// import React, { useState, useEffect } from 'react';
// import { useParams } from 'react-router-dom';
// import {
//   Box, Card, CardContent, Typography, Button, Grid, Chip,
//   Divider, LinearProgress, Paper, TextField, MenuItem,
//   CircularProgress,
// } from '@mui/material';
// import {
//   Download, Phone, ChevronRight, LocationOn, CheckCircle,
//   Construction, Security, Bolt, Groups, Pool, FitnessCenter,
//   SportsEsports, DirectionsRun, ChildCare, Park, SelfImprovement,
//   MeetingRoom, Theaters, Work, ElectricCar, LocalParking, Water,
//   Videocam, ChildFriendly, Spa, HotTub, SportsTennis,
//   SportsBasketball, SportsCricket, SportsSoccer, DirectionsBike,
//   LocalLibrary, LocalCafe, Event, Hotel, Texture, Kitchen, Bathtub,
//   FormatPaint, Home as HomeIcon, Map, Train, Flight, DirectionsBus,
//   School, LocalHospital, ShoppingCart, ApartmentOutlined, Description,
//   Gavel, AccountBalance, Star,
// } from '@mui/icons-material';

// import { HiOutlinePhoto } from "react-icons/hi2";
// import { CgPlayButtonO } from "react-icons/cg";
// import { TbRotate360 } from "react-icons/tb";

// /* ------------------------------------------------------------------
//    THEME (unchanged)
// ------------------------------------------------------------------ */
// const COLORS = {
//   primary: '#8B4A2B',
//   primaryDark: '#6B3620',
//   primaryLight: '#FBEEE0',
//   bg: '#FFFFFF',
//   cardBg: '#FFFFFF',
//   chipDark: '#3D2B1F',
//   green: '#2E7D32',
//   greenBg: '#E8F5E9',
//   blue: '#1565C0',
//   textSecondary: '#8A7A6D',
//   textDark: '#2B2118',
//   border: '#F0E6DA',
//   inputBg: '#FAF5EF',
// };

// /* ------------------------------------------------------------------
//    API CONFIG — fetch by id only, e.g.
//    https://landnest.net:81/ad-properties/combined/15/
// ------------------------------------------------------------------ */
// const API_ORIGIN = 'https://landnest.net:81';
// const AD_API_URL = `${API_ORIGIN}/ad-properties/combined/`;

// /* ------------------------------------------------------------------
//    ICON RESOLUTION HELPERS (unchanged)
// ------------------------------------------------------------------ */
// const ICON_KEYWORDS = [
//   { keys: ['security', 'cctv', 'guard', '24'], icon: Security },
//   { keys: ['power', 'backup', 'electrical', 'bolt'], icon: Bolt },
//   { keys: ['club', 'community'], icon: Groups },
//   { keys: ['swim', 'pool'], icon: Pool },
//   { keys: ['gym', 'fitness'], icon: FitnessCenter },
//   { keys: ['indoor', 'game', 'sports esports'], icon: SportsEsports },
//   { keys: ['jog', 'run', 'track'], icon: DirectionsRun },
//   { keys: ['child', 'kid', 'play'], icon: ChildCare },
//   { keys: ['senior', 'park', 'garden', 'landscape'], icon: Park },
//   { keys: ['yoga', 'meditation'], icon: SelfImprovement },
//   { keys: ['multipurpose', 'hall', 'banquet', 'party'], icon: MeetingRoom },
//   { keys: ['theatre', 'theater', 'cinema'], icon: Theaters },
//   { keys: ['co-work', 'cowork', 'office', 'business', 'lounge'], icon: Work },
//   { keys: ['ev', 'electric', 'charging'], icon: ElectricCar },
//   { keys: ['visitor', 'parking'], icon: LocalParking },
//   { keys: ['rain', 'water', 'harvest'], icon: Water },
//   { keys: ['cctv', 'camera', 'surveillance'], icon: Videocam },
//   { keys: ['kids pool', 'child pool'], icon: ChildFriendly },
//   { keys: ['spa'], icon: Spa },
//   { keys: ['sauna', 'hot tub', 'jacuzzi'], icon: HotTub },
//   { keys: ['badminton', 'tennis'], icon: SportsTennis },
//   { keys: ['basketball'], icon: SportsBasketball },
//   { keys: ['cricket', 'net'], icon: SportsCricket },
//   { keys: ['football', 'soccer', 'turf'], icon: SportsSoccer },
//   { keys: ['cycling', 'bike'], icon: DirectionsBike },
//   { keys: ['library', 'reading'], icon: LocalLibrary },
//   { keys: ['cafe', 'coffee'], icon: LocalCafe },
//   { keys: ['event', 'auditorium'], icon: Event },
//   { keys: ['hotel', 'guest', 'room'], icon: Hotel },
//   { keys: ['flooring', 'floor', 'texture'], icon: Texture },
//   { keys: ['kitchen', 'modular'], icon: Kitchen },
//   { keys: ['bathroom', 'bath', 'toilet'], icon: Bathtub },
//   { keys: ['painting', 'paint'], icon: FormatPaint },
//   { keys: ['smart', 'home', 'automation'], icon: HomeIcon },
//   { keys: ['door', 'window'], icon: MeetingRoom },
//   { keys: ['metro', 'train', 'railway'], icon: Train },
//   { keys: ['airport', 'flight'], icon: Flight },
//   { keys: ['bus', 'transit'], icon: DirectionsBus },
//   { keys: ['school', 'college', 'education'], icon: School },
//   { keys: ['hospital', 'clinic', 'medical'], icon: LocalHospital },
//   { keys: ['mall', 'shopping', 'market'], icon: ShoppingCart },
//   { keys: ['it park', 'tech', 'office park'], icon: ApartmentOutlined },
//   { keys: ['brochure', 'document', 'pdf'], icon: Description },
//   { keys: ['legal', 'rera', 'approval'], icon: Gavel },
//   { keys: ['bank', 'loan', 'finance'], icon: AccountBalance },
// ];

// const resolveIcon = (label = '') => {
//   const lower = String(label).toLowerCase();
//   for (const { keys, icon } of ICON_KEYWORDS) {
//     if (keys.some((k) => lower.includes(k))) return icon;
//   }
//   return CheckCircle;
// };

// /* ------------------------------------------------------------------
//    FORMATTERS
// ------------------------------------------------------------------ */
// const formatPrice = (price) => {
//   if (!price && price !== 0) return 'Price on Request';
//   if (price >= 10000000) return `₹${(price / 10000000).toFixed(price % 10000000 === 0 ? 0 : 2)}Cr`;
//   if (price >= 100000) return `₹${(price / 100000).toFixed(price % 100000 === 0 ? 0 : 1)}L`;
//   return `₹${Number(price).toLocaleString()}`;
// };

// // 4800000 -> "₹48 Lakhs"
// const formatPriceLong = (price) => {
//   if (price === undefined || price === null) return 'Price on Request';
//   if (price >= 10000000) return `₹${parseFloat((price / 10000000).toFixed(2))} Crores`;
//   if (price >= 100000) return `₹${parseFloat((price / 100000).toFixed(2))} Lakhs`;
//   return `₹${Number(price).toLocaleString()}`;
// };

// const formatDate = (d) =>
//   d ? new Date(d).toLocaleDateString('en-IN', { month: 'short', year: 'numeric' }) : '';

// // "1BHK" -> "1 BHK", "4+BHK" -> "4+ BHK"
// const prettyBhk = (raw) => {
//   if (!raw) return 'Unit';
//   return String(raw).replace(/(\d+\+?)\s*BHK/i, '$1 BHK').trim();
// };

// const BHK_SORT = (a, b) => {
//   const num = (s) => {
//     const m = String(s || '').match(/(\d+)/);
//     return m ? parseInt(m[1], 10) : 999;
//   };
//   return num(a) - num(b);
// };

// const isEmpty = (v) =>
//   v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0);

// const show = (v) => (isEmpty(v) ? '—' : String(v));

// const withUnit = (v, unit) => {
//   if (isEmpty(v)) return '';
//   return /^[\d.,]+$/.test(String(v).trim()) ? `${v} ${unit}` : String(v);
// };

// // Relative API paths ("/media/...") -> absolute URL against the API origin.
// const getImageUrl = (imagePath) => {
//   if (!imagePath) return '';
//   if (typeof imagePath !== 'string') return '';
//   if (imagePath.startsWith('http') || imagePath.startsWith('data:')) return imagePath;
//   return `${API_ORIGIN}${imagePath.startsWith('/') ? '' : '/'}${imagePath}`;
// };

// /* ------------------------------------------------------------------
//    API → VIEW-MODEL ADAPTER
//    Field names below match the confirmed working reference
//    (property_name, configurations[].bhk_type like "1BHK",
//    property_highlights, property_amenities, location_advantages,
//    brochures, hero_images, lat/long, etc). A couple of alternate
//    names are kept as a fallback in case a field is occasionally
//    named differently.
// ------------------------------------------------------------------ */
// const labelOf = (item) => {
//   if (item === undefined || item === null) return '';
//   if (typeof item !== 'object') return String(item);
//   return String(item.name || item.title || item.label || '');
// };

// const normalizeProject = (proj, i) => {
//   const name = proj.name || proj.property_name || 'Project';
//   const area = proj.area || proj.location || proj.city || '';
//   const bhk = proj.bhk || proj.bhk_type || '';
//   const priceRange =
//     proj.priceRange || proj.price_range ||
//     (proj.min_budget && proj.max_budget
//       ? `${formatPrice(proj.min_budget)} - ${formatPrice(proj.max_budget)}`
//       : '');
//   return {
//     id: proj.id ?? proj.property_id ?? i,
//     name,
//     area,
//     bhk,
//     priceRange,
//     rating: proj.rating,
//     rera: !!(proj.rera || proj.rera_number || proj.is_rera_approved),
//     image: getImageUrl(proj.image || proj.hero_image || (proj.hero_images && proj.hero_images[0]?.image) || ''),
//   };
// };

// const EMPTY_DATA = {
//   project: {},
//   configs: [],
//   highlights: [],
//   amenities: [],
//   specifications: [],
//   locationAdvantages: [],
//   legal: {},
//   brochures: [],
//   nearby: [],
//   similar: [],
//   media: { photos: 0, video: '', tour: '' },
// };

// const normalizeProperty = (property) => {
//   const p = property || {};

//   /* ---- configurations ---- */
//   const configs = (p.configurations || [])
//     .slice()
//     .sort((a, b) => BHK_SORT(a.bhk_type, b.bhk_type))
//     .map((c, i) => ({
//       id: c.id ?? i,
//       bhk_type: prettyBhk(c.bhk_type),
//       price: c.price,
//       carpet_area: c.carpet_area,
//       built_up_area: c.built_up_area,
//       super_built_up_area: c.super_built_up_area,
//       bathrooms: c.bathrooms,
//       facing: c.facing,
//       parking: c.parking,
//       balcony: c.balcony,
//       images: (c.floor_plan_images || []).map((im) => getImageUrl(im.image)).filter(Boolean),
//       brochure: getImageUrl((c.floor_plan_images || [])[0]?.image || ''),
//     }));

//   /* ---- highlights / amenities ---- */
//   const highlights = (p.property_highlights || []).map(labelOf).filter(Boolean);
//   const amenities = (p.property_amenities || []).map(labelOf).filter(Boolean);

//   /* ---- specifications ---- */
//   const specifications = (p.specifications || [])
//     .map((s) => ({ name: s.name || '', value: s.value || '' }))
//     .filter((s) => s.name);

//   /* ---- location advantages ---- */
//   const locationAdvantages = (p.location_advantages || [])
//     .map((l) => ({
//       place_name: l.place_name || '',
//       distance: withUnit(l.distance, 'km'),
//       travel_time: withUnit(l.travel_time, 'min'),
//     }))
//     .filter((l) => l.place_name);

//   /* ---- legal / brochures ---- */
//   const brochures = (p.brochures || []).map((doc, i) => ({
//     id: doc.id ?? i,
//     title: doc.title || 'Document',
//     url: getImageUrl(doc.document),
//     uploadedAt: doc.uploaded_at ? formatDate(doc.uploaded_at) : '',
//   }));

//   const legal = {
//     bankApproved: p.bank_approved || '',
//     approvalStatus: p.approval_status || (p.status ? 'Approved' : ''),
//     governmentApprovals: p.government_approvals || '',
//     legalClearances: p.legal_clearances || (brochures.length > 0 ? 'All Clear' : ''),
//   };

//   /* ---- price range ---- */
//   const cfgPrices = configs.map((c) => c.price).filter((n) => n !== undefined && n !== null);
//   const priceRange =
//     p.min_budget && p.max_budget
//       ? p.min_budget === p.max_budget
//         ? formatPrice(p.min_budget)
//         : `${formatPrice(p.min_budget)} - ${formatPrice(p.max_budget)}`
//       : cfgPrices.length
//         ? (Math.min(...cfgPrices) === Math.max(...cfgPrices)
//             ? formatPrice(Math.min(...cfgPrices))
//             : `${formatPrice(Math.min(...cfgPrices))} - ${formatPrice(Math.max(...cfgPrices))}`)
//         : '';

//   const heroImages = p.hero_images || [];

//   const project = {
//     builder: p.builder_details?.builder_name || '',
//     name: p.property_name || '',
//     location: [p.address, p.city].filter(Boolean).join(', '),
//     lat: p.lat,
//     lng: p.long,
//     priceRange,
//     bhkTypes: configs.map((c) => c.bhk_type).join(', '),
//     status: p.status ? 'Active' : '',
//     possession: formatDate(p.possession_date),
//     // These aren't in the confirmed API payload yet; shown only if present.
//     towers: p.towers || p.total_towers || '',
//     floors: p.floors || p.total_floors || '',
//     units: p.units || p.total_units || '',
//     totalArea: withUnit(p.total_area || p.project_area, 'Acres'),
//     constructionProgress: Number(p.construction_progress) || 0,
//     rera: p.rera_number ? 'RERA APPROVED' : '',
//     verified: !!p.status,
//     propertyType: p.property_type || '',
//     category: p.category_name || '',
//     description: p.description || '',
//     phone: p.user_mobile_no || '',
//     cover: getImageUrl(heroImages[0]?.image || ''),
//   };

//   return {
//     project,
//     configs,
//     highlights,
//     amenities,
//     specifications,
//     locationAdvantages,
//     legal,
//     brochures,
//     nearby: (p.nearby_projects || p.nearbyProjects || p.nearby || []).map(normalizeProject),
//     similar: (p.similar_projects || p.similarProjects || []).map(normalizeProject),
//     media: {
//       photos: heroImages.length,
//       video: getImageUrl(p.video || p.video_url || ''),
//       tour: getImageUrl(p.virtual_tour || p.virtual_tour_url || ''),
//     },
//   };
// };

// /* ------------------------------------------------------------------
//    Reusable icon-grid block for Highlights / Amenities
// ------------------------------------------------------------------ */
// const IconGrid = ({ items, emptyText }) => {
//   if (!items || items.length === 0) {
//     return (
//       <Typography variant="body2" sx={{ color: COLORS.textSecondary, textAlign: 'center', py: 3 }}>
//         {emptyText || 'Not available'}
//       </Typography>
//     );
//   }
//   return (
//     <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px' }}>
//       {items.map((item) => {
//         const IconComp = resolveIcon(item);
//         return (
//           <Box
//             key={item}
//             sx={{
//               display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center',
//               gap: 0.5, p: 1, borderRadius: '10px', border: `1px solid ${COLORS.border}`,
//               backgroundColor: COLORS.cardBg, minHeight: '90px', justifyContent: 'center', overflow: 'hidden',
//             }}
//           >
//             <IconComp sx={{ fontSize: 24, color: COLORS.primary }} />
//             <Typography sx={{ fontSize: '10.5px', fontWeight: 600, color: COLORS.textDark, lineHeight: 1.2, wordBreak: 'break-word' }}>
//               {item}
//             </Typography>
//           </Box>
//         );
//       })}
//     </Box>
//   );
// };

// /* Reusable "heading + View All" row */
// const SectionHeaderWithViewAll = ({ title, onViewAll, expanded }) => (
//   <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//     <Typography variant="subtitle1" fontWeight="bold" sx={{ color: COLORS.textDark }}>{title}</Typography>
//     {onViewAll && (
//       <Typography
//         variant="body2"
//         onClick={onViewAll}
//         sx={{ color: COLORS.blue, fontWeight: 600, cursor: 'pointer' }}
//       >
//         {expanded ? 'Show Less' : 'View All'}
//       </Typography>
//     )}
//   </Box>
// );

// /* Image block for nearby/similar project cards (placeholder when no image) */
// const NearbyImagePlaceholder = ({ image }) =>
//   image ? (
//     <Box component="img" src={image} alt="" sx={{ width: '100%', height: 90, objectFit: 'cover', display: 'block' }} />
//   ) : (
//     <Box sx={{ width: '100%', height: 90, bgcolor: '#F5F5F5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//       <Construction sx={{ fontSize: 28, color: '#D4A373' }} />
//     </Box>
//   );

// const ProjectCard = ({ proj }) => (
//   <Card sx={{ borderRadius: 3, border: `1px solid ${COLORS.border}`, boxShadow: 'none', overflow: 'hidden' }}>
//     <NearbyImagePlaceholder image={proj.image} />
//     <CardContent sx={{ p: 1.25, '&:last-child': { pb: 1.25 } }}>
//       <Typography variant="body2" fontWeight="bold" sx={{ color: COLORS.textDark }} noWrap>{proj.name}</Typography>
//       <Typography variant="caption" sx={{ color: COLORS.textSecondary, display: 'block' }} noWrap>
//         {[proj.area, proj.bhk].filter(Boolean).join(' • ')}
//       </Typography>
//       <Typography variant="body2" fontWeight="bold" sx={{ color: COLORS.blue, mt: 0.5 }}>{proj.priceRange}</Typography>
//       <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 0.5 }}>
//         {proj.rera ? (
//           <Chip label="RERA" size="small" sx={{ bgcolor: COLORS.chipDark, color: 'white', fontSize: '0.65rem', height: 20 }} />
//         ) : <span />}
//         {!isEmpty(proj.rating) && (
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
//             <Star sx={{ fontSize: 14, color: '#F5A623' }} />
//             <Typography variant="caption" fontWeight="bold">{proj.rating}</Typography>
//           </Box>
//         )}
//       </Box>
//     </CardContent>
//   </Card>
// );

// const EmptyText = ({ children }) => (
//   <Typography variant="body2" sx={{ color: COLORS.textSecondary, textAlign: 'center', py: 3 }}>
//     {children}
//   </Typography>
// );

// /* ================================================================== */
// /**
//  * Mounted at <Route path="/new-launching-properties/:id" element={<BHKDescription />} />
//  * — reads the id from the route and fetches that single property only.
//  */
// const BHKDescription = () => {
//   const { id } = useParams();

//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [reloadKey, setReloadKey] = useState(0);

//   const [activeTab, setActiveTab] = useState(0);
//   const [showAllHighlights, setShowAllHighlights] = useState(false);
//   const [showAllAmenities, setShowAllAmenities] = useState(false);
//   const [showAllNearby, setShowAllNearby] = useState(false);
//   const [showAllSimilar, setShowAllSimilar] = useState(false);
//   const [contactForm, setContactForm] = useState({
//     name: '', phone: '', email: '', preferredTime: 'Morning (9-12)', message: '',
//   });

//   /* ---------------- Fetch by id only ---------------- */
//   useEffect(() => {
//     if (!id) {
//       setError('No property id in the URL');
//       setLoading(false);
//       return;
//     }

//     const controller = new AbortController();

//     (async () => {
//       try {
//         setLoading(true);
//         setError(null);
//         const res = await fetch(`${AD_API_URL}${id}/`, {
//           signal: controller.signal,
//           headers: { Accept: 'application/json' },
//         });
//         if (!res.ok) throw new Error(`Request failed (${res.status})`);
//         const json = await res.json();
//         // Handy while wiring up field names — remove once happy.
//         console.log('[BHKDescription] raw API response:', json);

//         // response.data?.data (single object) is what the reference
//         // detail endpoint returns; fall back to response.data itself,
//         // and to the first item if the API ever returns a list here.
//         let property = json?.data ?? json;
//         if (Array.isArray(property)) {
//           property = property.find((it) => String(it.property_id) === String(id)) || property[0];
//         }

//         setData(normalizeProperty(property));
//         setActiveTab(0);
//       } catch (e) {
//         if (e.name !== 'AbortError') setError(e.message || 'Something went wrong');
//       } finally {
//         if (!controller.signal.aborted) setLoading(false);
//       }
//     })();

//     return () => controller.abort();
//   }, [id, reloadKey]);

//   /* ---------------- Loading / error states ---------------- */
//   if (loading) {
//     return (
//       <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: COLORS.bg }}>
//         <CircularProgress sx={{ color: COLORS.primary }} />
//       </Box>
//     );
//   }

//   if (error) {
//     return (
//       <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2, px: 3, textAlign: 'center', backgroundColor: COLORS.bg }}>
//         <Typography sx={{ color: COLORS.textDark, fontWeight: 700 }}>Couldn't load this property</Typography>
//         <Typography variant="body2" sx={{ color: COLORS.textSecondary }}>{error}</Typography>
//         <Button
//           variant="contained"
//           onClick={() => setReloadKey((k) => k + 1)}
//           sx={{ borderRadius: 2, bgcolor: COLORS.primary, textTransform: 'none', fontWeight: 700, '&:hover': { bgcolor: COLORS.primaryDark } }}
//         >
//           Try again
//         </Button>
//       </Box>
//     );
//   }

//   /* ---------------- Derived data ---------------- */
//   const d = data || EMPTY_DATA;
//   const { project, configs, media, legal, brochures } = d;
//   const activeConfig = configs[activeTab] || null;

//   const openUrl = (url) => {
//     if (url) window.open(url, '_blank', 'noopener');
//   };

//   const openGoogleMaps = () => {
//     const query =
//       project.lat !== undefined && project.lng !== undefined
//         ? `${project.lat},${project.lng}`
//         : project.location;
//     window.open(`https://www.google.com/maps?q=${encodeURIComponent(query)}`, '_blank');
//   };

//   const handleDownloadBrochure = () => openUrl(brochures[0]?.url);

//   const handleContactSubmit = () => {
//     // TODO: post to your lead/enquiry endpoint
//     console.log('Contact form submitted:', { propertyId: id, ...contactForm });
//   };

//   const visibleHighlights = showAllHighlights ? d.highlights : d.highlights.slice(0, 8);
//   const visibleAmenities = showAllAmenities ? d.amenities : d.amenities.slice(0, 8);
//   const visibleNearby = showAllNearby ? d.nearby : d.nearby.slice(0, 2);
//   const visibleSimilar = showAllSimilar ? d.similar : d.similar.slice(0, 2);

//   return (
//     <Box sx={{ backgroundColor: COLORS.bg, minHeight: '100vh', pb: 10, fontFamily: 'sans-serif', overflowY: 'auto' }}>

//       {/* --- Top Action Chips --- */}
//       <Box sx={{ display: 'flex', gap: 1.5, p: 2, pt: 3, overflowX: 'auto', '&::-webkit-scrollbar': { display: 'none' } }}>
//         {[
//           { label: media.photos ? `${media.photos} Photos` : 'Photos', icon: <HiOutlinePhoto size={16} />, url: '' },
//           { label: 'Video', icon: <CgPlayButtonO size={16} />, url: media.video },
//           { label: 'Virtual Tour', icon: <TbRotate360 size={16} />, url: media.tour },
//         ].map((item, i) => (
//           <Chip
//             key={i}
//             icon={item.icon}
//             label={item.label}
//             onClick={item.url ? () => openUrl(item.url) : undefined}
//             sx={{
//               bgcolor: COLORS.primaryDark,
//               color: 'white',
//               fontWeight: 600,
//               fontSize: '12px',
//               borderRadius: 10,
//               px: 1,
//               '& .MuiChip-icon': { color: 'white' },
//             }}
//           />
//         ))}
//       </Box>

//       {/* --- Property Header Card --- */}
//       <Box sx={{ px: 2 }}>
//         <Card sx={{ borderRadius: 3, p: 2, boxShadow: '0 4px 20px rgba(139,74,43,0.08)', border: `1px solid ${COLORS.border}` }}>
//           <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
//             <Box sx={{ width: 80, height: 80, bgcolor: '#F5F5F5', borderRadius: 2, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, overflow: 'hidden' }}>
//               {project.cover ? (
//                 <Box component="img" src={project.cover} alt={project.name} sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
//               ) : (
//                 <Construction sx={{ fontSize: 40, color: '#D4A373' }} />
//               )}
//             </Box>
//             <Box sx={{ flex: 1 }}>
//               <Typography sx={{ fontSize: '12px', color: COLORS.primary, fontWeight: 700, mb: 0.5 }}>
//                 {[project.builder, project.category].filter(Boolean).join(' • ')}
//               </Typography>
//               <Typography sx={{ fontSize: '18px', fontWeight: 800, color: COLORS.textDark, mb: 0.5, lineHeight: 1.2 }}>
//                 {project.name}
//               </Typography>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1 }}>
//                 <LocationOn sx={{ fontSize: 14, color: COLORS.textSecondary }} />
//                 <Typography sx={{ fontSize: '12px', color: COLORS.textSecondary }}>
//                   {project.location}
//                 </Typography>
//               </Box>
//               <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
//                 {project.rera && (
//                   <Chip label={project.rera} size="small" sx={{ bgcolor: COLORS.primaryDark, color: 'white', fontSize: '10px', fontWeight: 700, height: 22, borderRadius: 10 }} />
//                 )}
//                 {project.verified && (
//                   <Chip icon={<CheckCircle sx={{ fontSize: 12 }} />} label="Verified" size="small" sx={{ bgcolor: COLORS.greenBg, color: COLORS.green, fontSize: '10px', fontWeight: 700, height: 22, borderRadius: 10, '& .MuiChip-icon': { color: COLORS.green } }} />
//                 )}
//               </Box>
//             </Box>
//           </Box>

//           <Divider sx={{ my: 2, borderColor: COLORS.border, borderStyle: 'dashed' }} />

//           <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
//             <Box>
//               <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary, mb: 0.5 }}>Possession</Typography>
//               <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.textDark }}>{show(project.possession)}</Typography>
//             </Box>
//             <Box sx={{ textAlign: 'right' }}>
//               <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary, mb: 0.5 }}>Type</Typography>
//               <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.textDark }}>{show(project.propertyType)}</Typography>
//             </Box>
//           </Box>
//         </Card>
//       </Box>

//       {/* --- Price & BHK Summary --- */}
//       <Box sx={{ px: 2, mt: 2 }}>
//         <Typography sx={{ fontSize: '28px', fontWeight: 800, color: COLORS.textDark, letterSpacing: '-0.5px' }}>
//           {project.priceRange || 'Price on Request'}
//         </Typography>
//         <Typography sx={{ fontSize: '12px', color: COLORS.textSecondary, letterSpacing: '1px', fontWeight: 600, mt: 0.5 }}>
//           PRICE RANGE
//         </Typography>
//         {project.bhkTypes && (
//           <Typography sx={{ fontSize: '20px', fontWeight: 700, color: COLORS.textDark, mt: 1 }}>
//             {project.bhkTypes}
//           </Typography>
//         )}
//         {project.description && (
//           <Typography sx={{ fontSize: '13px', color: COLORS.textSecondary, mt: 1 }}>
//             {project.description}
//           </Typography>
//         )}
//       </Box>

//       {/* --- Project Stats & Progress --- */}
//       <Box sx={{ px: 2, mt: 2 }}>
//         <Card
//           sx={{
//             borderRadius: 3,
//             p: 2,
//             boxShadow: 'none',
//             border: `1px solid ${COLORS.border}`,
//             bgcolor: '#FAFAFA',
//           }}
//         >
//           <Box
//             sx={{
//               display: 'grid',
//               gridTemplateColumns: '1fr 1fr',
//               rowGap: 2,
//               columnGap: 2,
//             }}
//           >
//             {/* STATUS */}
//             <Box>
//               <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary, mb: 0.5 }}>
//                 STATUS
//               </Typography>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                 <Construction sx={{ fontSize: 16, color: COLORS.primary }} />
//                 <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.primary }}>
//                   {show(project.status)}
//                 </Typography>
//               </Box>
//             </Box>

//             {/* POSSESSION */}
//             <Box>
//               <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary, mb: 0.5 }}>
//                 POSSESSION
//               </Typography>
//               <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.textDark }}>
//                 {show(project.possession)}
//               </Typography>
//             </Box>

//             {/* TOWERS */}
//             <Box>
//               <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary, mb: 0.5 }}>
//                 TOWERS
//               </Typography>
//               <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.textDark }}>
//                 {show(project.towers)}
//               </Typography>
//             </Box>

//             {/* FLOORS */}
//             <Box>
//               <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary, mb: 0.5 }}>
//                 FLOORS
//               </Typography>
//               <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.textDark }}>
//                 {show(project.floors)}
//               </Typography>
//             </Box>

//             {/* UNITS */}
//             <Box>
//               <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary, mb: 0.5 }}>
//                 UNITS
//               </Typography>
//               <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.textDark }}>
//                 {show(project.units)}
//               </Typography>
//             </Box>

//             {/* TOTAL AREA */}
//             <Box>
//               <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary, mb: 0.5 }}>
//                 TOTAL AREA
//               </Typography>
//               <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.textDark }}>
//                 {show(project.totalArea)}
//               </Typography>
//             </Box>
//           </Box>

//           {/* Construction Progress */}
//           <Box sx={{ mt: 2.5 }}>
//             <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
//               <Typography sx={{ fontSize: '12px', fontWeight: 600, color: COLORS.textDark }}>
//                 Construction Progress
//               </Typography>
//               <Typography sx={{ fontSize: '12px', fontWeight: 700, color: COLORS.textDark }}>
//                 {project.constructionProgress}%
//               </Typography>
//             </Box>
//             <LinearProgress
//               variant="determinate"
//               value={project.constructionProgress}
//               sx={{
//                 height: 8,
//                 borderRadius: 4,
//                 bgcolor: '#E0E0E0',
//                 '& .MuiLinearProgress-bar': {
//                   bgcolor: COLORS.primaryDark,
//                   borderRadius: 4,
//                 },
//               }}
//             />
//           </Box>
//         </Card>
//       </Box>

//       {/* --- BHK Tabs (equal width, non-scrollable) --- */}
//       {configs.length > 0 && (
//         <Box sx={{ mt: 3, px: 2, bgcolor: 'white' }}>
//           <Box sx={{ display: 'flex', gap: 1 }}>
//             {configs.map((cfg, idx) => {
//               const isActive = activeTab === idx;
//               return (
//                 <Box
//                   key={cfg.id}
//                   onClick={() => setActiveTab(idx)}
//                   sx={{
//                     flex: 1,
//                     textAlign: 'center',
//                     py: 1,
//                     borderRadius: 2,
//                     border: `1px solid ${isActive ? COLORS.primaryDark : COLORS.border}`,
//                     bgcolor: isActive ? COLORS.primaryDark : 'white',
//                     color: isActive ? 'white' : COLORS.textDark,
//                     fontWeight: 700,
//                     fontSize: '12.5px',
//                     cursor: 'pointer',
//                     userSelect: 'none',
//                     whiteSpace: 'nowrap',
//                     transition: 'all 0.15s ease',
//                   }}
//                 >
//                   {cfg.bhk_type}
//                 </Box>
//               );
//             })}
//           </Box>
//         </Box>
//       )}

//       {/* --- Floor Plans & Pricing Content --- */}
//       <Box sx={{ p: 2 }}>
//         <Typography sx={{ fontSize: '20px', fontWeight: 800, color: COLORS.textDark, mb: 2 }}>
//           Floor Plans & Pricing
//         </Typography>

//         {!activeConfig && <EmptyText>No configurations available for this property</EmptyText>}

//         {activeConfig && (
//           <Card sx={{ mb: 2, borderRadius: 3, border: `1px solid ${COLORS.border}`, boxShadow: '0 2px 10px rgba(139,74,43,0.06)' }}>
//             <CardContent sx={{ p: 2 }}>
//               {/* Header: BHK + Starting chip */}
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//                 <Typography sx={{ fontSize: '18px', fontWeight: 800, color: COLORS.textDark }}>
//                   {activeConfig.bhk_type}
//                 </Typography>
//                 <Box
//                   sx={{
//                     bgcolor: COLORS.primaryLight,
//                     color: COLORS.primary,
//                     fontWeight: 700,
//                     fontSize: '11px',
//                     px: 1.25,
//                     py: 0.5,
//                     borderRadius: 1.5,
//                   }}
//                 >
//                   {activeConfig.price !== undefined ? `Starting at ${formatPrice(activeConfig.price)}` : 'Price on Request'}
//                 </Box>
//               </Box>

//               {/* Specs grid — label left, value right aligned to grid columns */}
//               <Box
//                 sx={{
//                   display: 'grid',
//                   gridTemplateColumns: '1fr 1fr',
//                   rowGap: 1.75,
//                   columnGap: 2,
//                 }}
//               >
//                 {[
//                   { label: 'Carpet Area',     value: show(withUnit(activeConfig.carpet_area, 'sqft')) },
//                   { label: 'Built-up Area',   value: show(withUnit(activeConfig.built_up_area, 'sqft')) },
//                   { label: 'Super Built-up',  value: show(withUnit(activeConfig.super_built_up_area, 'sqft')) },
//                   { label: 'Price',           value: formatPriceLong(activeConfig.price) },
//                   { label: 'Bathrooms',       value: show(activeConfig.bathrooms) },
//                   { label: 'Facing',          value: show(activeConfig.facing) },
//                   { label: 'Parking',         value: show(activeConfig.parking) },
//                   { label: 'Balcony',         value: show(activeConfig.balcony) },
//                 ].map((item) => (
//                   <Box
//                     key={item.label}
//                     sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
//                   >
//                     <Typography sx={{ fontSize: '12px', color: COLORS.textSecondary }}>
//                       {item.label}
//                     </Typography>
//                     <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.textDark }}>
//                       {item.value}
//                     </Typography>
//                   </Box>
//                 ))}
//               </Box>

//               {/* --- Horizontal scrollable floor plan images --- */}
//               <Box
//                 sx={{
//                   display: 'flex',
//                   gap: 1.5,
//                   overflowX: 'auto',
//                   mt: 2.5,
//                   pb: 0.5,
//                   scrollSnapType: 'x mandatory',
//                   '&::-webkit-scrollbar': { height: 4 },
//                   '&::-webkit-scrollbar-thumb': { bgcolor: COLORS.border, borderRadius: 2 },
//                 }}
//               >
//                 {(activeConfig.images.length > 0 ? activeConfig.images : [null, null]).map((src, n) => (
//                   <Box
//                     key={n}
//                     sx={{
//                       flex: '0 0 calc(50% - 6px)',
//                       minWidth: 'calc(50% - 6px)',
//                       height: 150,
//                       borderRadius: 2,
//                       overflow: 'hidden',
//                       border: `1px solid ${COLORS.border}`,
//                       bgcolor: '#F5F5F5',
//                       scrollSnapAlign: 'start',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                     }}
//                   >
//                     {src ? (
//                       <Box
//                         component="img"
//                         src={src}
//                         alt={`${activeConfig.bhk_type} floor plan ${n + 1}`}
//                         onClick={() => openUrl(src)}
//                         sx={{ width: '100%', height: '100%', objectFit: 'contain', cursor: 'pointer' }}
//                       />
//                     ) : (
//                       <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75, width: '80%', height: '80%' }}>
//                         <Box sx={{ display: 'flex', gap: 0.75, height: '40%' }}>
//                           <Box sx={{ flex: 1, border: '1px solid #CCC', bgcolor: '#EAEAEA' }} />
//                           <Box sx={{ flex: 2, border: '1px solid #CCC', bgcolor: '#EAEAEA' }} />
//                         </Box>
//                         <Box sx={{ display: 'flex', gap: 0.75, height: '60%' }}>
//                           <Box sx={{ flex: 2, border: '1px solid #CCC', bgcolor: '#EAEAEA' }} />
//                           <Box sx={{ flex: 1, border: '1px solid #CCC', bgcolor: '#EAEAEA' }} />
//                         </Box>
//                       </Box>
//                     )}
//                   </Box>
//                 ))}
//               </Box>

//               {/* Action buttons */}
//               <Box sx={{ display: 'flex', gap: 1.5, mt: 2 }}>
//                 <Button
//                   variant="outlined"
//                   size="small"
//                   startIcon={<Download sx={{ fontSize: 16 }} />}
//                   onClick={() => openUrl(activeConfig.brochure || brochures[0]?.url)}
//                   disabled={!activeConfig.brochure && !brochures[0]?.url}
//                   sx={{
//                     flex: 1,
//                     borderRadius: 2,
//                     color: COLORS.primaryDark,
//                     borderColor: COLORS.border,
//                     fontWeight: 700,
//                     fontSize: '12px',
//                     textTransform: 'none',
//                     '&:hover': { borderColor: COLORS.primaryDark, bgcolor: COLORS.primaryLight },
//                   }}
//                 >
//                   Download
//                 </Button>
//                 <Button
//                   variant="contained"
//                   size="small"
//                   startIcon={<Phone sx={{ fontSize: 16 }} />}
//                   onClick={() => document.getElementById('bhk-request-callback')?.scrollIntoView({ behavior: 'smooth', block: 'center' })}
//                   sx={{
//                     flex: 1,
//                     borderRadius: 2,
//                     bgcolor: COLORS.primaryDark,
//                     color: 'white',
//                     fontWeight: 700,
//                     fontSize: '12px',
//                     textTransform: 'none',
//                     '&:hover': { bgcolor: COLORS.primary },
//                   }}
//                 >
//                   Request Callback
//                 </Button>
//               </Box>
//             </CardContent>
//           </Card>
//         )}

//         {/* Other configurations (click to switch the card above) */}
//         {configs.map((config, idx) =>
//           idx === activeTab ? null : (
//             <Paper
//               key={config.id}
//               onClick={() => setActiveTab(idx)}
//               sx={{
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 alignItems: 'center',
//                 p: 2,
//                 mb: 1.5,
//                 borderRadius: 3,
//                 cursor: 'pointer',
//                 border: `1px solid ${COLORS.border}`,
//                 boxShadow: 'none',
//                 bgcolor: 'white',
//                 '&:hover': { bgcolor: '#FAFAFA' },
//               }}
//             >
//               <Typography sx={{ fontSize: '15px', fontWeight: 700, color: COLORS.textDark }}>
//                 {config.bhk_type}
//               </Typography>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 600, color: COLORS.primary }}>
//                   {config.price !== undefined ? `Starting at ${formatPrice(config.price)}` : 'Price on Request'}
//                 </Typography>
//                 <ChevronRight sx={{ color: COLORS.textSecondary, fontSize: 20 }} />
//               </Box>
//             </Paper>
//           )
//         )}
//       </Box>

//       {/* ================================================================
//           Highlights → Request Callback, stacked vertically
//       ================================================================= */}

//       <Box sx={{ px: 2 }}>
//         <Divider sx={{ borderColor: COLORS.border, mb: 3 }} />
//       </Box>

//       {/* --- HIGHLIGHTS --- */}
//       <Box sx={{ px: 2, mb: 3 }}>
//         <Card sx={{ borderRadius: 3, boxShadow: '0 2px 10px rgba(139,74,43,0.06)', border: `1px solid ${COLORS.border}` }}>
//           <CardContent sx={{ p: 2 }}>
//             <SectionHeaderWithViewAll
//               title="Property Highlights"
//               onViewAll={d.highlights.length > 8 ? () => setShowAllHighlights(!showAllHighlights) : null}
//               expanded={showAllHighlights}
//             />
//             <IconGrid items={visibleHighlights} emptyText="No highlights available for this property" />
//           </CardContent>
//         </Card>
//       </Box>

//       {/* --- AMENITIES --- */}
//       <Box sx={{ px: 2, mb: 3 }}>
//         <Card sx={{ borderRadius: 3, boxShadow: '0 2px 10px rgba(139,74,43,0.06)', border: `1px solid ${COLORS.border}` }}>
//           <CardContent sx={{ p: 2 }}>
//             <SectionHeaderWithViewAll
//               title="Amenities"
//               onViewAll={d.amenities.length > 8 ? () => setShowAllAmenities(!showAllAmenities) : null}
//               expanded={showAllAmenities}
//             />
//             <IconGrid items={visibleAmenities} emptyText="No amenities listed for this property" />
//           </CardContent>
//         </Card>
//       </Box>

//       {/* --- SPECIFICATIONS --- */}
//       <Box sx={{ px: 2, mb: 3 }}>
//         <Card sx={{ borderRadius: 3, border: `1px solid ${COLORS.border}`, boxShadow: '0 2px 10px rgba(139,74,43,0.06)' }}>
//           <CardContent sx={{ p: 2 }}>
//             <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1, color: COLORS.textDark }}>
//               Specifications
//             </Typography>
//             {d.specifications.length === 0 && <EmptyText>No specifications listed for this property</EmptyText>}
//             {d.specifications.map((spec, idx, arr) => {
//               const IconComp = resolveIcon(spec.name);
//               return (
//                 <Box
//                   key={`${spec.name}-${idx}`}
//                   sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1.5, borderBottom: idx < arr.length - 1 ? `1px solid ${COLORS.border}` : 'none' }}
//                 >
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//                     <IconComp sx={{ fontSize: 20, color: COLORS.primary }} />
//                     <Box>
//                       <Typography variant="body2" fontWeight={600} sx={{ color: COLORS.textDark }}>{spec.name}</Typography>
//                       <Typography variant="caption" sx={{ color: COLORS.textSecondary }}>{spec.value}</Typography>
//                     </Box>
//                   </Box>
//                 </Box>
//               );
//             })}
//           </CardContent>
//         </Card>
//       </Box>

//       {/* --- LOCATION --- */}
//       <Box sx={{ px: 2, mb: 3 }}>
//         <Card sx={{ borderRadius: 3, border: `1px solid ${COLORS.border}`, boxShadow: '0 2px 10px rgba(139,74,43,0.06)' }}>
//           <CardContent sx={{ p: 2 }}>
//             <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1, color: COLORS.textDark }}>
//               Location Advantages
//             </Typography>

//             {d.locationAdvantages.length === 0 && <EmptyText>No location details available</EmptyText>}
//             {d.locationAdvantages.map((item, index, arr) => {
//               const IconComp = resolveIcon(item.place_name);
//               return (
//                 <Box
//                   key={`${item.place_name}-${index}`}
//                   sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1.5, borderBottom: index < arr.length - 1 ? `1px solid ${COLORS.border}` : 'none' }}
//                 >
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//                     <IconComp sx={{ fontSize: 20, color: COLORS.primary }} />
//                     <Box>
//                       <Typography fontWeight="bold" sx={{ color: COLORS.textDark }}>{item.place_name}</Typography>
//                       <Typography variant="body2" sx={{ color: COLORS.textSecondary }}>{item.distance}</Typography>
//                     </Box>
//                   </Box>
//                   <Typography sx={{ color: COLORS.blue, fontWeight: 600 }}>{item.travel_time}</Typography>
//                 </Box>
//               );
//             })}

//             <Box sx={{ mt: 2 }}>
//               <Button
//                 variant="outlined" fullWidth startIcon={<Map />}
//                 onClick={openGoogleMaps}
//                 disabled={!project.location && (project.lat === undefined || project.lng === undefined)}
//                 sx={{ borderRadius: 6, color: COLORS.primary, borderColor: COLORS.primary, fontWeight: 700, py: 1, '&:hover': { borderColor: COLORS.primaryDark, bgcolor: COLORS.primaryLight } }}
//               >
//                 View on Google Maps
//               </Button>
//             </Box>
//           </CardContent>
//         </Card>
//       </Box>

//       {/* --- LEGAL INFORMATION --- */}
//       <Box sx={{ px: 2, mb: 3 }}>
//         <Card sx={{ borderRadius: 3, border: `1px solid ${COLORS.border}`, boxShadow: '0 2px 10px rgba(139,74,43,0.06)' }}>
//           <CardContent sx={{ p: 2 }}>
//             <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2, color: COLORS.textDark }}>
//               Legal Information
//             </Typography>

//             <Grid container spacing={2} sx={{ mb: 1 }}>
//               <Grid item xs={6}>
//                 <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary, mb: 0.5 }}>Bank Approved</Typography>
//                 <Typography sx={{ fontSize: '14px', fontWeight: 700, color: COLORS.textDark }}>{show(legal.bankApproved)}</Typography>
//               </Grid>
//               <Grid item xs={6}>
//                 <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary, mb: 0.5 }}>Approval Status</Typography>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                   {legal.approvalStatus && <CheckCircle sx={{ fontSize: 16, color: COLORS.green }} />}
//                   <Typography sx={{ fontSize: '14px', fontWeight: 700, color: legal.approvalStatus ? COLORS.green : COLORS.textDark }}>{show(legal.approvalStatus)}</Typography>
//                 </Box>
//               </Grid>
//             </Grid>

//             <Grid container spacing={2} sx={{ mb: 2.5 }}>
//               <Grid item xs={6}>
//                 <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary, mb: 0.5 }}>Government Approvals</Typography>
//                 <Typography sx={{ fontSize: '14px', fontWeight: 700, color: COLORS.textDark }}>{show(legal.governmentApprovals)}</Typography>
//               </Grid>
//               <Grid item xs={6}>
//                 <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary, mb: 0.5 }}>Legal Clearances</Typography>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                   {legal.legalClearances && <CheckCircle sx={{ fontSize: 16, color: COLORS.green }} />}
//                   <Typography sx={{ fontSize: '14px', fontWeight: 700, color: legal.legalClearances ? COLORS.green : COLORS.textDark }}>{show(legal.legalClearances)}</Typography>
//                 </Box>
//               </Grid>
//             </Grid>

//             {/* Uploaded legal documents, when the API provides them */}
//             {brochures.length > 0 && (
//               <Box sx={{ mb: 2 }}>
//                 {brochures.map((doc, idx) => (
//                   <Box
//                     key={doc.id}
//                     onClick={() => openUrl(doc.url)}
//                     sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1.25, borderBottom: idx < brochures.length - 1 ? `1px solid ${COLORS.border}` : 'none', cursor: 'pointer' }}
//                   >
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//                       <Description sx={{ fontSize: 18, color: COLORS.primary }} />
//                       <Box>
//                         <Typography variant="body2" fontWeight={600} sx={{ color: COLORS.textDark }}>{doc.title}</Typography>
//                         {doc.uploadedAt && (
//                           <Typography variant="caption" sx={{ color: COLORS.textSecondary }}>{doc.uploadedAt}</Typography>
//                         )}
//                       </Box>
//                     </Box>
//                     <Download sx={{ color: COLORS.primary, fontSize: 18 }} />
//                   </Box>
//                 ))}
//               </Box>
//             )}

//             <Button
//               variant="contained" fullWidth startIcon={<Download />}
//               onClick={handleDownloadBrochure}
//               disabled={brochures.length === 0}
//               sx={{ borderRadius: 2, bgcolor: COLORS.primary, py: 1.1, fontWeight: 700, textTransform: 'none', '&:hover': { bgcolor: COLORS.primaryDark } }}
//             >
//               Brochure Download
//             </Button>
//           </CardContent>
//         </Card>
//       </Box>

//       {/* --- REQUEST CALLBACK --- */}
//       <Box id="bhk-request-callback" sx={{ px: 2, mb: 3 }}>
//         <Card sx={{ borderRadius: 3, border: `1px solid ${COLORS.border}`, boxShadow: '0 2px 10px rgba(139,74,43,0.06)' }}>
//           <CardContent sx={{ p: 2 }}>
//             <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2, color: COLORS.textDark }}>
//               Request Callback
//             </Typography>

//             <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
//               <Box>
//                 <Typography variant="caption" sx={{ color: COLORS.textSecondary, fontWeight: 600 }}>Name</Typography>
//                 <TextField
//                   placeholder="Your full name" fullWidth size="small"
//                   value={contactForm.name}
//                   onChange={(e) => setContactForm({ ...contactForm, name: e.target.value })}
//                   sx={{ mt: 0.5, '& .MuiOutlinedInput-root': { bgcolor: COLORS.inputBg, borderRadius: 2, '& fieldset': { borderColor: COLORS.border } } }}
//                 />
//               </Box>
//               <Box>
//                 <Typography variant="caption" sx={{ color: COLORS.textSecondary, fontWeight: 600 }}>Phone</Typography>
//                 <TextField
//                   placeholder="+91 88765 43210" fullWidth size="small"
//                   value={contactForm.phone}
//                   onChange={(e) => setContactForm({ ...contactForm, phone: e.target.value })}
//                   sx={{ mt: 0.5, '& .MuiOutlinedInput-root': { bgcolor: COLORS.inputBg, borderRadius: 2, '& fieldset': { borderColor: COLORS.border } } }}
//                 />
//               </Box>
//               <Box>
//                 <Typography variant="caption" sx={{ color: COLORS.textSecondary, fontWeight: 600 }}>Email</Typography>
//                 <TextField
//                   placeholder="you@example.com" fullWidth size="small"
//                   value={contactForm.email}
//                   onChange={(e) => setContactForm({ ...contactForm, email: e.target.value })}
//                   sx={{ mt: 0.5, '& .MuiOutlinedInput-root': { bgcolor: COLORS.inputBg, borderRadius: 2, '& fieldset': { borderColor: COLORS.border } } }}
//                 />
//               </Box>
//               <Box>
//                 <Typography variant="caption" sx={{ color: COLORS.textSecondary, fontWeight: 600 }}>Preferred Time</Typography>
//                 <TextField
//                   select fullWidth size="small"
//                   value={contactForm.preferredTime}
//                   onChange={(e) => setContactForm({ ...contactForm, preferredTime: e.target.value })}
//                   sx={{ mt: 0.5, '& .MuiOutlinedInput-root': { bgcolor: COLORS.inputBg, borderRadius: 2, '& fieldset': { borderColor: COLORS.border } } }}
//                 >
//                   <MenuItem value="Morning (9-12)">Morning (9-12)</MenuItem>
//                   <MenuItem value="Afternoon (12-4)">Afternoon (12-4)</MenuItem>
//                   <MenuItem value="Evening (4-8)">Evening (4-8)</MenuItem>
//                 </TextField>
//               </Box>
//               <Box>
//                 <Typography variant="caption" sx={{ color: COLORS.textSecondary, fontWeight: 600 }}>Message</Typography>
//                 <TextField
//                   placeholder="Type your message..." multiline rows={3} fullWidth
//                   value={contactForm.message}
//                   onChange={(e) => setContactForm({ ...contactForm, message: e.target.value })}
//                   sx={{ mt: 0.5, '& .MuiOutlinedInput-root': { bgcolor: COLORS.inputBg, borderRadius: 2, '& fieldset': { borderColor: COLORS.border } } }}
//                 />
//               </Box>
//             </Box>

//             <Button
//               variant="contained" fullWidth startIcon={<Phone />}
//               onClick={handleContactSubmit}
//               sx={{ mt: 2.5, borderRadius: 2, bgcolor: COLORS.primary, py: 1.1, fontWeight: 700, textTransform: 'none', '&:hover': { bgcolor: COLORS.primaryDark } }}
//             >
//               Request Callback
//             </Button>
//           </CardContent>
//         </Card>
//       </Box>

//       {/* --- NEARBY / SIMILAR (2 per row, View All next to heading) --- */}
//       {(d.nearby.length > 0 || d.similar.length > 0) && (
//         <Box sx={{ px: 2, mb: 2 }}>
//           {d.nearby.length > 0 && (
//             <>
//               <SectionHeaderWithViewAll
//                 title="Nearby Projects"
//                 onViewAll={d.nearby.length > 2 ? () => setShowAllNearby(!showAllNearby) : null}
//                 expanded={showAllNearby}
//               />
//               <Grid container spacing={1.5}>
//                 {visibleNearby.map((proj) => (
//                   <Grid item xs={6} key={proj.id}>
//                     <ProjectCard proj={proj} />
//                   </Grid>
//                 ))}
//               </Grid>
//             </>
//           )}

//           {d.similar.length > 0 && (
//             <>
//               <Box sx={{ mt: 3 }}>
//                 <SectionHeaderWithViewAll
//                   title="Similar Projects"
//                   onViewAll={d.similar.length > 2 ? () => setShowAllSimilar(!showAllSimilar) : null}
//                   expanded={showAllSimilar}
//                 />
//               </Box>
//               <Grid container spacing={1.5}>
//                 {visibleSimilar.map((proj) => (
//                   <Grid item xs={6} key={proj.id}>
//                     <ProjectCard proj={proj} />
//                   </Grid>
//                 ))}
//               </Grid>
//             </>
//           )}
//         </Box>
//       )}

//     </Box>
//   );
// };

// export default BHKDescription;




// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import {
//   Box, Card, CardContent, Typography, Button, Grid, Chip,
//   Divider, LinearProgress, Paper, TextField, MenuItem,
//   CircularProgress, IconButton,
// } from '@mui/material';
// import {
//   Download, Phone, ChevronRight, LocationOn, CheckCircle,
//   Construction, Security, Bolt, Groups, Pool, FitnessCenter,
//   SportsEsports, DirectionsRun, ChildCare, Park, SelfImprovement,
//   MeetingRoom, Theaters, Work, ElectricCar, LocalParking, Water,
//   Videocam, ChildFriendly, Spa, HotTub, SportsTennis,
//   SportsBasketball, SportsCricket, SportsSoccer, DirectionsBike,
//   LocalLibrary, LocalCafe, Event, Hotel, Texture, Kitchen, Bathtub,
//   FormatPaint, Home as HomeIcon, Map, Train, Flight, DirectionsBus,
//   School, LocalHospital, ShoppingCart, ApartmentOutlined, Description,
//   Gavel, AccountBalance, Star, ArrowBack,
// } from '@mui/icons-material';

// import { HiOutlinePhoto } from "react-icons/hi2";
// import { CgPlayButtonO } from "react-icons/cg";
// import { TbRotate360 } from "react-icons/tb";

// /* ------------------------------------------------------------------
//    THEME (unchanged)
// ------------------------------------------------------------------ */
// const COLORS = {
//   primary: '#8B4A2B',
//   primaryDark: '#6B3620',
//   primaryLight: '#FBEEE0',
//   bg: '#FFFFFF',
//   cardBg: '#FFFFFF',
//   chipDark: '#3D2B1F',
//   green: '#2E7D32',
//   greenBg: '#E8F5E9',
//   blue: '#1565C0',
//   textSecondary: '#8A7A6D',
//   textDark: '#2B2118',
//   border: '#F0E6DA',
//   inputBg: '#FAF5EF',
// };

// /* ------------------------------------------------------------------
//    API CONFIG
// ------------------------------------------------------------------ */
// const API_ORIGIN = 'https://landnest.net:81';
// const AD_API_URL = `${API_ORIGIN}/ad-properties/combined/`;

// /* ------------------------------------------------------------------
//    ICON RESOLUTION HELPERS (unchanged)
// ------------------------------------------------------------------ */
// const ICON_KEYWORDS = [
//   { keys: ['security', 'cctv', 'guard', '24'], icon: Security },
//   { keys: ['power', 'backup', 'electrical', 'bolt'], icon: Bolt },
//   { keys: ['club', 'community'], icon: Groups },
//   { keys: ['swim', 'pool'], icon: Pool },
//   { keys: ['gym', 'fitness'], icon: FitnessCenter },
//   { keys: ['indoor', 'game', 'sports esports'], icon: SportsEsports },
//   { keys: ['jog', 'run', 'track'], icon: DirectionsRun },
//   { keys: ['child', 'kid', 'play'], icon: ChildCare },
//   { keys: ['senior', 'park', 'garden', 'landscape'], icon: Park },
//   { keys: ['yoga', 'meditation'], icon: SelfImprovement },
//   { keys: ['multipurpose', 'hall', 'banquet', 'party'], icon: MeetingRoom },
//   { keys: ['theatre', 'theater', 'cinema'], icon: Theaters },
//   { keys: ['co-work', 'cowork', 'office', 'business', 'lounge'], icon: Work },
//   { keys: ['ev', 'electric', 'charging'], icon: ElectricCar },
//   { keys: ['visitor', 'parking'], icon: LocalParking },
//   { keys: ['rain', 'water', 'harvest'], icon: Water },
//   { keys: ['cctv', 'camera', 'surveillance'], icon: Videocam },
//   { keys: ['kids pool', 'child pool'], icon: ChildFriendly },
//   { keys: ['spa'], icon: Spa },
//   { keys: ['sauna', 'hot tub', 'jacuzzi'], icon: HotTub },
//   { keys: ['badminton', 'tennis'], icon: SportsTennis },
//   { keys: ['basketball'], icon: SportsBasketball },
//   { keys: ['cricket', 'net'], icon: SportsCricket },
//   { keys: ['football', 'soccer', 'turf'], icon: SportsSoccer },
//   { keys: ['cycling', 'bike'], icon: DirectionsBike },
//   { keys: ['library', 'reading'], icon: LocalLibrary },
//   { keys: ['cafe', 'coffee'], icon: LocalCafe },
//   { keys: ['event', 'auditorium'], icon: Event },
//   { keys: ['hotel', 'guest', 'room'], icon: Hotel },
//   { keys: ['flooring', 'floor', 'texture'], icon: Texture },
//   { keys: ['kitchen', 'modular'], icon: Kitchen },
//   { keys: ['bathroom', 'bath', 'toilet'], icon: Bathtub },
//   { keys: ['painting', 'paint'], icon: FormatPaint },
//   { keys: ['smart', 'home', 'automation'], icon: HomeIcon },
//   { keys: ['door', 'window'], icon: MeetingRoom },
//   { keys: ['metro', 'train', 'railway'], icon: Train },
//   { keys: ['airport', 'flight'], icon: Flight },
//   { keys: ['bus', 'transit'], icon: DirectionsBus },
//   { keys: ['school', 'college', 'education'], icon: School },
//   { keys: ['hospital', 'clinic', 'medical'], icon: LocalHospital },
//   { keys: ['mall', 'shopping', 'market'], icon: ShoppingCart },
//   { keys: ['it park', 'tech', 'office park'], icon: ApartmentOutlined },
//   { keys: ['brochure', 'document', 'pdf'], icon: Description },
//   { keys: ['legal', 'rera', 'approval'], icon: Gavel },
//   { keys: ['bank', 'loan', 'finance'], icon: AccountBalance },
// ];

// const resolveIcon = (label = '') => {
//   const lower = String(label).toLowerCase();
//   for (const { keys, icon } of ICON_KEYWORDS) {
//     if (keys.some((k) => lower.includes(k))) return icon;
//   }
//   return CheckCircle;
// };

// /* ------------------------------------------------------------------
//    FORMATTERS (unchanged)
// ------------------------------------------------------------------ */
// const formatPrice = (price) => {
//   if (!price && price !== 0) return 'Price on Request';
//   if (price >= 10000000) return `₹${(price / 10000000).toFixed(price % 10000000 === 0 ? 0 : 2)}Cr`;
//   if (price >= 100000) return `₹${(price / 100000).toFixed(price % 100000 === 0 ? 0 : 1)}L`;
//   return `₹${Number(price).toLocaleString()}`;
// };

// const formatPriceLong = (price) => {
//   if (price === undefined || price === null) return 'Price on Request';
//   if (price >= 10000000) return `₹${parseFloat((price / 10000000).toFixed(2))} Crores`;
//   if (price >= 100000) return `₹${parseFloat((price / 100000).toFixed(2))} Lakhs`;
//   return `₹${Number(price).toLocaleString()}`;
// };

// const formatDate = (d) =>
//   d ? new Date(d).toLocaleDateString('en-IN', { month: 'short', year: 'numeric' }) : '';

// const prettyBhk = (raw) => {
//   if (!raw) return 'Unit';
//   return String(raw).replace(/(\d+\+?)\s*BHK/i, '$1 BHK').trim();
// };

// const BHK_SORT = (a, b) => {
//   const num = (s) => {
//     const m = String(s || '').match(/(\d+)/);
//     return m ? parseInt(m[1], 10) : 999;
//   };
//   return num(a) - num(b);
// };

// const isEmpty = (v) =>
//   v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0);

// const show = (v) => (isEmpty(v) ? '—' : String(v));

// const withUnit = (v, unit) => {
//   if (isEmpty(v)) return '';
//   return /^[\d.,]+$/.test(String(v).trim()) ? `${v} ${unit}` : String(v);
// };

// const getImageUrl = (imagePath) => {
//   if (!imagePath) return '';
//   if (typeof imagePath !== 'string') return '';
//   if (imagePath.startsWith('http') || imagePath.startsWith('data:')) return imagePath;
//   return `${API_ORIGIN}${imagePath.startsWith('/') ? '' : '/'}${imagePath}`;
// };

// /* ------------------------------------------------------------------
//    API → VIEW-MODEL ADAPTER
// ------------------------------------------------------------------ */
// const labelOf = (item) => {
//   if (item === undefined || item === null) return '';
//   if (typeof item !== 'object') return String(item);
//   return String(item.name || item.title || item.label || '');
// };

// const normalizeProject = (proj, i) => {
//   const name = proj.name || proj.property_name || 'Project';
//   const area = proj.area || proj.location || proj.city || '';
//   const bhk = proj.bhk || proj.bhk_type || '';
//   const priceRange =
//     proj.priceRange || proj.price_range ||
//     (proj.min_budget && proj.max_budget
//       ? `${formatPrice(proj.min_budget)} - ${formatPrice(proj.max_budget)}`
//       : '');
//   return {
//     id: proj.id ?? proj.property_id ?? i,
//     name,
//     area,
//     bhk,
//     priceRange,
//     rating: proj.rating,
//     rera: !!(proj.rera || proj.rera_number || proj.is_rera_approved),
//     image: getImageUrl(proj.image || proj.hero_image || (proj.hero_images && proj.hero_images[0]?.image) || ''),
//   };
// };

// const EMPTY_DATA = {
//   project: {},
//   configs: [],
//   highlights: [],
//   amenities: [],
//   specifications: [],
//   locationAdvantages: [],
//   legal: {},
//   brochures: [],
//   nearby: [],
//   similar: [],
//   media: { photos: 0, video: '', tour: '' },
// };

// const normalizeProperty = (property) => {
//   const p = property || {};

//   const configs = (p.configurations || [])
//     .slice()
//     .sort((a, b) => BHK_SORT(a.bhk_type, b.bhk_type))
//     .map((c, i) => ({
//       id: c.id ?? i,
//       bhk_type: prettyBhk(c.bhk_type),
//       price: c.price,
//       carpet_area: c.carpet_area,
//       built_up_area: c.built_up_area,
//       super_built_up_area: c.super_built_up_area,
//       bathrooms: c.bathrooms,
//       facing: c.facing,
//       parking: c.parking,
//       balcony: c.balcony,
//       images: (c.floor_plan_images || []).map((im) => getImageUrl(im.image)).filter(Boolean),
//       brochure: getImageUrl((c.floor_plan_images || [])[0]?.image || ''),
//     }));

//   const highlights = (p.property_highlights || []).map(labelOf).filter(Boolean);
//   const amenities = (p.property_amenities || []).map(labelOf).filter(Boolean);

//   const specifications = (p.specifications || [])
//     .map((s) => ({ name: s.name || '', value: s.value || '' }))
//     .filter((s) => s.name);

//   const locationAdvantages = (p.location_advantages || [])
//     .map((l) => ({
//       place_name: l.place_name || '',
//       distance: withUnit(l.distance, 'km'),
//       travel_time: withUnit(l.travel_time, 'min'),
//     }))
//     .filter((l) => l.place_name);

//   const brochures = (p.brochures || []).map((doc, i) => ({
//     id: doc.id ?? i,
//     title: doc.title || 'Document',
//     url: getImageUrl(doc.document),
//     uploadedAt: doc.uploaded_at ? formatDate(doc.uploaded_at) : '',
//   }));

//   const legal = {
//     bankApproved: p.bank_approved || '',
//     approvalStatus: p.approval_status || (p.status ? 'Approved' : ''),
//     governmentApprovals: p.government_approvals || '',
//     legalClearances: p.legal_clearances || (brochures.length > 0 ? 'All Clear' : ''),
//   };

//   const cfgPrices = configs.map((c) => c.price).filter((n) => n !== undefined && n !== null);
//   const priceRange =
//     p.min_budget && p.max_budget
//       ? p.min_budget === p.max_budget
//         ? formatPrice(p.min_budget)
//         : `${formatPrice(p.min_budget)} - ${formatPrice(p.max_budget)}`
//       : cfgPrices.length
//         ? (Math.min(...cfgPrices) === Math.max(...cfgPrices)
//           ? formatPrice(Math.min(...cfgPrices))
//           : `${formatPrice(Math.min(...cfgPrices))} - ${formatPrice(Math.max(...cfgPrices))}`)
//         : '';

//   const heroImages = p.hero_images || [];

//   const project = {
//     builder: p.builder_details?.builder_name || '',
//     name: p.property_name || '',
//     location: [p.address, p.city].filter(Boolean).join(', '),
//     lat: p.lat,
//     lng: p.long,
//     priceRange,
//     bhkTypes: configs.map((c) => c.bhk_type).join(', '),
//     status: p.status ? 'Active' : '',
//     possession: formatDate(p.possession_date),
//     towers: p.towers || p.total_towers || '',
//     floors: p.floors || p.total_floors || '',
//     units: p.units || p.total_units || '',
//     totalArea: withUnit(p.total_area || p.project_area, 'Acres'),
//     constructionProgress: Number(p.construction_progress) || 0,
//     rera: p.rera_number ? 'RERA APPROVED' : '',
//     verified: !!p.status,
//     propertyType: p.property_type || '',
//     category: p.category_name || '',
//     description: p.description || '',
//     phone: p.user_mobile_no || '',
//     cover: getImageUrl(heroImages[0]?.image || ''),
//   };

//   return {
//     project,
//     configs,
//     highlights,
//     amenities,
//     specifications,
//     locationAdvantages,
//     legal,
//     brochures,
//     nearby: (p.nearby_projects || p.nearbyProjects || p.nearby || []).map(normalizeProject),
//     similar: (p.similar_projects || p.similarProjects || []).map(normalizeProject),
//     media: {
//       photos: heroImages.length,
//       video: getImageUrl(p.video || p.video_url || ''),
//       tour: getImageUrl(p.virtual_tour || p.virtual_tour_url || ''),
//     },
//   };
// };

// /* ------------------------------------------------------------------
//    Reusable components
// ------------------------------------------------------------------ */
// const IconGrid = ({ items, emptyText }) => {
//   if (!items || items.length === 0) {
//     return (
//       <Typography variant="body2" sx={{ color: COLORS.textSecondary, textAlign: 'center', py: 1 }}>
//         {emptyText || 'Not available'}
//       </Typography>
//     );
//   }
//   return (
//     <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px' }}>
//       {items.map((item) => {
//         const IconComp = resolveIcon(item);
//         return (
//           <Box
//             key={item}
//             sx={{
//               display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center',
//               gap: 0.5, p: 1, borderRadius: '10px', border: `1px solid ${COLORS.border}`,
//               backgroundColor: COLORS.cardBg, minHeight: '60px', justifyContent: 'center', overflow: 'hidden',
//             }}
//           >
//             <IconComp sx={{ fontSize: 24, color: COLORS.primary }} />
//             <Typography sx={{ fontSize: '10.5px', fontWeight: 600, color: COLORS.textDark, lineHeight: 1.2, wordBreak: 'break-word' }}>
//               {item}
//             </Typography>
//           </Box>
//         );
//       })}
//     </Box>
//   );
// };

// const SectionHeaderWithViewAll = ({ title, onViewAll, expanded }) => (
//   <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
//     <Typography variant="subtitle1" fontWeight="bold" sx={{ color: COLORS.textDark }}>{title}</Typography>
//     {onViewAll && (
//       <Typography
//         variant="body2"
//         onClick={onViewAll}
//         sx={{ color: COLORS.blue, fontWeight: 600, cursor: 'pointer' }}
//       >
//         {expanded ? 'Show Less' : 'View All'}
//       </Typography>
//     )}
//   </Box>
// );

// const NearbyImagePlaceholder = ({ image }) =>
//   image ? (
//     <Box component="img" src={image} alt="" sx={{ width: '100%', height: 90, objectFit: 'cover', display: 'block' }} />
//   ) : (
//     <Box sx={{ width: '100%', height: 90, bgcolor: '#F5F5F5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//       <Construction sx={{ fontSize: 28, color: '#D4A373' }} />
//     </Box>
//   );

// const ProjectCard = ({ proj }) => (
//   <Card sx={{ borderRadius: 3, border: `1px solid ${COLORS.border}`, boxShadow: 'none', overflow: 'hidden' }}>
//     <NearbyImagePlaceholder image={proj.image} />
//     <CardContent sx={{ p: 1, '&:last-child': { pb: 1 } }}>
//       <Typography variant="body2" fontWeight="bold" sx={{ color: COLORS.textDark }} noWrap>{proj.name}</Typography>
//       <Typography variant="caption" sx={{ color: COLORS.textSecondary, display: 'block' }} noWrap>
//         {[proj.area, proj.bhk].filter(Boolean).join(' • ')}
//       </Typography>
//       <Typography variant="body2" fontWeight="bold" sx={{ color: COLORS.blue, mt: 0.5 }}>{proj.priceRange}</Typography>
//       <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 0.5 }}>
//         {proj.rera ? (
//           <Chip label="RERA" size="small" sx={{ bgcolor: COLORS.chipDark, color: 'white', fontSize: '0.65rem', height: 20 }} />
//         ) : <span />}
//         {!isEmpty(proj.rating) && (
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
//             <Star sx={{ fontSize: 14, color: '#F5A623' }} />
//             <Typography variant="caption" fontWeight="bold">{proj.rating}</Typography>
//           </Box>
//         )}
//       </Box>
//     </CardContent>
//   </Card>
// );

// const EmptyText = ({ children }) => (
//   <Typography variant="body2" sx={{ color: COLORS.textSecondary, textAlign: 'center', py: 3 }}>
//     {children}
//   </Typography>
// );

// /* ================================================================== */
// const BHKDescription = () => {
//   const { id } = useParams();
//   const navigate = useNavigate(); // Added to enable back navigation

//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [reloadKey, setReloadKey] = useState(0);

//   const [activeTab, setActiveTab] = useState(0);
//   const [showAllHighlights, setShowAllHighlights] = useState(false);
//   const [showAllAmenities, setShowAllAmenities] = useState(false);
//   const [showAllNearby, setShowAllNearby] = useState(false);
//   const [showAllSimilar, setShowAllSimilar] = useState(false);
//   const [contactForm, setContactForm] = useState({
//     name: '', phone: '', email: '', preferredTime: 'Morning (9-12)', message: '',
//   });

//   useEffect(() => {
//     if (!id) {
//       setError('No property id in the URL');
//       setLoading(false);
//       return;
//     }

//     const controller = new AbortController();

//     (async () => {
//       try {
//         setLoading(true);
//         setError(null);
//         const res = await fetch(`${AD_API_URL}${id}/`, {
//           signal: controller.signal,
//           headers: { Accept: 'application/json' },
//         });
//         if (!res.ok) throw new Error(`Request failed (${res.status})`);
//         const json = await res.json();
//         console.log('[BHKDescription] raw API response:', json);

//         let property = json?.data ?? json;
//         if (Array.isArray(property)) {
//           property = property.find((it) => String(it.property_id) === String(id)) || property[0];
//         }

//         setData(normalizeProperty(property));
//         setActiveTab(0);
//       } catch (e) {
//         if (e.name !== 'AbortError') setError(e.message || 'Something went wrong');
//       } finally {
//         if (!controller.signal.aborted) setLoading(false);
//       }
//     })();

//     return () => controller.abort();
//   }, [id, reloadKey]);

//   if (loading) {
//     return (
//       <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: COLORS.bg }}>
//         <CircularProgress sx={{ color: COLORS.primary }} />
//       </Box>
//     );
//   }

//   if (error) {
//     return (
//       <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2, px: 3, textAlign: 'center', backgroundColor: COLORS.bg }}>
//         <Typography sx={{ color: COLORS.textDark, fontWeight: 700 }}>Couldn't load this property</Typography>
//         <Typography variant="body2" sx={{ color: COLORS.textSecondary }}>{error}</Typography>
//         <Button
//           variant="contained"
//           onClick={() => setReloadKey((k) => k + 1)}
//           sx={{ borderRadius: 2, bgcolor: COLORS.primary, textTransform: 'none', fontWeight: 700, '&:hover': { bgcolor: COLORS.primaryDark } }}
//         >
//           Try again
//         </Button>
//       </Box>
//     );
//   }

//   const d = data || EMPTY_DATA;
//   const { project, configs, media, legal, brochures } = d;
//   const activeConfig = configs[activeTab] || null;

//   const openUrl = (url) => {
//     if (url) window.open(url, '_blank', 'noopener');
//   };

//   const openGoogleMaps = () => {
//     const query =
//       project.lat !== undefined && project.lng !== undefined
//         ? `${project.lat},${project.lng}`
//         : project.location;
//     window.open(`https://www.google.com/maps?q=${encodeURIComponent(query)}`, '_blank');
//   };

//   const handleDownloadBrochure = () => openUrl(brochures[0]?.url);

//   const handleContactSubmit = () => {
//     console.log('Contact form submitted:', { propertyId: id, ...contactForm });
//   };

//   const visibleHighlights = showAllHighlights ? d.highlights : d.highlights.slice(0, 8);
//   const visibleAmenities = showAllAmenities ? d.amenities : d.amenities.slice(0, 8);
//   const visibleNearby = showAllNearby ? d.nearby : d.nearby.slice(0, 2);
//   const visibleSimilar = showAllSimilar ? d.similar : d.similar.slice(0, 2);

//   return (
//     <Box sx={{ backgroundColor: COLORS.bg, minHeight: '100vh', pb: 10, fontFamily: 'sans-serif', overflowY: 'auto' }}>

//       {/* --- NEW HERO IMAGE & OVERLAY SECTION --- */}
//       <Box sx={{ position: 'relative', width: '100%', height: 320, mb: 1 }}>
//         {/* Hero Image */}
//         {project.cover ? (
//           <Box
//             component="img"
//             src={project.cover}
//             alt={project.name}
//             sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
//           />
//         ) : (
//           <Box sx={{ width: '100%', height: '100%', bgcolor: '#E0E0E0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//             <Construction sx={{ fontSize: 60, color: '#BDBDBD' }} />
//           </Box>
//         )}

//         {/* Back Arrow (Top Left) */}
//         <IconButton
//           onClick={() => navigate(-1)}
//           sx={{
//             position: 'absolute',
//             top: 16,
//             left: 16,
//             bgcolor: 'rgba(255,255,255,0.85)',
//             color: COLORS.textDark,
//             backdropFilter: 'blur(4px)',
//             '&:hover': { bgcolor: 'white' },
//             boxShadow: 1,
//           }}
//         >
//           <ArrowBack />
//         </IconButton>

//         {/* Top Action Chips (Overlaid on Image, Bottom Left) */}
//         <Box
//           sx={{
//             position: 'absolute',
//             bottom: 4,
//             left: 16,
//             right: 16,
//             display: 'flex',
//             gap: 1.5,
//             overflowX: 'auto',
//             '&::-webkit-scrollbar': { display: 'none' },
//             pb: 0.5,
//           }}
//         >
//           {[
//             { label: media.photos ? `${media.photos} Photos` : 'Photos', icon: <HiOutlinePhoto size={16} />, url: '' },
//             { label: 'Video', icon: <CgPlayButtonO size={16} />, url: media.video },
//             // { label: 'Virtual Tour', icon: <TbRotate360 size={16} />, url: media.tour },
//           ].map((item, i) => (
//             <Chip
//               key={i}
//               icon={item.icon}
//               label={item.label}
//               onClick={item.url ? () => openUrl(item.url) : undefined}
//               sx={{
//                 bgcolor: 'rgba(61, 43, 31, 0.85)', // Slightly transparent dark brown
//                 color: 'white',
//                 fontWeight: 600,
//                 fontSize: '12px',
//                 borderRadius: 10,
//                 px: 1,
//                 backdropFilter: 'blur(4px)',
//                 '& .MuiChip-icon': { color: 'white' },
//               }}
//             />
//           ))}
//         </Box>
//       </Box>
//       {/* --- END HERO SECTION --- */}

//       {/* --- Property Header Card --- */}
//       <Box sx={{ px: 2 }}>
//         <Card sx={{ borderRadius: 3, p: 2, boxShadow: '0 4px 20px rgba(139,74,43,0.08)', border: `1px solid ${COLORS.border}` }}>
//           <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
//             <Box sx={{ width: 80, height: 100, bgcolor: '#F5F5F5', borderRadius: 2, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, overflow: 'hidden' }}>
//               {project.cover ? (
//                 <Box component="img" src={project.cover} alt={project.name} sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
//               ) : (
//                 <Construction sx={{ fontSize: 40, color: '#D4A373' }} />
//               )}
//             </Box>
//             <Box sx={{ flex: 1 }}>
//               <Typography sx={{ fontSize: '14px', color: COLORS.primary, fontWeight: 700, mb: 0.5 }}>
//                 {[project.builder, project.category].filter(Boolean).join(' • ')}
//               </Typography>
//               <Typography sx={{ fontSize: '18px', fontWeight: 800, color: COLORS.textDark, mb: 0.5, lineHeight: 1.2 }}>
//                 {project.name}
//               </Typography>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1 }}>
//                 <LocationOn sx={{ fontSize: 14, color: COLORS.textSecondary }} />
//                 <Typography sx={{ fontSize: '12px', color: COLORS.textSecondary }}>
//                   {project.location}
//                 </Typography>
//               </Box>
//               <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
//                 {project.rera && (
//                   <Chip label={project.rera} size="small" sx={{ bgcolor: COLORS.primaryDark, color: 'white', fontSize: '10px', fontWeight: 700, height: 22, borderRadius: 10 }} />
//                 )}
//                 {project.verified && (
//                   <Chip icon={<CheckCircle sx={{ fontSize: 12 }} />} label="Verified" size="small" sx={{ bgcolor: COLORS.greenBg, color: COLORS.green, fontSize: '10px', fontWeight: 700, height: 22, borderRadius: 10, '& .MuiChip-icon': { color: COLORS.green } }} />
//                 )}
//               </Box>
//             </Box>
//           </Box>

//           <Divider sx={{ my: 2, borderColor: COLORS.border, borderStyle: 'dashed' }} />

//           <Box sx={{ display: 'flex', gap: 4, alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
//             {/* Possession Section */}
//             <Typography sx={{ fontSize: '13px', color: '#4B5563' /* Lighter gray for the value */ }}>
//               <Box component="span" sx={{ fontWeight: 700, color: '#111827' /* Dark/Black for the label */, mr: 0.5 }}>
//                 Possession:
//               </Box>
//               {show(project.possession)}
//             </Typography>

//             {/* Type Section */}
//             <Typography sx={{ fontSize: '13px', color: '#4B5563' /* Lighter gray for the value */ }}>
//               <Box component="span" sx={{ fontWeight: 700, color: '#111827' /* Dark/Black for the label */, mr: 0.5 }}>
//                 Type:
//               </Box>
//               {show(project.propertyType)}
//             </Typography>
//           </Box>
//         </Card>
//       </Box>

//    {/* --- Price & BHK Summary --- */}
// <Box sx={{ px: 2, mt: 1 }}>
//   <Typography sx={{ fontSize: '28px', fontWeight: 800, color:'#6B3620', letterSpacing: '-0.5px' }}>
//     {project.priceRange || 'Price on Request'}
//   </Typography>
//   <Typography sx={{ fontSize: '12px', color: COLORS.textSecondary, letterSpacing: '1px', fontWeight: 600 }}>
//     PRICE RANGE
//   </Typography>

//   {/* BHK Types + Property Type on the same line */}
//   {(project.bhkTypes || project.propertyType) && (
//     <Typography sx={{ fontSize: '20px', fontWeight: 700, color:'#6B3620', }}>
//       {[project.bhkTypes, project.propertyType].filter(Boolean).join(' ')}
//     </Typography>
//   )}

//   {project.description && (
//     <Typography sx={{ fontSize: '13px', color: COLORS.textSecondary, mt: 1 }}>
//       {project.description}
//     </Typography>
//   )}
// </Box>

//       {/* --- Project Stats & Progress --- */}
//       <Box sx={{ px: 2, mt: 1 }}>
//         <Card
//           sx={{
//             borderRadius: 3,
//             p: 0.5,
//             boxShadow: 'none',
//             border: `1px solid ${COLORS.border}`,
//             bgcolor: '#FAFAFA',
//           }}
//         >
//           <Box
//             sx={{
//               display: 'grid',
//               gridTemplateColumns: '1fr 1fr',
//               rowGap: 2,
//               columnGap: 2,
//             }}
//           >
//             <Box>
//               <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary, mb: 0.5 }}>
//                 STATUS
//               </Typography>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                 <Construction sx={{ fontSize: 16, color: COLORS.primary }} />
//                 <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.primary }}>
//                   {show(project.status)}
//                 </Typography>
//               </Box>
//             </Box>
//             <Box>
//               <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary, mb: 0.5 }}>
//                 POSSESSION
//               </Typography>
//               <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.primary }}>
//                 {show(project.possession)}
//               </Typography>
//             </Box>
//             <Box>
//               <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary, mb: 0.5 }}>
//                 TOWERS
//               </Typography>
//               <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.primary }}>
//                 {show(project.towers)}
//               </Typography>
//             </Box>
//             <Box>
//               <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary, mb: 0.5 }}>
//                 FLOORS
//               </Typography>
//               <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.primary }}>
//                 {show(project.floors)}
//               </Typography>
//             </Box>
//             <Box>
//               <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary, mb: 0.5 }}>
//                 UNITS
//               </Typography>
//               <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.primary }}>
//                 {show(project.units)}
//               </Typography>
//             </Box>
//             <Box>
//               <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary, mb: 0.5 }}>
//                 TOTAL AREA
//               </Typography>
//               <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.primary }}>
//                 {show(project.totalArea)}
//               </Typography>
//             </Box>
//           </Box>

//           <Box sx={{ mt: 2.5 }}>
//             <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
//               <Typography sx={{ fontSize: '14px', fontWeight: 600, color: COLORS.textDark }}>
//                 Construction Progress
//               </Typography>
//               <Typography sx={{ fontSize: '12px', fontWeight: 700, color: COLORS.textDark }}>
//                 {project.constructionProgress}%
//               </Typography>
//             </Box>
//             <LinearProgress
//               variant="determinate"
//               value={project.constructionProgress}
//               sx={{
//                 height: 8,
//                 borderRadius: 4,
//                 bgcolor: '#E0E0E0',
//                 '& .MuiLinearProgress-bar': {
//                   bgcolor: COLORS.primaryDark,
//                   borderRadius: 4,
//                 },
//               }}
//             />
//           </Box>
//         </Card>
//       </Box>

//       {/* --- BHK Tabs --- */}
//       {configs.length > 0 && (
//         <Box sx={{ mt: 1, px: 1, bgcolor: 'white' }}>
//           <Box sx={{ display: 'flex', gap: 1 }}>
//             {configs.map((cfg, idx) => {
//               const isActive = activeTab === idx;
//               return (
//                 <Box
//                   key={cfg.id}
//                   onClick={() => setActiveTab(idx)}
//                   sx={{
//                     flex: 1,
//                     textAlign: 'center',
//                     py: 1,
//                     borderRadius: 2,
//                     border: `1px solid ${isActive ? COLORS.primaryDark : COLORS.border}`,
//                     bgcolor: isActive ? COLORS.primaryDark : 'white',
//                     color: isActive ? 'white' : COLORS.textDark,
//                     fontWeight: 700,
//                     fontSize: '12.5px',
//                     cursor: 'pointer',
//                     userSelect: 'none',
//                     whiteSpace: 'nowrap',
//                     transition: 'all 0.15s ease',
//                   }}
//                 >
//                   {cfg.bhk_type}
//                 </Box>
//               );
//             })}
//           </Box>
//         </Box>
//       )}

//       {/* --- Floor Plans & Pricing Content --- */}
//       <Box sx={{ p: 1 }}>
//         <Typography sx={{ fontSize: '20px', fontWeight: 800, color: COLORS.textDark }}>
//           Floor Plans & Pricing
//         </Typography>

//         {!activeConfig && <EmptyText>No configurations available for this property</EmptyText>}

//         {activeConfig && (
//           <Card sx={{ mb: 1, borderRadius: 3, border: `1px solid ${COLORS.border}`, boxShadow: '0 2px 10px rgba(139,74,43,0.06)' }}>
//             <CardContent sx={{ p: 0.5 }}>
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
//                 <Typography sx={{ fontSize: '18px', fontWeight: 800, color:'#6B3620'}}>
//                   {activeConfig.bhk_type}
//                 </Typography>
//                 <Box
//                   sx={{
//                     bgcolor: COLORS.primaryLight,
//                     color: COLORS.primary,
//                     fontWeight: 700,
//                     fontSize: '11px',
//                     px: 1,
//                     py: 0.5,
//                     borderRadius: 1.5,
//                   }}
//                 >
//                   {activeConfig.price !== undefined ? `Starting at ${formatPrice(activeConfig.price)}` : 'Price on Request'}
//                 </Box>
//               </Box>

//               <Box
//                 sx={{
//                   display: 'grid',
//                   gridTemplateColumns: '1fr 1fr',
//                   rowGap: 1.75,
//                   columnGap: 2,
//                 }}
//               >
//                 {[
//                   { label: 'Carpet Area', value: show(withUnit(activeConfig.carpet_area, 'sqft')) },
//                   { label: 'Built-up Area', value: show(withUnit(activeConfig.built_up_area, 'sqft')) },
//                   { label: 'Super Built-up', value: show(withUnit(activeConfig.super_built_up_area, 'sqft')) },
//                   { label: 'Price', value: formatPriceLong(activeConfig.price) },
//                   { label: 'Bathrooms', value: show(activeConfig.bathrooms) },
//                   { label: 'Facing', value: show(activeConfig.facing) },
//                   { label: 'Parking', value: show(activeConfig.parking) },
//                   { label: 'Balcony', value: show(activeConfig.balcony) },
//                 ].map((item) => (
//                   <Box
//                     key={item.label}
//                     sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
//                   >
//                     <Typography sx={{ fontSize: '12px', color: COLORS.textSecondary }}>
//                       {item.label}
//                     </Typography>
//                     <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.textDark }}>
//                       {item.value}
//                     </Typography>
//                   </Box>
//                 ))}
//               </Box>

//               <Box
//                 sx={{
//                   display: 'flex',
//                   gap: 1.5,
//                   overflowX: 'auto',
//                   mt: 1,
//                   pb: 0.5,
//                   scrollSnapType: 'x mandatory',
//                   '&::-webkit-scrollbar': { height: 4 },
//                   '&::-webkit-scrollbar-thumb': { bgcolor: COLORS.border, borderRadius: 2 },
//                 }}
//               >
//                 {(activeConfig.images.length > 0 ? activeConfig.images : [null, null]).map((src, n) => (
//                   <Box
//                     key={n}
//                     sx={{
//                       flex: '0 0 calc(50% - 6px)',
//                       minWidth: 'calc(50% - 6px)',
//                       height: 150,
//                       borderRadius: 2,
//                       overflow: 'hidden',
//                       border: `1px solid ${COLORS.border}`,
//                       bgcolor: '#F5F5F5',
//                       scrollSnapAlign: 'start',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                     }}
//                   >
//                     {src ? (
//                       <Box
//                         component="img"
//                         src={src}
//                         alt={`${activeConfig.bhk_type} floor plan ${n + 1}`}
//                         onClick={() => openUrl(src)}
//                         sx={{ width: '100%', height: '100%', objectFit: 'contain', cursor: 'pointer' }}
//                       />
//                     ) : (
//                       <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75, width: '80%', height: '80%' }}>
//                         <Box sx={{ display: 'flex', gap: 0.75, height: '40%' }}>
//                           <Box sx={{ flex: 1, border: '1px solid #CCC', bgcolor: '#EAEAEA' }} />
//                           <Box sx={{ flex: 2, border: '1px solid #CCC', bgcolor: '#EAEAEA' }} />
//                         </Box>
//                         <Box sx={{ display: 'flex', gap: 0.75, height: '60%' }}>
//                           <Box sx={{ flex: 2, border: '1px solid #CCC', bgcolor: '#EAEAEA' }} />
//                           <Box sx={{ flex: 1, border: '1px solid #CCC', bgcolor: '#EAEAEA' }} />
//                         </Box>
//                       </Box>
//                     )}
//                   </Box>
//                 ))}
//               </Box>

//               <Box sx={{ display: 'flex', gap: 1.5, mt: 1 }}>
//                 <Button
//                   variant="outlined"
//                   size="small"
//                   startIcon={<Download sx={{ fontSize: 16 }} />}
//                   onClick={() => openUrl(activeConfig.brochure || brochures[0]?.url)}
//                   disabled={!activeConfig.brochure && !brochures[0]?.url}
//                   sx={{
//                     flex: 1,
//                     borderRadius: 2,
//                     color: COLORS.primaryDark,
//                     borderColor: COLORS.border,
//                     fontWeight: 700,
//                     fontSize: '12px',
//                     textTransform: 'none',
//                     '&:hover': { borderColor: COLORS.primaryDark, bgcolor: COLORS.primaryLight },
//                   }}
//                 >
//                   Download
//                 </Button>
//                 <Button
//                   variant="contained"
//                   size="small"
//                   startIcon={<Phone sx={{ fontSize: 16 }} />}
//                   onClick={() => document.getElementById('bhk-request-callback')?.scrollIntoView({ behavior: 'smooth', block: 'center' })}
//                   sx={{
//                     flex: 1,
//                     borderRadius: 2,
//                     bgcolor: COLORS.primaryDark,
//                     color: 'white',
//                     fontWeight: 700,
//                     fontSize: '12px',
//                     textTransform: 'none',
//                     '&:hover': { bgcolor: COLORS.primary },
//                   }}
//                 >
//                   Request Callback
//                 </Button>
//               </Box>
//             </CardContent>
//           </Card>
//         )}

//         {configs.map((config, idx) =>
//           idx === activeTab ? null : (
//             <Paper
//               key={config.id}
//               onClick={() => setActiveTab(idx)}
//               sx={{
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 alignItems: 'center',
//                 p: 1,
//                 // mb: 1,
//                 borderRadius: 3,
//                 cursor: 'pointer',
//                 border: `1px solid ${COLORS.border}`,
//                 boxShadow: 'none',
//                 bgcolor: 'white',
//                 '&:hover': { bgcolor: '#FAFAFA' },
//               }}
//             >
//               <Typography sx={{ fontSize: '15px', fontWeight: 700, color: COLORS.textDark }}>
//                 {config.bhk_type}
//               </Typography>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 600, color: COLORS.primary }}>
//                   {config.price !== undefined ? `Starting at ${formatPrice(config.price)}` : 'Price on Request'}
//                 </Typography>
//                 <ChevronRight sx={{ color: COLORS.textSecondary, fontSize: 20 }} />
//               </Box>
//             </Paper>
//           )
//         )}
//       </Box>

//       {/* --- HIGHLIGHTS --- */}
//       <Box sx={{ px: 0.5 }}>
//         <Divider sx={{ borderColor: COLORS.border, mb: 0.5 }} />
//         <Card sx={{ borderRadius: 3, boxShadow: '0 2px 10px rgba(139,74,43,0.06)', border: `1px solid ${COLORS.border}` }}>
//           <CardContent sx={{ p: 0.5 }}>
//             <SectionHeaderWithViewAll
//               title="Property Highlights"
//               onViewAll={d.highlights.length > 8 ? () => setShowAllHighlights(!showAllHighlights) : null}
//               expanded={showAllHighlights}
//             />
//             <IconGrid items={visibleHighlights} emptyText="No highlights available for this property" />
//           </CardContent>
//         </Card>
//       </Box>

//       {/* --- AMENITIES --- */}
//       <Box sx={{ px: 0.5}}>
//         <Card sx={{ borderRadius: 3, boxShadow: '0 2px 10px rgba(139,74,43,0.06)', border: `1px solid ${COLORS.border}` }}>
//           <CardContent sx={{ p: 0.5 }}>
//             <SectionHeaderWithViewAll
//               title="Amenities"
//               onViewAll={d.amenities.length > 8 ? () => setShowAllAmenities(!showAllAmenities) : null}
//               expanded={showAllAmenities}
//             />
//             <IconGrid items={visibleAmenities} emptyText="No amenities listed for this property" />
//           </CardContent>
//         </Card>
//       </Box>

//       {/* --- SPECIFICATIONS --- */}
//       <Box sx={{ px: 0.5 }}>
//         <Card sx={{ borderRadius: 3, border: `1px solid ${COLORS.border}`, boxShadow: '0 2px 10px rgba(139,74,43,0.06)' }}>
//           <CardContent sx={{ p: 0.5 }}>
//             <Typography variant="subtitle1" fontWeight="bold" sx={{ color: COLORS.textDark }}>
//               Specifications
//             </Typography>
//             {d.specifications.length === 0 && <EmptyText>No specifications listed for this property</EmptyText>}
//             {d.specifications.map((spec, idx, arr) => {
//               const IconComp = resolveIcon(spec.name);
//               return (
//                 <Box
//                   key={`${spec.name}-${idx}`}
//                   sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 0.5, borderBottom: idx < arr.length - 1 ? `1px solid ${COLORS.border}` : 'none' }}
//                 >
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//                     <IconComp sx={{ fontSize: 20, color: COLORS.primary }} />
//                     <Box>
//                       <Typography variant="body2" fontWeight={600} sx={{ color: COLORS.textDark }}>{spec.name}</Typography>
//                       <Typography variant="caption" sx={{ color: COLORS.textSecondary }}>{spec.value}</Typography>
//                     </Box>
//                   </Box>
//                 </Box>
//               );
//             })}
//           </CardContent>
//         </Card>
//       </Box>

//       {/* --- LOCATION --- */}
//       <Box sx={{ px: 0.5, mb: 1 }}>
//         <Card sx={{ borderRadius: 3, border: `1px solid ${COLORS.border}`, boxShadow: '0 2px 10px rgba(139,74,43,0.06)' }}>
//           <CardContent sx={{ p: 0.5 }}>
//             <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1, color: COLORS.textDark }}>
//               Location Advantages
//             </Typography>

//             {d.locationAdvantages.length === 0 && <EmptyText>No location details available</EmptyText>}
//             {d.locationAdvantages.map((item, index, arr) => {
//               const IconComp = resolveIcon(item.place_name);
//               return (
//                 <Box
//                   key={`${item.place_name}-${index}`}
//                   sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1.5, borderBottom: index < arr.length - 1 ? `1px solid ${COLORS.border}` : 'none' }}
//                 >
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//                     <IconComp sx={{ fontSize: 20, color: COLORS.primary }} />
//                     <Box>
//                       <Typography variant="body2"  sx={{ color: COLORS.textDark, fontSize: 14, fontWeight: 600 }}>{item.place_name}</Typography>
//                       <Typography variant="caption" sx={{ color: COLORS.textSecondary }}>{item.distance}</Typography>
//                     </Box>
//                   </Box>
//                   <Typography sx={{ color: COLORS.blue, fontWeight: 600 }}>{item.travel_time}</Typography>
//                 </Box>
//               );
//             })}

//             <Box sx={{ mt: 2 }}>
//               <Button
//                 variant="outlined" fullWidth startIcon={<Map />}
//                 onClick={openGoogleMaps}
//                 disabled={!project.location && (project.lat === undefined || project.lng === undefined)}
//                 sx={{ borderRadius: 6, color: COLORS.primary, borderColor: COLORS.primary, fontWeight: 700, py: 1, '&:hover': { borderColor: COLORS.primaryDark, bgcolor: COLORS.primaryLight } }}
//               >
//                 View on Google Maps
//               </Button>
//             </Box>
//           </CardContent>
//         </Card>
//       </Box>



//       {/* --- REQUEST CALLBACK --- */}
//       <Box id="bhk-request-callback" sx={{ px: 0.5 }}>
//         <Card sx={{ borderRadius: 3, border: `1px solid ${COLORS.border}`, boxShadow: '0 2px 10px rgba(139,74,43,0.06)' }}>
//           <CardContent sx={{ p: 0.5 }}>
//             <Typography variant="subtitle1" fontWeight="bold" sx={{ color: COLORS.textDark }}>
//               Request Callback
//             </Typography>

//             <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//               <Box>
//                 <Typography variant="caption" sx={{ color: COLORS.textSecondary, fontWeight: 600 }}>Name</Typography>
//                 <TextField
//                   placeholder="Your full name" fullWidth size="small"
//                   value={contactForm.name}
//                   onChange={(e) => setContactForm({ ...contactForm, name: e.target.value })}
//                   sx={{ mt: 0.5, '& .MuiOutlinedInput-root': { bgcolor: COLORS.inputBg, borderRadius: 2, '& fieldset': { borderColor: COLORS.border } } }}
//                 />
//               </Box>
//               <Box>
//                 <Typography variant="caption" sx={{ color: COLORS.textSecondary, fontWeight: 600 }}>Phone</Typography>
//                 <TextField
//                   placeholder="+91 88765 43210" fullWidth size="small"
//                   value={contactForm.phone}
//                   onChange={(e) => setContactForm({ ...contactForm, phone: e.target.value })}
//                   sx={{ mt: 0.5, '& .MuiOutlinedInput-root': { bgcolor: COLORS.inputBg, borderRadius: 2, '& fieldset': { borderColor: COLORS.border } } }}
//                 />
//               </Box>
//               <Box>
//                 <Typography variant="caption" sx={{ color: COLORS.textSecondary, fontWeight: 600 }}>Email</Typography>
//                 <TextField
//                   placeholder="you@example.com" fullWidth size="small"
//                   value={contactForm.email}
//                   onChange={(e) => setContactForm({ ...contactForm, email: e.target.value })}
//                   sx={{ mt: 0.5, '& .MuiOutlinedInput-root': { bgcolor: COLORS.inputBg, borderRadius: 2, '& fieldset': { borderColor: COLORS.border } } }}
//                 />
//               </Box>
//               <Box>
//                 <Typography variant="caption" sx={{ color: COLORS.textSecondary, fontWeight: 600 }}>Preferred Time</Typography>
//                 <TextField
//                   select fullWidth size="small"
//                   value={contactForm.preferredTime}
//                   onChange={(e) => setContactForm({ ...contactForm, preferredTime: e.target.value })}
//                   sx={{ mt: 0.5, '& .MuiOutlinedInput-root': { bgcolor: COLORS.inputBg, borderRadius: 2, '& fieldset': { borderColor: COLORS.border } } }}
//                 >
//                   <MenuItem value="Morning (9-12)">Morning (9-12)</MenuItem>
//                   <MenuItem value="Afternoon (12-4)">Afternoon (12-4)</MenuItem>
//                   <MenuItem value="Evening (4-8)">Evening (4-8)</MenuItem>
//                 </TextField>
//               </Box>
//               <Box>
//                 <Typography variant="caption" sx={{ color: COLORS.textSecondary, fontWeight: 600 }}>Message</Typography>
//                 <TextField
//                   placeholder="Type your message..." multiline rows={3} fullWidth
//                   value={contactForm.message}
//                   onChange={(e) => setContactForm({ ...contactForm, message: e.target.value })}
//                   sx={{ mt: 0.5, '& .MuiOutlinedInput-root': { bgcolor: COLORS.inputBg, borderRadius: 2, '& fieldset': { borderColor: COLORS.border } } }}
//                 />
//               </Box>
//             </Box>

//             <Button
//               variant="contained" fullWidth startIcon={<Phone />}
//               onClick={handleContactSubmit}
//               sx={{ mt: 1, borderRadius: 2, bgcolor: COLORS.primary, py: 1.1, fontWeight: 700, textTransform: 'none', '&:hover': { bgcolor: COLORS.primaryDark } }}
//             >
//               Request Callback
//             </Button>
//           </CardContent>
//         </Card>
//       </Box>

//       {/* --- NEARBY / SIMILAR --- */}
//       {(d.nearby.length > 0 || d.similar.length > 0) && (
//         <Box sx={{ px: 2, mb: 1 }}>
//           {d.nearby.length > 0 && (
//             <>
//               <SectionHeaderWithViewAll
//                 title="Nearby Projects"
//                 onViewAll={d.nearby.length > 2 ? () => setShowAllNearby(!showAllNearby) : null}
//                 expanded={showAllNearby}
//               />
//               <Grid container spacing={1.5}>
//                 {visibleNearby.map((proj) => (
//                   <Grid item xs={6} key={proj.id}>
//                     <ProjectCard proj={proj} />
//                   </Grid>
//                 ))}
//               </Grid>
//             </>
//           )}

//           {d.similar.length > 0 && (
//             <>
//               <Box sx={{ mt: 1 }}>
//                 <SectionHeaderWithViewAll
//                   title="Similar Projects"
//                   onViewAll={d.similar.length > 2 ? () => setShowAllSimilar(!showAllSimilar) : null}
//                   expanded={showAllSimilar}
//                 />
//               </Box>
//               <Grid container spacing={1.5}>
//                 {visibleSimilar.map((proj) => (
//                   <Grid item xs={6} key={proj.id}>
//                     <ProjectCard proj={proj} />
//                   </Grid>
//                 ))}
//               </Grid>
//             </>
//           )}
//         </Box>
//       )}

//     </Box>
//   );
// };

// export default BHKDescription;



//=============================



// import React, { useState, useEffect, useRef, useContext } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import {
//   Box, Card, CardContent, Typography, Button, Grid, Chip,
//   Divider, LinearProgress, Paper, TextField, MenuItem,
//   CircularProgress, IconButton,
// } from '@mui/material';
// import {
//   Download, Phone, ChevronRight, LocationOn, CheckCircle,
//   Construction, Security, Bolt, Groups, Pool, FitnessCenter,
//   SportsEsports, DirectionsRun, ChildCare, Park, SelfImprovement,
//   MeetingRoom, Theaters, Work, ElectricCar, LocalParking, Water,
//   Videocam, ChildFriendly, Spa, HotTub, SportsTennis,
//   SportsBasketball, SportsCricket, SportsSoccer, DirectionsBike,
//   LocalLibrary, LocalCafe, Event, Hotel, Texture, Kitchen, Bathtub,
//   FormatPaint, Home as HomeIcon, Map, Train, Flight, DirectionsBus,
//   School, LocalHospital, ShoppingCart, ApartmentOutlined, Description,
//   Gavel, AccountBalance, Star, ArrowBack,
// } from '@mui/icons-material';

// import { HiOutlinePhoto } from "react-icons/hi2";
// import { CgPlayButtonO } from "react-icons/cg";
// import { TbRotate360 } from "react-icons/tb";
// import { AuthContext } from '../../AuthContext/AuthContext';

// /* ------------------------------------------------------------------
//    THEME
// ------------------------------------------------------------------ */
// const COLORS = {
//   primary: '#8B4A2B',
//   primaryDark: '#6B3620',
//   primaryLight: '#FBEEE0',
//   bg: '#FFFFFF',
//   cardBg: '#FFFFFF',
//   chipDark: '#3D2B1F',
//   green: '#2E7D32',
//   greenBg: '#E8F5E9',
//   blue: '#1565C0',
//   textSecondary: '#8A7A6D',
//   textDark: '#2B2118',
//   border: '#F0E6DA',
//   inputBg: '#FAF5EF',
// };

// /* ------------------------------------------------------------------
//    API CONFIG
// ------------------------------------------------------------------ */
// const API_ORIGIN = 'https://landnest.net:81';
// const AD_API_URL = `${API_ORIGIN}/ad-properties/combined/`;

// /* ------------------------------------------------------------------
//    ICON RESOLUTION HELPERS
// ------------------------------------------------------------------ */
// const ICON_KEYWORDS = [
//   { keys: ['security', 'cctv', 'guard', '24'], icon: Security },
//   { keys: ['power', 'backup', 'electrical', 'bolt'], icon: Bolt },
//   { keys: ['club', 'community'], icon: Groups },
//   { keys: ['swim', 'pool'], icon: Pool },
//   { keys: ['gym', 'fitness'], icon: FitnessCenter },
//   { keys: ['indoor', 'game', 'sports esports'], icon: SportsEsports },
//   { keys: ['jog', 'run', 'track'], icon: DirectionsRun },
//   { keys: ['child', 'kid', 'play'], icon: ChildCare },
//   { keys: ['senior', 'park', 'garden', 'landscape'], icon: Park },
//   { keys: ['yoga', 'meditation'], icon: SelfImprovement },
//   { keys: ['multipurpose', 'hall', 'banquet', 'party'], icon: MeetingRoom },
//   { keys: ['theatre', 'theater', 'cinema'], icon: Theaters },
//   { keys: ['co-work', 'cowork', 'office', 'business', 'lounge'], icon: Work },
//   { keys: ['ev', 'electric', 'charging'], icon: ElectricCar },
//   { keys: ['visitor', 'parking'], icon: LocalParking },
//   { keys: ['rain', 'water', 'harvest'], icon: Water },
//   { keys: ['cctv', 'camera', 'surveillance'], icon: Videocam },
//   { keys: ['kids pool', 'child pool'], icon: ChildFriendly },
//   { keys: ['spa'], icon: Spa },
//   { keys: ['sauna', 'hot tub', 'jacuzzi'], icon: HotTub },
//   { keys: ['badminton', 'tennis'], icon: SportsTennis },
//   { keys: ['basketball'], icon: SportsBasketball },
//   { keys: ['cricket', 'net'], icon: SportsCricket },
//   { keys: ['football', 'soccer', 'turf'], icon: SportsSoccer },
//   { keys: ['cycling', 'bike'], icon: DirectionsBike },
//   { keys: ['library', 'reading'], icon: LocalLibrary },
//   { keys: ['cafe', 'coffee'], icon: LocalCafe },
//   { keys: ['event', 'auditorium'], icon: Event },
//   { keys: ['hotel', 'guest', 'room'], icon: Hotel },
//   { keys: ['flooring', 'floor', 'texture'], icon: Texture },
//   { keys: ['kitchen', 'modular'], icon: Kitchen },
//   { keys: ['bathroom', 'bath', 'toilet'], icon: Bathtub },
//   { keys: ['painting', 'paint'], icon: FormatPaint },
//   { keys: ['smart', 'home', 'automation'], icon: HomeIcon },
//   { keys: ['door', 'window'], icon: MeetingRoom },
//   { keys: ['metro', 'train', 'railway'], icon: Train },
//   { keys: ['airport', 'flight'], icon: Flight },
//   { keys: ['bus', 'transit'], icon: DirectionsBus },
//   { keys: ['school', 'college', 'education'], icon: School },
//   { keys: ['hospital', 'clinic', 'medical'], icon: LocalHospital },
//   { keys: ['mall', 'shopping', 'market'], icon: ShoppingCart },
//   { keys: ['it park', 'tech', 'office park'], icon: ApartmentOutlined },
//   { keys: ['brochure', 'document', 'pdf'], icon: Description },
//   { keys: ['legal', 'rera', 'approval'], icon: Gavel },
//   { keys: ['bank', 'loan', 'finance'], icon: AccountBalance },
// ];

// const resolveIcon = (label = '') => {
//   const lower = String(label).toLowerCase();
//   for (const { keys, icon } of ICON_KEYWORDS) {
//     if (keys.some((k) => lower.includes(k))) return icon;
//   }
//   return CheckCircle;
// };

// /* ------------------------------------------------------------------
//    FORMATTERS
// ------------------------------------------------------------------ */
// const formatPrice = (price) => {
//   if (!price && price !== 0) return 'Price on Request';
//   if (price >= 10000000) return `₹${(price / 10000000).toFixed(price % 10000000 === 0 ? 0 : 2)}Cr`;
//   if (price >= 100000) return `₹${(price / 100000).toFixed(price % 100000 === 0 ? 0 : 1)}L`;
//   return `₹${Number(price).toLocaleString()}`;
// };

// const formatPriceLong = (price) => {
//   if (price === undefined || price === null) return 'Price on Request';
//   if (price >= 10000000) return `₹${parseFloat((price / 10000000).toFixed(2))} Crores`;
//   if (price >= 100000) return `₹${parseFloat((price / 100000).toFixed(2))} Lakhs`;
//   return `₹${Number(price).toLocaleString()}`;
// };

// const formatDate = (d) =>
//   d ? new Date(d).toLocaleDateString('en-IN', { month: 'short', year: 'numeric' }) : '';

// const prettyBhk = (raw) => {
//   if (!raw) return 'Unit';
//   return String(raw).replace(/(\d+\+?)\s*BHK/i, '$1 BHK').trim();
// };

// const BHK_SORT = (a, b) => {
//   const num = (s) => {
//     const m = String(s || '').match(/(\d+)/);
//     return m ? parseInt(m[1], 10) : 999;
//   };
//   return num(a) - num(b);
// };

// const isEmpty = (v) =>
//   v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0);

// const show = (v) => (isEmpty(v) ? '—' : String(v));

// const withUnit = (v, unit) => {
//   if (isEmpty(v)) return '';
//   return /^[\d.,]+$/.test(String(v).trim()) ? `${v} ${unit}` : String(v);
// };

// const getImageUrl = (imagePath) => {
//   if (!imagePath) return '';
//   if (typeof imagePath !== 'string') return '';
//   if (imagePath.startsWith('http') || imagePath.startsWith('data:')) return imagePath;
//   return `${API_ORIGIN}${imagePath.startsWith('/') ? '' : '/'}${imagePath}`;
// };

// /* ------------------------------------------------------------------
//    API → VIEW-MODEL ADAPTER
// ------------------------------------------------------------------ */
// const labelOf = (item) => {
//   if (item === undefined || item === null) return '';
//   if (typeof item !== 'object') return String(item);
//   return String(item.name || item.title || item.label || '');
// };

// const normalizeProject = (proj, i) => {
//   const name = proj.name || proj.property_name || 'Project';
//   const area = proj.area || proj.location || proj.city || '';
//   const bhk = proj.bhk || proj.bhk_type || '';
//   const priceRange =
//     proj.priceRange || proj.price_range ||
//     (proj.min_budget && proj.max_budget
//       ? `${formatPrice(proj.min_budget)} - ${formatPrice(proj.max_budget)}`
//       : '');
//   return {
//     id: proj.id ?? proj.property_id ?? i,
//     name,
//     area,
//     bhk,
//     priceRange,
//     rating: proj.rating,
//     rera: !!(proj.rera || proj.rera_number || proj.is_rera_approved),
//     image: getImageUrl(proj.image || proj.hero_image || (proj.hero_images && proj.hero_images[0]?.image) || ''),
//   };
// };

// const EMPTY_DATA = {
//   project: {},
//   configs: [],
//   highlights: [],
//   amenities: [],
//   specifications: [],
//   locationAdvantages: [],
//   legal: {},
//   brochures: [],
//   nearby: [],
//   similar: [],
//   media: { photos: 0, videos: [], video: '', tour: '' },
// };

// const normalizeProperty = (property) => {
//   const p = property || {};

//   const configs = (p.configurations || [])
//     .slice()
//     .sort((a, b) => BHK_SORT(a.bhk_type, b.bhk_type))
//     .map((c, i) => ({
//       id: c.id ?? i,
//       bhk_type: prettyBhk(c.bhk_type),
//       price: c.price,
//       carpet_area: c.carpet_area,
//       built_up_area: c.built_up_area,
//       super_built_up_area: c.super_built_up_area,
//       bathrooms: c.bathrooms,
//       facing: c.facing,
//       parking: c.parking,
//       balcony: c.balcony,
//       // plot + commercial fields
//       status: c.status,
//       floor: c.floor,
//       road_frontage: c.road_frontage,
//       ceiling_height: c.ceiling_height,
//       washrooms: c.washrooms,
//       power_backup: c.power_backup,
//       ownership: c.ownership,
//       images: (c.floor_plan_images || []).map((im) => getImageUrl(im.image)).filter(Boolean),
//       brochure: getImageUrl((c.floor_plan_images || [])[0]?.image || ''),
//     }));

//   const highlights = (p.property_highlights || []).map(labelOf).filter(Boolean);
//   const amenities = (p.property_amenities || []).map(labelOf).filter(Boolean);

//   const specifications = (p.specifications || [])
//     .map((s) => ({ name: s.name || '', value: s.value || '' }))
//     .filter((s) => s.name);

//   const locationAdvantages = (p.location_advantages || [])
//     .map((l) => ({
//       place_name: l.place_name || '',
//       distance: withUnit(l.distance, 'km'),
//       travel_time: withUnit(l.travel_time, 'min'),
//     }))
//     .filter((l) => l.place_name);

//   const brochures = (p.brochures || []).map((doc, i) => ({
//     id: doc.id ?? i,
//     title: doc.title || 'Document',
//     url: getImageUrl(doc.document),
//     uploadedAt: doc.uploaded_at ? formatDate(doc.uploaded_at) : '',
//   }));

//   const legal = {
//     bankApproved: p.bank_approved || '',
//     approvalStatus: p.approval_status || (p.status ? 'Approved' : ''),
//     governmentApprovals: p.government_approvals || '',
//     legalClearances: p.legal_clearances || (brochures.length > 0 ? 'All Clear' : ''),
//   };

//   const cfgPrices = configs.map((c) => c.price).filter((n) => n !== undefined && n !== null);
//   const priceRange =
//     p.min_budget && p.max_budget
//       ? p.min_budget === p.max_budget
//         ? formatPrice(p.min_budget)
//         : `${formatPrice(p.min_budget)} - ${formatPrice(p.max_budget)}`
//       : cfgPrices.length
//         ? (Math.min(...cfgPrices) === Math.max(...cfgPrices)
//           ? formatPrice(Math.min(...cfgPrices))
//           : `${formatPrice(Math.min(...cfgPrices))} - ${formatPrice(Math.max(...cfgPrices))}`)
//         : '';

//   const heroImages = Array.isArray(p.hero_images) ? p.hero_images : [];

//   // Sort images by `order` if present, map to full URLs, drop empties
//   const sortedHeroImages = heroImages
//     .slice()
//     .sort((a, b) => (a.order || 0) - (b.order || 0))
//     .map((im) => getImageUrl(im.image))
//     .filter(Boolean);

//   // Collect ALL videos (supports arrays & single-field fallbacks)
//   const rawVideos =
//     (Array.isArray(p.videos) && p.videos) ||
//     (Array.isArray(p.video_urls) && p.video_urls) ||
//     (Array.isArray(p.hero_videos) && p.hero_videos) ||
//     [];

//   let sortedVideos = rawVideos
//     .slice()
//     .sort((a, b) => (a.order || 0) - (b.order || 0))
//     .map((v) => getImageUrl(v?.video || v?.url || v?.video_url || v?.file || v))
//     .filter(Boolean);

//   // Fall back to single video field
//   if (sortedVideos.length === 0) {
//     const single = getImageUrl(p.video || p.video_url || '');
//     if (single) sortedVideos = [single];
//   }

//   const project = {
//     builder: p.builder_details?.builder_name || '',
//     name: p.property_name || '',
//     location: [p.address, p.city].filter(Boolean).join(', '),
//     exactlocation: p.location,
//     lat: p.lat,
//     lng: p.long,
//     priceRange,
//     // Unique types only: East, East, North -> "East, North"
//     bhkTypes: [...new Set(configs.map((c) => c.bhk_type))].join(', '),
//     status: p.possession_status ? 'Active' : '',
//     possession: formatDate(p.possession_date) || 'Ready to Move',
//     towers: p.towers || p.total_towers || '',
//     floors: p.floors || p.overall_floors || '',
//     units: p.units || p.total_units || '',
//     totalArea: withUnit(p.site_area || p.project_area, 'sq.ft'),
//     constructionProgress: Number(p.construction_progress) || 0,
//     rera: p.rera_number ? 'RERA APPROVED' : '',
//     verified: !!p.status,
//     propertyType: p.property_type || '',
//     category: p.property_type || '',
//     description: p.description || '',
//     phone: p.user_mobile_no || '',

//     cover: sortedHeroImages[0] || '',
//     covers: sortedHeroImages,
//     videos: sortedVideos,
//   };

//   return {
//     project,
//     configs,
//     highlights,
//     amenities,
//     specifications,
//     locationAdvantages,
//     legal,
//     brochures,
//     nearby: (p.nearby_projects || p.nearbyProjects || p.nearby || []).map(normalizeProject),
//     similar: (p.similar_projects || p.similarProjects || []).map(normalizeProject),
//     media: {
//       photos: heroImages.length,
//       videos: sortedVideos,
//       video: sortedVideos[0] || '',
//       tour: getImageUrl(p.virtual_tour || p.virtual_tour_url || ''),
//     },
//   };
// };

// /* ------------------------------------------------------------------
//    Reusable components
// ------------------------------------------------------------------ */
// const IconGrid = ({ items, emptyText }) => {
//   if (!items || items.length === 0) {
//     return (
//       <Typography variant="body2" sx={{ color: COLORS.textSecondary, textAlign: 'center', py: 1 }}>
//         {emptyText || 'Not available'}
//       </Typography>
//     );
//   }
//   return (
//     <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px' }}>
//       {items.map((item) => {
//         const IconComp = resolveIcon(item);
//         return (
//           <Box
//             key={item}
//             sx={{
//               display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center',
//               gap: 0.5, p: 1, borderRadius: '10px', border: `1px solid ${COLORS.border}`,
//               backgroundColor: COLORS.cardBg, minHeight: '60px', justifyContent: 'center', overflow: 'hidden',
//             }}
//           >
//             <IconComp sx={{ fontSize: 24, color: COLORS.primary }} />
//             <Typography sx={{ fontSize: '10.5px', fontWeight: 600, color: COLORS.textDark, lineHeight: 1.2, wordBreak: 'break-word' }}>
//               {item}
//             </Typography>
//           </Box>
//         );
//       })}
//     </Box>
//   );
// };

// const SectionHeaderWithViewAll = ({ title, onViewAll, expanded }) => (
//   <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//     <Typography variant="subtitle1" fontWeight="bold" sx={{ color: COLORS.textDark }}>{title}</Typography>
//     {onViewAll && (
//       <Typography
//         variant="body2"
//         onClick={onViewAll}
//         sx={{ color: COLORS.blue, fontWeight: 600, cursor: 'pointer' }}
//       >
//         {expanded ? 'Show Less' : 'View All'}
//       </Typography>
//     )}
//   </Box>
// );

// const NearbyImagePlaceholder = ({ image }) =>
//   image ? (
//     <Box component="img" src={image} alt="" sx={{ width: '100%', height: 90, objectFit: 'cover', display: 'block' }} />
//   ) : (
//     <Box sx={{ width: '100%', height: 90, bgcolor: '#F5F5F5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//       <Construction sx={{ fontSize: 28, color: '#D4A373' }} />
//     </Box>
//   );

// const ProjectCard = ({ proj }) => (
//   <Card sx={{ borderRadius: 3, border: `1px solid ${COLORS.border}`, boxShadow: 'none', overflow: 'hidden' }}>
//     <NearbyImagePlaceholder image={proj.image} />
//     <CardContent sx={{ p: 1, '&:last-child': { pb: 1 } }}>
//       <Typography variant="body2" fontWeight="bold" sx={{ color: COLORS.textDark }} noWrap>{proj.name}</Typography>
//       <Typography variant="caption" sx={{ color: COLORS.textSecondary, display: 'block' }} noWrap>
//         {[proj.area, proj.bhk].filter(Boolean).join(' • ')}
//       </Typography>
//       <Typography variant="body2" fontWeight="bold" sx={{ color: COLORS.blue, mt: 0.5 }}>{proj.priceRange}</Typography>
//       <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 0.5 }}>
//         {proj.rera ? (
//           <Chip label="RERA" size="small" sx={{ bgcolor: COLORS.chipDark, color: 'white', fontSize: '0.65rem', height: 20 }} />
//         ) : <span />}
//         {!isEmpty(proj.rating) && (
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
//             <Star sx={{ fontSize: 14, color: '#F5A623' }} />
//             <Typography variant="caption" fontWeight="bold">{proj.rating}</Typography>
//           </Box>
//         )}
//       </Box>
//     </CardContent>
//   </Card>
// );

// const EmptyText = ({ children }) => (
//   <Typography variant="body2" sx={{ color: COLORS.textSecondary, textAlign: 'center', py: 3 }}>
//     {children}
//   </Typography>
// );

// /* ================================================================== */
// const BHKDescription = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [userLoading, setUserLoading] = useState(false);
//   const [submitting, setSubmitting] = useState(false);

//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [reloadKey, setReloadKey] = useState(0);
//   const { userId } = useContext(AuthContext);

//   // activeTab = index of the selected UNIQUE type (East, North, South...)
//   const [activeTab, setActiveTab] = useState(0);
//   // activeSlide = which configuration (of the selected type) is visible in the slider
//   const [activeSlide, setActiveSlide] = useState(0);

//   const [showAllHighlights, setShowAllHighlights] = useState(false);
//   const [showAllAmenities, setShowAllAmenities] = useState(false);
//   const [showAllNearby, setShowAllNearby] = useState(false);
//   const [showAllSimilar, setShowAllSimilar] = useState(false);

//   // ---- Hero gallery state ----
//   const [heroIndex, setHeroIndex] = useState(0);
//   const heroScrollRef = useRef(null);

//   const [contactForm, setContactForm] = useState({
//     name: "",
//     phone: "",
//     email: "",
//     preferredTime: "morning",
//     message: "",
//   });

//   useEffect(() => {
//     if (!userId) return;
//     console.log("Fetching user details for userId:", userId);

//     const fetchUserDetails = async () => {
//       try {
//         setUserLoading(true);

//         const response = await fetch(
//           `https://landnest.net:81/users/${userId}/`,
//           {
//             headers: {
//               Accept: "application/json",
//             },
//           }
//         );

//         if (!response.ok) {
//           throw new Error("Failed to fetch user details");
//         }

//         const user = await response.json();

//         setContactForm((prev) => ({
//           ...prev,
//           name:
//             `${user.first_name || ""} ${user.last_name || ""}`.trim() ||
//             user.username ||
//             "",
//           phone: user.mobile_no || "",
//           email: user.email || "",
//         }));
//       } catch (error) {
//         console.error("Error fetching user details:", error);
//       } finally {
//         setUserLoading(false);
//       }
//     };

//     fetchUserDetails();
//   }, [userId]);

//   useEffect(() => {
//     if (!id) {
//       setError('No property id in the URL');
//       setLoading(false);
//       return;
//     }

//     const controller = new AbortController();

//     (async () => {
//       try {
//         setLoading(true);
//         setError(null);
//         const res = await fetch(`${AD_API_URL}${id}/`, {
//           signal: controller.signal,
//           headers: { Accept: 'application/json' },
//         });
//         if (!res.ok) throw new Error(`Request failed (${res.status})`);
//         const json = await res.json();
//         console.log('[BHKDescription] raw API response:', json);

//         let property = json?.data ?? json;
//         if (Array.isArray(property)) {
//           property = property.find((it) => String(it.property_id) === String(id)) || property[0];
//         }

//         setData(normalizeProperty(property));
//         setActiveTab(0);
//         setActiveSlide(0);
//         setHeroIndex(0);
//       } catch (e) {
//         if (e.name !== 'AbortError') setError(e.message || 'Something went wrong');
//       } finally {
//         if (!controller.signal.aborted) setLoading(false);
//       }
//     })();

//     return () => controller.abort();
//   }, [id, reloadKey]);

//   // Reliable pause-when-not-active effect for hero videos
//   useEffect(() => {
//     const container = heroScrollRef.current;
//     if (!container) return;

//     const items = container.querySelectorAll('[data-media-type]');
//     items.forEach((el) => {
//       const mediaType = el.getAttribute('data-media-type');
//       const idx = Number(el.getAttribute('data-media-index'));
//       if (mediaType === 'video' && idx !== heroIndex) {
//         const vid = el.querySelector('video');
//         if (vid) {
//           try { vid.pause(); } catch (e) { /* ignore */ }
//         }
//       }
//     });
//   }, [heroIndex]);

//   if (loading) {
//     return (
//       <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: COLORS.bg }}>
//         <CircularProgress sx={{ color: COLORS.primary }} />
//       </Box>
//     );
//   }

//   if (error) {
//     return (
//       <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2, px: 3, textAlign: 'center', backgroundColor: COLORS.bg }}>
//         <Typography sx={{ color: COLORS.textDark, fontWeight: 700 }}>Couldn't load this property</Typography>
//         <Typography variant="body2" sx={{ color: COLORS.textSecondary }}>{error}</Typography>
//         <Button
//           variant="contained"
//           onClick={() => setReloadKey((k) => k + 1)}
//           sx={{ borderRadius: 2, bgcolor: COLORS.primary, textTransform: 'none', fontWeight: 700, '&:hover': { bgcolor: COLORS.primaryDark } }}
//         >
//           Try again
//         </Button>
//       </Box>
//     );
//   }

//   const d = data || EMPTY_DATA;
//   const { project, configs, media, legal, brochures } = d;

//   // Property kind: Commercial Space / Plot-Land / everything else (BHK types)
//   const typeLower = String(project.propertyType || '').toLowerCase();
//   const isCommercial = typeLower.includes('commercial');
//   const isPlot = typeLower.includes('plot') || typeLower.includes('land');

//   const typeSuffix = typeLower.includes('apartment')
//   ? 'Flats'
//   : typeLower.includes('villa')
//     ? 'Villa'
//     : typeLower.includes('independent')
//       ? 'Independent House'
//       : '';

// const getTypeLabel = (type) => (typeSuffix ? `${type} ${typeSuffix}` : type);

//   // Fields shown in each configuration card (same as the upload form)
//   const getConfigFields = (cfg) => {
//     if (isPlot) {
//       return [
//         { label: 'Status', value: show(cfg.status) },
//         { label: 'Facing', value: show(cfg.facing) },
//         { label: 'Area', value: show(withUnit(cfg.carpet_area, 'sqft')) },
//         { label: 'Price', value: formatPriceLong(cfg.price) },
//       ];
//     }
//     if (isCommercial) {
//       return [
//         { label: 'Status', value: show(cfg.status) },
//         { label: 'Price', value: formatPriceLong(cfg.price) },
//         { label: 'Built-up Area', value: show(withUnit(cfg.built_up_area, 'sqft')) },
//         { label: 'Carpet Area', value: show(withUnit(cfg.carpet_area, 'sqft')) },
//         { label: 'Floor', value: show(cfg.floor) },
//         { label: 'Facing', value: show(cfg.facing) },
//         { label: 'Road Frontage', value: show(withUnit(cfg.road_frontage, 'ft')) },
//         { label: 'Ceiling Height', value: show(withUnit(cfg.ceiling_height, 'ft')) },
//         { label: 'Washrooms', value: show(cfg.washrooms) },
//         { label: 'Parking', value: show(cfg.parking) },
//         { label: 'Power Backup', value: show(cfg.power_backup) },
//         { label: 'Ownership', value: show(cfg.ownership) },
//       ];
//     }
//     return [
//       { label: 'Carpet Area', value: show(withUnit(cfg.carpet_area, 'sqft')) },
//       { label: 'Built-up Area', value: show(withUnit(cfg.built_up_area, 'sqft')) },
//       { label: 'Super Built-up', value: show(withUnit(cfg.super_built_up_area, 'sqft')) },
//       { label: 'Price', value: formatPriceLong(cfg.price) },
//       { label: 'Bathrooms', value: show(cfg.bathrooms) },
//       { label: 'Facing', value: show(cfg.facing) },
//       { label: 'Parking', value: show(cfg.parking) },
//       { label: 'Balcony', value: show(cfg.balcony) },
//     ];
//   };

//   const openUrl = (url) => {
//     if (url) window.open(url, '_blank', 'noopener');
//   };

//   const openGoogleMaps = () => {
//     const query =
//       project.lat !== undefined && project.lng !== undefined
//         ? `${project.lat},${project.lng}`
//         : project.location;
//     window.open(`https://www.google.com/maps?q=${encodeURIComponent(query)}`, '_blank');
//   };

//   /* ---------------- Group configurations by type ----------------
//      East, East, North, North, South -> [East[2], North[2], South[1]]
//      One tab per type; all configs of a type go in the slider. */
//   const configGroups = [];
//   configs.forEach((cfg) => {
//     let group = configGroups.find((g) => g.type === cfg.bhk_type);
//     if (!group) {
//       group = { type: cfg.bhk_type, items: [] };
//       configGroups.push(group);
//     }
//     group.items.push(cfg);
//   });

//   const activeGroup = configGroups[activeTab] || null;

//   const groupMinPrice = (group) => {
//     const prices = group.items
//       .map((c) => c.price)
//       .filter((n) => n !== undefined && n !== null);
//     return prices.length ? Math.min(...prices) : undefined;
//   };

//   const handlePlanScroll = (e) => {
//     const el = e.currentTarget;
//     if (!el.clientWidth) return;
//     setActiveSlide(Math.round(el.scrollLeft / el.clientWidth));
//   };

//   const selectGroup = (idx) => {
//     setActiveTab(idx);
//     setActiveSlide(0);
//   };

//   // One configuration card (used inside the slider)
//   const renderConfigCard = (cfg) => (
//     <Card sx={{ borderRadius: 3, border: `1px solid ${COLORS.border}`, boxShadow: '0 2px 10px rgba(139,74,43,0.06)' }}>
//       <CardContent sx={{ p: 0.5 }}>
//         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
//           <Typography sx={{ fontSize: '18px', fontWeight: 800, color: '#6B3620' }}>
//             {getTypeLabel(cfg.bhk_type)}
//           </Typography>
//           <Box
//             sx={{
//               bgcolor: COLORS.primaryLight,
//               color: COLORS.primary,
//               fontWeight: 700,
//               fontSize: '11px',
//               px: 1,
//               py: 0.5,
//               borderRadius: 1.5,
//             }}
//           >
//             {cfg.price !== undefined ? `Starting at ${formatPrice(cfg.price)}` : 'Price on Request'}
//           </Box>
//         </Box>

//         <Box
//           sx={{
//             display: 'grid',
//             gridTemplateColumns: '1fr 1fr',
//             rowGap: 1.75,
//             columnGap: 2,
//           }}
//         >
//           {getConfigFields(cfg).map((item) => (
//             <Box
//               key={item.label}
//               sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
//             >
//               <Typography sx={{ fontSize: '12px', color: COLORS.textSecondary }}>
//                 {item.label}
//               </Typography>
//               <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.textDark }}>
//                 {item.value}
//               </Typography>
//             </Box>
//           ))}
//         </Box>

//         <Box
//           sx={{
//             display: 'flex',
//             gap: 1.5,
//             overflowX: 'auto',
//             mt: 1,
//             pb: 0.5,
//             '&::-webkit-scrollbar': { height: 4 },
//             '&::-webkit-scrollbar-thumb': { bgcolor: COLORS.border, borderRadius: 2 },
//           }}
//         >
//           {(cfg.images.length > 0 ? cfg.images : [null, null]).map((src, n) => (
//             <Box
//               key={n}
//               sx={{
//                 flex: '0 0 calc(50% - 6px)',
//                 minWidth: 'calc(50% - 6px)',
//                 height: 150,
//                 borderRadius: 2,
//                 overflow: 'hidden',
//                 border: `1px solid ${COLORS.border}`,
//                 bgcolor: '#F5F5F5',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//               }}
//             >
//               {src ? (
//                 <Box
//                   component="img"
//                   src={src}
//                   alt={`${cfg.bhk_type} floor plan ${n + 1}`}
//                   onClick={() => openUrl(src)}
//                   sx={{ width: '100%', height: '100%', objectFit: 'contain', cursor: 'pointer' }}
//                 />
//               ) : (
//                 <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75, width: '80%', height: '80%' }}>
//                   <Box sx={{ display: 'flex', gap: 0.75, height: '40%' }}>
//                     <Box sx={{ flex: 1, border: '1px solid #CCC', bgcolor: '#EAEAEA' }} />
//                     <Box sx={{ flex: 2, border: '1px solid #CCC', bgcolor: '#EAEAEA' }} />
//                   </Box>
//                   <Box sx={{ display: 'flex', gap: 0.75, height: '60%' }}>
//                     <Box sx={{ flex: 2, border: '1px solid #CCC', bgcolor: '#EAEAEA' }} />
//                     <Box sx={{ flex: 1, border: '1px solid #CCC', bgcolor: '#EAEAEA' }} />
//                   </Box>
//                 </Box>
//               )}
//             </Box>
//           ))}
//         </Box>

//         <Box sx={{ display: 'flex', gap: 1.5, mt: 1 }}>
//           <Button
//             variant="outlined"
//             size="small"
//             startIcon={<Download sx={{ fontSize: 16 }} />}
//             onClick={() => openUrl(cfg.brochure || brochures[0]?.url)}
//             disabled={!cfg.brochure && !brochures[0]?.url}
//             sx={{
//               flex: 1,
//               borderRadius: 2,
//               color: COLORS.primaryDark,
//               borderColor: COLORS.border,
//               fontWeight: 700,
//               fontSize: '12px',
//               textTransform: 'none',
//               '&:hover': { borderColor: COLORS.primaryDark, bgcolor: COLORS.primaryLight },
//             }}
//           >
//             Download
//           </Button>
//           <Button
//             variant="contained"
//             size="small"
//             startIcon={<Phone sx={{ fontSize: 16 }} />}
//             onClick={() => document.getElementById('bhk-request-callback')?.scrollIntoView({ behavior: 'smooth', block: 'center' })}
//             sx={{
//               flex: 1,
//               borderRadius: 2,
//               bgcolor: COLORS.primaryDark,
//               color: 'white',
//               fontWeight: 700,
//               fontSize: '12px',
//               textTransform: 'none',
//               '&:hover': { bgcolor: COLORS.primary },
//             }}
//           >
//             Request Callback
//           </Button>
//         </Box>
//       </CardContent>
//     </Card>
//   );

//   const handleDownloadBrochure = () => openUrl(brochures[0]?.url);

//   const handleContactSubmit = async () => {
//     if (!userId) {
//       alert("Please log in to request a callback.");
//       return;
//     }

//     if (!contactForm.name || !contactForm.phone || !contactForm.email) {
//       alert("Please fill in your name, phone, and email.");
//       return;
//     }

//     try {
//       setSubmitting(true);

//       const payload = {
//         user_id: Number(userId),
//         property: Number(id),
//         name: contactForm.name,
//         phone: contactForm.phone,
//         email: contactForm.email,
//         preferred_time: contactForm.preferredTime,
//         message: contactForm.message,
//       };

//       console.log("Callback request payload:", payload);

//       const response = await fetch(
//         "https://landnest.net:81/request-callback/",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Accept: "application/json",
//           },
//           body: JSON.stringify(payload),
//         }
//       );

//       const result = await response.json();

//       if (!response.ok) {
//         console.error("Callback API Error:", result);

//         throw new Error(
//           result?.message || result?.detail || "Failed to request callback"
//         );
//       }

//       alert("Callback requested successfully!");

//       setContactForm((prev) => ({
//         ...prev,
//         preferredTime: "morning",
//         message: "",
//       }));
//     } catch (error) {
//       console.error("Callback submission error:", error);
//       alert(error.message || "Something went wrong. Please try again.");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleHeroScroll = (e) => {
//     const el = e.currentTarget;
//     const raw = Math.round(el.scrollLeft / el.clientWidth);
//     const clamped = Math.max(0, Math.min(raw, heroMedia.length - 1));
//     if (clamped !== heroIndex) setHeroIndex(clamped);
//   };

//   const scrollHeroTo = (index) => {
//     const el = heroScrollRef.current;
//     if (!el) return;
//     el.scrollTo({ left: index * el.clientWidth, behavior: 'smooth' });
//   };

//   const visibleHighlights = showAllHighlights ? d.highlights : d.highlights.slice(0, 8);
//   const visibleAmenities = showAllAmenities ? d.amenities : d.amenities.slice(0, 8);
//   const visibleNearby = showAllNearby ? d.nearby : d.nearby.slice(0, 2);
//   const visibleSimilar = showAllSimilar ? d.similar : d.similar.slice(0, 2);

//   // Build unified media list: all images, then ALL videos
//   const heroImages = project.covers || [];
//   const heroVideos = project.videos || [];

//   const heroMedia = [
//     ...heroImages.map((src) => ({ type: 'image', src })),
//     ...heroVideos.map((src) => ({ type: 'video', src })),
//   ];

//   const hasMultipleMedia = heroMedia.length > 1;
//   const firstVideoIndex = heroImages.length;

//   const currentMedia = heroMedia[heroIndex];
//   const currentThumb =
//     (currentMedia?.type === 'image' && currentMedia.src) ||
//     heroImages[0] ||
//     project.cover ||
//     '';

//   return (
//     <Box sx={{ backgroundColor: COLORS.bg, minHeight: '100vh', pb: 10, fontFamily: 'sans-serif', overflowY: 'auto' }}>

//       {/* --- HERO IMAGE & OVERLAY SECTION --- */}
//       <Box sx={{ position: 'relative', width: '100%', height: 320, mb: 1 }}>
//         {/* Hero Media — Scrollable gallery (all images + all videos) */}
//         {heroMedia.length > 0 ? (
//           <>
//             <Box
//               ref={heroScrollRef}
//               onScroll={handleHeroScroll}
//               sx={{
//                 display: 'flex',
//                 width: '100%',
//                 height: '100%',
//                 overflowX: 'auto',
//                 overflowY: 'hidden',
//                 scrollSnapType: 'x mandatory',
//                 scrollBehavior: 'smooth',
//                 WebkitOverflowScrolling: 'touch',
//                 '&::-webkit-scrollbar': { display: 'none' },
//                 msOverflowStyle: 'none',
//                 scrollbarWidth: 'none',
//               }}
//             >
//               {heroMedia.map((item, i) => (
//                 <Box
//                   key={`${item.type}-${i}`}
//                   data-media-type={item.type}
//                   data-media-index={i}
//                   sx={{
//                     flex: '0 0 100%',
//                     width: '100%',
//                     height: '100%',
//                     scrollSnapAlign: 'start',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     bgcolor: '#000',
//                   }}
//                 >
//                   {item.type === 'image' ? (
//                     <Box
//                       component="img"
//                       src={item.src}
//                       alt={`${project.name} ${i + 1}`}
//                       draggable={false}
//                       sx={{
//                         width: '100%',
//                         height: '100%',
//                         objectFit: 'cover',
//                         display: 'block',
//                         userSelect: 'none',
//                       }}
//                     />
//                   ) : (
//                     <Box
//                       component="video"
//                       src={item.src}
//                       controls
//                       playsInline
//                       preload="metadata"
//                       sx={{
//                         width: '100%',
//                         height: '100%',
//                         objectFit: 'contain',
//                         display: 'block',
//                         bgcolor: '#000',
//                       }}
//                     />
//                   )}
//                 </Box>
//               ))}
//             </Box>

//             {/* Dot Indicators — only if >1 media item */}
//             {hasMultipleMedia && (
//               <Box
//                 sx={{
//                   position: 'absolute',
//                   bottom: 44,
//                   left: '50%',
//                   transform: 'translateX(-50%)',
//                   display: 'flex',
//                   gap: '5px',
//                   px: 1,
//                   py: 0.5,
//                   borderRadius: '10px',
//                   bgcolor: 'rgba(0,0,0,0.35)',
//                   backdropFilter: 'blur(4px)',
//                   zIndex: 3,
//                 }}
//               >
//                 {heroMedia.map((item, i) => (
//                   <Box
//                     key={i}
//                     onClick={() => scrollHeroTo(i)}
//                     sx={{
//                       width: item.type === 'video' ? 10 : 6,
//                       height: 6,
//                       borderRadius: item.type === 'video' ? '3px' : '50%',
//                       cursor: 'pointer',
//                       bgcolor: heroIndex === i ? '#FFFFFF' : 'rgba(255,255,255,0.5)',
//                       transition: 'background 0.2s',
//                     }}
//                   />
//                 ))}
//               </Box>
//             )}
//           </>
//         ) : (
//           <Box
//             sx={{
//               width: '100%',
//               height: '100%',
//               bgcolor: '#E0E0E0',
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//             }}
//           >
//             <Construction sx={{ fontSize: 60, color: '#BDBDBD' }} />
//           </Box>
//         )}

//         {/* Back Arrow (Top Left) */}
//         <IconButton
//           onClick={() => navigate(-1)}
//           sx={{
//             position: 'absolute',
//             top: 16,
//             left: 16,
//             bgcolor: 'rgba(255,255,255,0.85)',
//             color: COLORS.textDark,
//             backdropFilter: 'blur(4px)',
//             '&:hover': { bgcolor: 'white' },
//             boxShadow: 1,
//             zIndex: 4,
//           }}
//         >
//           <ArrowBack />
//         </IconButton>

//         {/* Action Chips (Overlaid on Image, Bottom Left) */}
//         <Box
//           sx={{
//             position: 'absolute',
//             bottom: 4,
//             left: 16,
//             right: 16,
//             display: 'flex',
//             gap: 1.5,
//             overflowX: 'auto',
//             '&::-webkit-scrollbar': { display: 'none' },
//             pb: 0.5,
//             zIndex: 4,
//           }}
//         >
//           {/* Photos chip → jump to first image */}
//           <Chip
//             icon={<HiOutlinePhoto size={16} />}
//             label={media.photos ? `${media.photos} Photos` : 'Photos'}
//             onClick={() => scrollHeroTo(0)}
//             sx={{
//               bgcolor: 'rgba(61, 43, 31, 0.85)',
//               color: 'white',
//               fontWeight: 600,
//               fontSize: '12px',
//               borderRadius: 10,
//               px: 1,
//               backdropFilter: 'blur(4px)',
//               cursor: 'pointer',
//               '& .MuiChip-icon': { color: 'white' },
//             }}
//           />

//           {/* Video chip → jump to first video slide (only if videos exist) */}
//           {heroVideos.length > 0 && (
//             <Chip
//               icon={<CgPlayButtonO size={16} />}
//               label={heroVideos.length > 1 ? `${heroVideos.length} Videos` : 'Video'}
//               onClick={() => scrollHeroTo(firstVideoIndex)}
//               sx={{
//                 bgcolor:
//                   heroIndex >= firstVideoIndex
//                     ? 'rgba(139, 74, 43, 0.95)'
//                     : 'rgba(61, 43, 31, 0.85)',
//                 color: 'white',
//                 fontWeight: 600,
//                 fontSize: '12px',
//                 borderRadius: 10,
//                 px: 1,
//                 backdropFilter: 'blur(4px)',
//                 cursor: 'pointer',
//                 transition: 'background 0.2s',
//                 '& .MuiChip-icon': { color: 'white' },
//               }}
//             />
//           )}
//         </Box>
//       </Box>
//       {/* --- END HERO SECTION --- */}

//       {/* --- Property Header Card --- */}
//       <Box sx={{ px: 2 }}>
//         <Card sx={{ borderRadius: 3, p: 2, boxShadow: '0 4px 20px rgba(139,74,43,0.08)', border: `1px solid ${COLORS.border}` }}>
//           <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
//             <Box sx={{ width: 80, height: 100, bgcolor: '#F5F5F5', borderRadius: 2, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, overflow: 'hidden' }}>
//               {currentThumb ? (
//                 <Box component="img" src={currentThumb} alt={project.name} sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
//               ) : (
//                 <Construction sx={{ fontSize: 40, color: '#D4A373' }} />
//               )}
//             </Box>
//             <Box sx={{ flex: 1 }}>
//               <Typography sx={{ fontSize: '14px', color: COLORS.primary, fontWeight: 700, mb: 0.5 }}>
//                 {/* {[project.builder, project.category].filter(Boolean).join(' • ')} */}
//                 {project.builder}
//               </Typography>
//               <Typography sx={{ fontSize: '18px', fontWeight: 800, color: COLORS.textDark, mb: 0.5, lineHeight: 1.2 }}>
//                 {project.name}
//               </Typography>
//                <Typography sx={{ fontSize: '14px', color: COLORS.primary, fontWeight: 700, mb: 0.5 }}>
//                 {project.category}
//               </Typography>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1 }}>
//                 <LocationOn sx={{ fontSize: 14, color: COLORS.textSecondary }} />
//                 <Typography sx={{ fontSize: '12px', color: COLORS.textSecondary }}>
//                   {project.exactlocation}
//                 </Typography>
//               </Box>
//               <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
//                 {project.rera && (
//                   <Chip label={project.rera} size="small" sx={{ bgcolor: COLORS.primaryDark, color: 'white', fontSize: '10px', fontWeight: 700, height: 22, borderRadius: 10 }} />
//                 )}
//                 {project.verified && (
//                   <Chip icon={<CheckCircle sx={{ fontSize: 12 }} />} label="Verified" size="small" sx={{ bgcolor: COLORS.greenBg, color: COLORS.green, fontSize: '10px', fontWeight: 700, height: 22, borderRadius: 10, '& .MuiChip-icon': { color: COLORS.green } }} />
//                 )}
//               </Box>
//             </Box>
//           </Box>

//           <Divider sx={{ my: 2, borderColor: COLORS.border, borderStyle: 'dashed' }} />

//           <Box sx={{ display: 'flex', gap: 4, alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
//             <Typography sx={{ fontSize: '13px', color: '#4B5563' }}>
//               <Box component="span" sx={{ fontWeight: 700, color: '#111827', mr: 0.5 }}>
//                 Possession:
//               </Box>
//               {show(project.possession)}
//             </Typography>

//             <Typography sx={{ fontSize: '13px', color: '#4B5563' }}>
//               <Box component="span" sx={{ fontWeight: 700, color: '#111827', mr: 0.5 }}>
//                 Type:
//               </Box>
//               {show(project.propertyType)}
//             </Typography>
//           </Box>
//         </Card>
//       </Box>

//       {/* --- Price & BHK Summary --- */}
//       <Box sx={{ px: 2, mt: 1 }}>
//         <Typography sx={{ fontSize: '28px', fontWeight: 800, color: '#6B3620', letterSpacing: '-0.5px' }}>
//           {project.priceRange || 'Price on Request'}
//         </Typography>
//         <Typography sx={{ fontSize: '12px', color: COLORS.textSecondary, letterSpacing: '1px', fontWeight: 600 }}>
//           PRICE RANGE
//         </Typography>

//         {(project.bhkTypes || project.propertyType) && (
//           <Typography sx={{ fontSize: '20px', fontWeight: 700, color: '#6B3620' }}>
//             {[isCommercial ? '' : project.bhkTypes, project.propertyType].filter(Boolean).join(' ')}
//           </Typography>
//         )}
//       </Box>

//       {/* --- Project Stats & Progress --- */}
//       <Box sx={{ px: 2, mt: 1 }}>
//         <Card
//           sx={{
//             borderRadius: 3,
//             p: 0.5,
//             boxShadow: 'none',
//             border: `1px solid ${COLORS.border}`,
//             bgcolor: '#FAFAFA',
//           }}
//         >
//           <Box
//             sx={{
//               display: 'grid',
//               gridTemplateColumns: '1fr 1fr',
//               rowGap: 2,
//               columnGap: 2,
//             }}
//           >
//             <Box>
//               <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary, mb: 0.5 }}>STATUS</Typography>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                 <Construction sx={{ fontSize: 16, color: COLORS.primary }} />
//                 <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.primary }}>
//                   {show(project.status)}
//                 </Typography>
//               </Box>
//             </Box>
//             <Box>
//               <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary, mb: 0.5 }}>POSSESSION</Typography>
//               <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.primary }}>
//                 {show(project.possession)}
//               </Typography>
//             </Box>
//             {!isPlot && (
//               <>
//                 <Box>
//                   <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary, mb: 0.5 }}>TOWERS</Typography>
//                   <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.primary }}>
//                     {show(project.towers)}
//                   </Typography>
//                 </Box>
//                 <Box>
//                   <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary, mb: 0.5 }}>FLOORS</Typography>
//                   <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.primary }}>
//                     {show(project.floors)}
//                   </Typography>
//                 </Box>
//               </>
//             )}
//             <Box>
//               <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary, mb: 0.5 }}>UNITS</Typography>
//               <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.primary }}>
//                 {show(project.units)}
//               </Typography>
//             </Box>
//             <Box>
//               <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary, mb: 0.5 }}>TOTAL PROJECT AREA</Typography>
//               <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.primary }}>
//                 {show(project.totalArea)}
//               </Typography>
//             </Box>
//           </Box>

//         </Card>
//       </Box>

//       {/* --- BHK Tabs (one tab per unique type) --- */}
//       {configGroups.length > 0 && (
//         <Box sx={{ mt: 1, px: 1, bgcolor: 'white' }}>
//           <Box
//             sx={{
//               display: 'flex',
//               gap: 1,
//               overflowX: 'auto',
//               '&::-webkit-scrollbar': { display: 'none' },
//             }}
//           >
//             {configGroups.map((group, idx) => {
//               const isActive = activeTab === idx;
//               return (
//                 <Box
//                   key={group.type}
//                   onClick={() => selectGroup(idx)}
//                   sx={{
//                     flex: '1 0 auto',
//                     minWidth: 60,
//                     px: 1.5,
//                     textAlign: 'center',
//                     py: 1,
//                     borderRadius: 2,
//                     border: `1px solid ${isActive ? COLORS.primaryDark : COLORS.border}`,
//                     bgcolor: isActive ? COLORS.primaryDark : 'white',
//                     color: isActive ? 'white' : COLORS.textDark,
//                     fontWeight: 700,
//                     fontSize: '12.5px',
//                     cursor: 'pointer',
//                     userSelect: 'none',
//                     whiteSpace: 'nowrap',
//                     transition: 'all 0.15s ease',
//                   }}
//                 >
//                   {getTypeLabel(group.type)}
//                   {group.items.length > 1 ? ` (${group.items.length})` : ''}
//                 </Box>
//               );
//             })}
//           </Box>
//         </Box>
//       )}

//       {/* --- Floor Plans & Pricing Content --- */}
//       <Box sx={{ p: 1 }}>
//         <Typography sx={{ fontSize: '20px', fontWeight: 800, color: COLORS.textDark }}>
//           Floor Plans & Pricing
//         </Typography>

//         {!activeGroup && <EmptyText>No configurations available for this property</EmptyText>}

//         {activeGroup && (
//           <Box sx={{ mb: 1 }}>
//             {/* Slider: one slide per configuration of the selected type */}
//             <Box
//               key={activeGroup.type}
//               onScroll={handlePlanScroll}
//               sx={{
//                 display: 'flex',
//                 gap: 1,
//                 overflowX: 'auto',
//                 scrollSnapType: 'x mandatory',
//                 WebkitOverflowScrolling: 'touch',
//                 '&::-webkit-scrollbar': { display: 'none' },
//                 scrollbarWidth: 'none',
//               }}
//             >
//               {activeGroup.items.map((cfg) => (
//                 <Box
//                   key={cfg.id}
//                   sx={{ flex: '0 0 100%', minWidth: 0, scrollSnapAlign: 'start' }}
//                 >
//                   {renderConfigCard(cfg)}
//                 </Box>
//               ))}
//             </Box>

//             {/* Dots + counter, only when there is more than one */}
//             {activeGroup.items.length > 1 && (
//               <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mt: 1 }}>
//                 <Box sx={{ display: 'flex', gap: '5px' }}>
//                   {activeGroup.items.map((cfg, i) => (
//                     <Box
//                       key={cfg.id}
//                       sx={{
//                         width: activeSlide === i ? 16 : 6,
//                         height: 6,
//                         borderRadius: 3,
//                         bgcolor: activeSlide === i ? COLORS.primaryDark : COLORS.border,
//                         transition: 'all 0.2s',
//                       }}
//                     />
//                   ))}
//                 </Box>
//                 <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary }}>
//                   {activeSlide + 1} / {activeGroup.items.length} · swipe →
//                 </Typography>
//               </Box>
//             )}
//           </Box>
//         )}

//         {/* Other types (one row per type, not per configuration) */}
//         {configGroups.map((group, idx) => {
//           if (idx === activeTab) return null;
//           const minPrice = groupMinPrice(group);
//           return (
//             <Paper
//               key={group.type}
//               onClick={() => selectGroup(idx)}
//               sx={{
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 alignItems: 'center',
//                 p: 1,
//                 mb: 0.5,
//                 borderRadius: 3,
//                 cursor: 'pointer',
//                 border: `1px solid ${COLORS.border}`,
//                 boxShadow: 'none',
//                 bgcolor: 'white',
//                 '&:hover': { bgcolor: '#FAFAFA' },
//               }}
//             >
//               <Typography sx={{ fontSize: '15px', fontWeight: 700, color: COLORS.textDark }}>
//                 {getTypeLabel(group.type)}
//                 {group.items.length > 1 ? ` (${group.items.length})` : ''}
//               </Typography>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                 <Typography sx={{ fontSize: '13px', fontWeight: 600, color: COLORS.primary }}>
//                   {minPrice !== undefined ? `Starting at ${formatPrice(minPrice)}` : 'Price on Request'}
//                 </Typography>
//                 <ChevronRight sx={{ color: COLORS.textSecondary, fontSize: 20 }} />
//               </Box>
//             </Paper>
//           );
//         })}
//       </Box>

//       {/* --- HIGHLIGHTS --- */}
//       <Box sx={{ px: 0.5 }}>
//         <Divider sx={{ borderColor: COLORS.border, mb: 0.5 }} />
//         <Card sx={{ borderRadius: 3, boxShadow: '0 2px 10px rgba(139,74,43,0.06)', border: `1px solid ${COLORS.border}` }}>
//           <CardContent sx={{ p: 0.5 }}>
//             <SectionHeaderWithViewAll
//               title="Property Highlights"
//               onViewAll={d.highlights.length > 8 ? () => setShowAllHighlights(!showAllHighlights) : null}
//               expanded={showAllHighlights}
//             />
//             <IconGrid items={visibleHighlights} emptyText="No highlights available for this property" />
//           </CardContent>
//         </Card>
//       </Box>

//       {/* --- AMENITIES --- */}
//       <Box sx={{ px: 0.5 }}>
//         <Card sx={{ borderRadius: 3, boxShadow: '0 2px 10px rgba(139,74,43,0.06)', border: `1px solid ${COLORS.border}` }}>
//           <CardContent sx={{ p: 0.5 }}>
//             <SectionHeaderWithViewAll
//               title="Amenities"
//               onViewAll={d.amenities.length > 8 ? () => setShowAllAmenities(!showAllAmenities) : null}
//               expanded={showAllAmenities}
//             />
//             <IconGrid items={visibleAmenities} emptyText="No amenities listed for this property" />
//           </CardContent>
//         </Card>
//       </Box>

//       {/* --- SPECIFICATIONS --- */}
//       <Box sx={{ px: 0.5 }}>
//         <Card sx={{ borderRadius: 3, border: `1px solid ${COLORS.border}`, boxShadow: '0 2px 10px rgba(139,74,43,0.06)' }}>
//           <CardContent sx={{ p: 0.5 }}>
//             <Typography variant="subtitle1" fontWeight="bold" sx={{ color: COLORS.textDark }}>
//               Specifications
//             </Typography>
//             {d.specifications.length === 0 && <EmptyText>No specifications listed for this property</EmptyText>}
//             {d.specifications.map((spec, idx, arr) => {
//               const IconComp = resolveIcon(spec.name);
//               return (
//                 <Box
//                   key={`${spec.name}-${idx}`}
//                   sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 0.5, borderBottom: idx < arr.length - 1 ? `1px solid ${COLORS.border}` : 'none' }}
//                 >
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//                     <IconComp sx={{ fontSize: 20, color: COLORS.primary }} />
//                     <Box>
//                       <Typography variant="body2" fontWeight={600} sx={{ color: COLORS.textDark }}>{spec.name}</Typography>
//                       <Typography variant="caption" sx={{ color: COLORS.textSecondary }}>{spec.value}</Typography>
//                     </Box>
//                   </Box>
//                 </Box>
//               );
//             })}
//           </CardContent>
//         </Card>
//       </Box>

//       {/* --- LOCATION --- */}
//       <Box sx={{ px: 0.5, mb: 1 }}>
//         <Card sx={{ borderRadius: 3, border: `1px solid ${COLORS.border}`, boxShadow: '0 2px 10px rgba(139,74,43,0.06)' }}>
//           <CardContent sx={{ p: 0.5 }}>
//             <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1, color: COLORS.textDark }}>
//               Location Advantages
//             </Typography>

//             {d.locationAdvantages.length === 0 && <EmptyText>No location details available</EmptyText>}
//             {d.locationAdvantages.map((item, index, arr) => {
//               const IconComp = resolveIcon(item.place_name);
//               return (
//                 <Box
//                   key={`${item.place_name}-${index}`}
//                   sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1.5, borderBottom: index < arr.length - 1 ? `1px solid ${COLORS.border}` : 'none' }}
//                 >
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//                     <IconComp sx={{ fontSize: 20, color: COLORS.primary }} />
//                     <Box>
//                       <Typography variant="body2" sx={{ color: COLORS.textDark, fontSize: 14, fontWeight: 600 }}>{item.place_name}</Typography>
//                       <Typography variant="caption" sx={{ color: COLORS.textSecondary }}>{item.distance}</Typography>
//                     </Box>
//                   </Box>
//                   <Typography sx={{ color: COLORS.blue, fontWeight: 600 }}>{item.travel_time}</Typography>
//                 </Box>
//               );
//             })}

//             <Box sx={{ mt: 2 }}>
//               <Button
//                 variant="outlined" fullWidth startIcon={<Map />}
//                 onClick={openGoogleMaps}
//                 disabled={!project.location && (project.lat === undefined || project.lng === undefined)}
//                 sx={{ borderRadius: 6, color: COLORS.primary, borderColor: COLORS.primary, fontWeight: 700, py: 1, '&:hover': { borderColor: COLORS.primaryDark, bgcolor: COLORS.primaryLight } }}
//               >
//                 View on Google Maps
//               </Button>
//             </Box>
//           </CardContent>
//         </Card>
//       </Box>

//       {/* --- ABOUT THE PROJECT --- */}
//       {project.description && (
//         <Box sx={{ px: 0.5, mb: 1 }}>
//           <Card
//             sx={{
//               borderRadius: 3,
//               border: `1px solid ${COLORS.border}`,
//               boxShadow: '0 2px 10px rgba(139,74,43,0.06)',
//             }}
//           >
//             <CardContent sx={{ p: 0.5 }}>
//               <Typography
//                 variant="subtitle1"
//                 fontWeight="bold"
//                 sx={{ mb: 1, color: COLORS.textDark }}
//               >
//                 About the Project
//               </Typography>

//               <Typography
//                 sx={{
//                   fontSize: '13px',
//                   color: COLORS.textSecondary,
//                   lineHeight: 1.6,
//                   whiteSpace: 'pre-line',
//                 }}
//               >
//                 {project.description}
//               </Typography>
//             </CardContent>
//           </Card>
//         </Box>
//       )}

//       {/* --- REQUEST CALLBACK --- */}
//       <Box id="bhk-request-callback" sx={{ px: 0.5 }}>
//         <Card sx={{ borderRadius: 3, border: `1px solid ${COLORS.border}`, boxShadow: '0 2px 10px rgba(139,74,43,0.06)' }}>
//           <CardContent sx={{ p: 0.5 }}>
//             <Typography variant="subtitle1" fontWeight="bold" sx={{ color: COLORS.textDark }}>
//               Request Callback
//             </Typography>

//             <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
//               <Box>
//                 <Typography variant="caption" sx={{ color: COLORS.textSecondary, fontWeight: 600 }}>Name</Typography>
//                 <TextField
//                   placeholder="Your full name" fullWidth size="small"
//                   value={contactForm.name}
//                   onChange={(e) => setContactForm({ ...contactForm, name: e.target.value })}
//                   sx={{ mt: 0.5, '& .MuiOutlinedInput-root': { bgcolor: COLORS.inputBg, borderRadius: 2, '& fieldset': { borderColor: COLORS.border } } }}
//                 />
//               </Box>
//               <Box>
//                 <Typography variant="caption" sx={{ color: COLORS.textSecondary, fontWeight: 600 }}>Phone</Typography>
//                 <TextField
//                   placeholder="+91 88765 43210" fullWidth size="small"
//                   value={contactForm.phone}
//                   onChange={(e) => setContactForm({ ...contactForm, phone: e.target.value })}
//                   sx={{ mt: 0.5, '& .MuiOutlinedInput-root': { bgcolor: COLORS.inputBg, borderRadius: 2, '& fieldset': { borderColor: COLORS.border } } }}
//                 />
//               </Box>
//               <Box>
//                 <Typography variant="caption" sx={{ color: COLORS.textSecondary, fontWeight: 600 }}>Email</Typography>
//                 <TextField
//                   placeholder="you@example.com" fullWidth size="small"
//                   value={contactForm.email}
//                   onChange={(e) => setContactForm({ ...contactForm, email: e.target.value })}
//                   sx={{ mt: 0.5, '& .MuiOutlinedInput-root': { bgcolor: COLORS.inputBg, borderRadius: 2, '& fieldset': { borderColor: COLORS.border } } }}
//                 />
//               </Box>
//               <Box>
//                 <Typography variant="caption" sx={{ color: COLORS.textSecondary, fontWeight: 600 }}>Preferred Time</Typography>
//                 <TextField
//                   select
//                   fullWidth
//                   size="small"
//                   value={contactForm.preferredTime}
//                   onChange={(e) =>
//                     setContactForm((prev) => ({
//                       ...prev,
//                       preferredTime: e.target.value,
//                     }))
//                   }
//                   sx={{
//                     mt: 0.5,
//                     "& .MuiOutlinedInput-root": {
//                       bgcolor: COLORS.inputBg,
//                       borderRadius: 2,
//                       "& fieldset": { borderColor: COLORS.border },
//                     },
//                   }}
//                 >
//                   <MenuItem value="morning">Morning (9-12)</MenuItem>
//                   <MenuItem value="afternoon">Afternoon (12-3)</MenuItem>
//                   <MenuItem value="evening">Evening (3-6)</MenuItem>
//                 </TextField>
//               </Box>
//               <Box>
//                 <Typography variant="caption" sx={{ color: COLORS.textSecondary, fontWeight: 600 }}>Message</Typography>
//                 <TextField
//                   placeholder="Type your message..." multiline rows={3} fullWidth
//                   value={contactForm.message}
//                   onChange={(e) => setContactForm({ ...contactForm, message: e.target.value })}
//                   sx={{ mt: 0.5, '& .MuiOutlinedInput-root': { bgcolor: COLORS.inputBg, borderRadius: 2, '& fieldset': { borderColor: COLORS.border } } }}
//                 />
//               </Box>
//             </Box>

//             <Button
//               variant="contained"
//               fullWidth
//               startIcon={<Phone />}
//               onClick={handleContactSubmit}
//               disabled={submitting || userLoading}
//               sx={{
//                 mt: 1,
//                 borderRadius: 2,
//                 bgcolor: COLORS.primary,
//                 py: 1.1,
//                 fontWeight: 700,
//                 textTransform: "none",
//                 "&:hover": { bgcolor: COLORS.primaryDark },
//               }}
//             >
//               {submitting ? "Submitting..." : "Request Callback"}
//             </Button>
//           </CardContent>
//         </Card>
//       </Box>

//       {/* --- NEARBY / SIMILAR --- */}
//       {(d.nearby.length > 0 || d.similar.length > 0) && (
//         <Box sx={{ px: 2, mb: 1 }}>
//           {d.nearby.length > 0 && (
//             <>
//               <SectionHeaderWithViewAll
//                 title="Nearby Projects"
//                 onViewAll={d.nearby.length > 2 ? () => setShowAllNearby(!showAllNearby) : null}
//                 expanded={showAllNearby}
//               />
//               <Grid container spacing={1.5}>
//                 {visibleNearby.map((proj) => (
//                   <Grid item xs={6} key={proj.id}>
//                     <ProjectCard proj={proj} />
//                   </Grid>
//                 ))}
//               </Grid>
//             </>
//           )}

//           {d.similar.length > 0 && (
//             <>
//               <Box sx={{ mt: 1 }}>
//                 <SectionHeaderWithViewAll
//                   title="Similar Projects"
//                   onViewAll={d.similar.length > 2 ? () => setShowAllSimilar(!showAllSimilar) : null}
//                   expanded={showAllSimilar}
//                 />
//               </Box>
//               <Grid container spacing={1.5}>
//                 {visibleSimilar.map((proj) => (
//                   <Grid item xs={6} key={proj.id}>
//                     <ProjectCard proj={proj} />
//                   </Grid>
//                 ))}
//               </Grid>
//             </>
//           )}
//         </Box>
//       )}

//     </Box>
//   );
// };

// export default BHKDescription;
import React, { useState, useEffect, useRef, useContext } from 'react';
import FavoriteBorder from '@mui/icons-material/FavoriteBorder';
import Favorite from '@mui/icons-material/Favorite';
import Share from '@mui/icons-material/Share';
import PersonIcon from '@mui/icons-material/Person';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box, Card, CardContent, Typography, Button, Grid, Chip,
  Divider, LinearProgress, Paper, TextField, MenuItem,
  CircularProgress, IconButton, Dialog, Modal, Backdrop,
} from '@mui/material';
import {
  Download, Phone, ChevronRight, LocationOn, CheckCircle,
  Construction, Security, Bolt, Groups, Pool, FitnessCenter,
  SportsEsports, DirectionsRun, ChildCare, Park, SelfImprovement,
  MeetingRoom, Theaters, Work, ElectricCar, LocalParking, Water,
  Videocam, ChildFriendly, Spa, HotTub, SportsTennis,
  SportsBasketball, SportsCricket, SportsSoccer, DirectionsBike,
  LocalLibrary, LocalCafe, Event, Hotel, Texture, Kitchen, Bathtub,
  FormatPaint, Home as HomeIcon, Map, Train, Flight, DirectionsBus,
  School, LocalHospital, ShoppingCart, ApartmentOutlined, Description,
  Gavel, AccountBalance, Star, ArrowBack, Close, CallOutlined,
} from '@mui/icons-material';

import axios from 'axios';
import { HiOutlinePhoto } from "react-icons/hi2";
import { CgPlayButtonO } from "react-icons/cg";
import { TbRotate360 } from "react-icons/tb";
import { AuthContext } from '../../AuthContext/AuthContext';

// --- IMPORT THE NEW CUSTOM MODALS ---
// Adjust paths based on where you saved them
import PhoneModal from './PhoneModal'; 
import MapModal from './MapModal';     

/* ------------------------------------------------------------------
   THEME
------------------------------------------------------------------ */
const COLORS = {
  primary: '#8B4A2B',
  primaryDark: '#6B3620',
  primaryLight: '#FBEEE0',
  bg: '#FFFFFF',
  cardBg: '#FFFFFF',
  chipDark: '#3D2B1F',
  green: '#2E7D32',
  greenBg: '#E8F5E9',
  blue: '#1565C0',
  textSecondary: '#8A7A6D',
  textDark: '#2B2118',
  border: '#F0E6DA',
  inputBg: '#FAF5EF',
};

/* ------------------------------------------------------------------
   API CONFIG
------------------------------------------------------------------ */
const API_ORIGIN = 'https://landnest.net:81';
const AD_API_URL = `${API_ORIGIN}/ad-properties/combined/`;
const ACTIVITIES_API = `${API_ORIGIN}/activities/`;
const USER_CART_API = `${API_ORIGIN}/user-cart/`;

/* ------------------------------------------------------------------
   AMENITY CATEGORIES
------------------------------------------------------------------ */
const AMENITY_CATEGORIES = [
  "Recreation",
  "Fitness & Wellness",
  "Sports",
  "Security",
  "Utilities",
  "Building Facilities",
  "Family & Convenience",
];

const AMENITY_CATEGORY_MAP = {
  "Swimming Pool": "Recreation", "Kids Pool": "Recreation", "Club House": "Recreation",
  "Indoor Games": "Recreation", "Mini Theatre": "Recreation", "Party Hall": "Recreation",
  "Library": "Recreation", "Cafe": "Recreation", "Guest Rooms": "Recreation",
  "Gym": "Fitness & Wellness", "Yoga Room": "Fitness & Wellness", "Jogging Track": "Fitness & Wellness",
  "Cycling Track": "Fitness & Wellness", "Spa": "Fitness & Wellness", "Sauna": "Fitness & Wellness",
  "Steam Room": "Fitness & Wellness", "Meditation Area": "Fitness & Wellness", "Fitness Centre": "Fitness & Wellness",
  "Tennis Court": "Sports", "Basketball Court": "Sports", "Badminton Court": "Sports",
  "Cricket Net": "Sports", "Football Field": "Sports", "Table Tennis": "Sports",
  "Volleyball Court": "Sports", "Skating Area": "Sports", "Kids Play Area": "Sports",
  "24x7 Security": "Security", "CCTV Surveillance": "Security", "Video Door Phone": "Security",
  "Intercom": "Security", "Gated Entry": "Security", "Visitor Mgmt": "Security",
  "Fire Safety": "Security", "Access Control": "Security", "Emergency Exit": "Security",
  "Power Backup": "Utilities", "Water Supply": "Utilities", "Rainwater Harvesting": "Utilities",
  "Sewage Treatment": "Utilities", "Waste Mgmt": "Utilities", "Solar Power": "Utilities",
  "EV Charging": "Utilities", "Gas Pipeline": "Utilities", "STP / WTP": "Utilities",
  "High Speed Lift": "Building Facilities", "Lobby": "Building Facilities", "Reception": "Building Facilities",
  "Waiting Area": "Building Facilities", "Basement Parking": "Building Facilities",
  "Maintenance": "Building Facilities", "Housekeeping": "Building Facilities",
  "Service Lift": "Building Facilities", "Common Terrace": "Building Facilities",
  "Creche/Day Care": "Family & Convenience", "Senior Citizen Area": "Family & Convenience",
  "Convenience Store": "Family & Convenience", "Pharmacy": "Family & Convenience",
  "ATM": "Family & Convenience", "Salon": "Family & Convenience", "Laundry": "Family & Convenience",
  "Medical Centre": "Family & Convenience",
};

const CATEGORY_KEYWORDS = [
  { cat: "Recreation", keys: ["pool", "club house", "indoor games", "mini theatre", "party hall", "library", "cafe", "guest room"] },
  { cat: "Fitness & Wellness", keys: ["gym", "yoga", "jogging", "cycling", "spa", "sauna", "steam", "meditation", "fitness"] },
  { cat: "Sports", keys: ["tennis", "basketball", "badminton", "cricket", "football", "table tennis", "volleyball", "skating", "kids play", "play area"] },
  { cat: "Security", keys: ["security", "cctv", "video door", "intercom", "gated entry", "visitor", "fire safety", "access control", "emergency exit"] },
  { cat: "Utilities", keys: ["power backup", "water supply", "rainwater", "rain water", "sewage", "waste", "solar", "ev charging", "gas pipeline", "stp", "wtp"] },
  { cat: "Building Facilities", keys: ["lift", "lobby", "reception", "waiting", "basement parking", "maintenance", "housekeeping", "terrace"] },
  { cat: "Family & Convenience", keys: ["creche", "day care", "senior citizen", "convenience", "store", "pharmacy", "atm", "salon", "laundry", "medical"] },
];

const getAmenityCategory = (name = "") => {
  if (AMENITY_CATEGORY_MAP[name]) return AMENITY_CATEGORY_MAP[name];
  const lower = String(name).toLowerCase();
  for (const { cat, keys } of CATEGORY_KEYWORDS) {
    if (keys.some((k) => lower.includes(k))) return cat;
  }
  return "Other";
};

const groupAmenitiesByCategory = (amenities = []) => {
  const groups = {};
  amenities.forEach((name) => {
    const cat = getAmenityCategory(name);
    if (!groups[cat]) groups[cat] = [];
    groups[cat].push(name);
  });
  return groups;
};

/* ------------------------------------------------------------------
   ICON RESOLUTION
------------------------------------------------------------------ */
const ICON_KEYWORDS = [
  { keys: ['security', 'cctv', 'guard', '24'], icon: Security },
  { keys: ['power', 'backup', 'electrical', 'bolt'], icon: Bolt },
  { keys: ['club', 'community'], icon: Groups },
  { keys: ['swim', 'pool'], icon: Pool },
  { keys: ['gym', 'fitness'], icon: FitnessCenter },
  { keys: ['indoor', 'game', 'sports esports'], icon: SportsEsports },
  { keys: ['jog', 'run', 'track'], icon: DirectionsRun },
  { keys: ['child', 'kid', 'play'], icon: ChildCare },
  { keys: ['senior', 'park', 'garden', 'landscape'], icon: Park },
  { keys: ['yoga', 'meditation'], icon: SelfImprovement },
  { keys: ['multipurpose', 'hall', 'banquet', 'party'], icon: MeetingRoom },
  { keys: ['theatre', 'theater', 'cinema'], icon: Theaters },
  { keys: ['co-work', 'cowork', 'office', 'business', 'lounge'], icon: Work },
  { keys: ['ev', 'electric', 'charging'], icon: ElectricCar },
  { keys: ['visitor', 'parking'], icon: LocalParking },
  { keys: ['rain', 'water', 'harvest'], icon: Water },
  { keys: ['cctv', 'camera', 'surveillance'], icon: Videocam },
  { keys: ['kids pool', 'child pool'], icon: ChildFriendly },
  { keys: ['spa'], icon: Spa },
  { keys: ['sauna', 'hot tub', 'jacuzzi'], icon: HotTub },
  { keys: ['badminton', 'tennis'], icon: SportsTennis },
  { keys: ['basketball'], icon: SportsBasketball },
  { keys: ['cricket', 'net'], icon: SportsCricket },
  { keys: ['football', 'soccer', 'turf'], icon: SportsSoccer },
  { keys: ['cycling', 'bike'], icon: DirectionsBike },
  { keys: ['library', 'reading'], icon: LocalLibrary },
  { keys: ['cafe', 'coffee'], icon: LocalCafe },
  { keys: ['event', 'auditorium'], icon: Event },
  { keys: ['hotel', 'guest', 'room'], icon: Hotel },
  { keys: ['flooring', 'floor', 'texture'], icon: Texture },
  { keys: ['kitchen', 'modular'], icon: Kitchen },
  { keys: ['bathroom', 'bath', 'toilet'], icon: Bathtub },
  { keys: ['painting', 'paint'], icon: FormatPaint },
  { keys: ['smart', 'home', 'automation'], icon: HomeIcon },
  { keys: ['door', 'window'], icon: MeetingRoom },
  { keys: ['metro', 'train', 'railway'], icon: Train },
  { keys: ['airport', 'flight'], icon: Flight },
  { keys: ['bus', 'transit'], icon: DirectionsBus },
  { keys: ['school', 'college', 'education'], icon: School },
  { keys: ['hospital', 'clinic', 'medical'], icon: LocalHospital },
  { keys: ['mall', 'shopping', 'market'], icon: ShoppingCart },
  { keys: ['it park', 'tech', 'office park'], icon: ApartmentOutlined },
  { keys: ['brochure', 'document', 'pdf'], icon: Description },
  { keys: ['legal', 'rera', 'approval'], icon: Gavel },
  { keys: ['bank', 'loan', 'finance'], icon: AccountBalance },
];

const resolveIcon = (label = '') => {
  const lower = String(label).toLowerCase();
  for (const { keys, icon } of ICON_KEYWORDS) {
    if (keys.some((k) => lower.includes(k))) return icon;
  }
  return CheckCircle;
};

/* ------------------------------------------------------------------
   FORMATTERS
------------------------------------------------------------------ */
const formatPrice = (price) => {
  if (!price && price !== 0) return 'Price on Request';
  if (price >= 10000000) return `₹${(price / 10000000).toFixed(price % 10000000 === 0 ? 0 : 2)}Cr`;
  if (price >= 100000) return `₹${(price / 100000).toFixed(price % 100000 === 0 ? 0 : 1)}L`;
  return `₹${Number(price).toLocaleString()}`;
};

const formatPriceLong = (price) => {
  if (price === undefined || price === null) return 'Price on Request';
  if (price >= 10000000) return `₹${parseFloat((price / 10000000).toFixed(2))} Crores`;
  if (price >= 100000) return `₹${parseFloat((price / 100000).toFixed(2))} Lakhs`;
  return `₹${Number(price).toLocaleString()}`;
};

const formatDate = (d) =>
  d ? new Date(d).toLocaleDateString('en-IN', { month: 'short', year: 'numeric' }) : '';

const prettyBhk = (raw) => {
  if (!raw) return 'Unit';
  return String(raw).replace(/(\d+\+?)\s*BHK/i, '$1 BHK').trim();
};

const BHK_SORT = (a, b) => {
  const num = (s) => {
    const m = String(s || '').match(/(\d+)/);
    return m ? parseInt(m[1], 10) : 999;
  };
  return num(a) - num(b);
};

const isEmpty = (v) =>
  v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0);

const show = (v) => (isEmpty(v) ? '—' : String(v));

const withUnit = (v, unit) => {
  if (isEmpty(v)) return '';
  return /^[\d.,]+$/.test(String(v).trim()) ? `${v} ${unit}` : String(v);
};

const getImageUrl = (imagePath) => {
  if (!imagePath) return '';
  if (typeof imagePath !== 'string') return '';
  if (imagePath.startsWith('http') || imagePath.startsWith('data:')) return imagePath;
  return `${API_ORIGIN}${imagePath.startsWith('/') ? '' : '/'}${imagePath}`;
};

/* ------------------------------------------------------------------
   ADAPTER
------------------------------------------------------------------ */
const labelOf = (item) => {
  if (item === undefined || item === null) return '';
  if (typeof item !== 'object') return String(item);
  return String(item.name || item.title || item.label || '');
};

const normalizeProject = (proj, i) => {
  const name = proj.name || proj.property_name || 'Project';
  const area = proj.area || proj.location || proj.city || '';
  const bhk = proj.bhk || proj.bhk_type || '';
  const priceRange =
    proj.priceRange || proj.price_range ||
    (proj.min_budget && proj.max_budget
      ? `${formatPrice(proj.min_budget)} - ${formatPrice(proj.max_budget)}`
      : '');
  return {
    id: proj.id ?? proj.property_id ?? i,
    name, area, bhk, priceRange,
    rating: proj.rating,
    rera: !!(proj.rera || proj.rera_number || proj.is_rera_approved),
    image: getImageUrl(proj.image || proj.hero_image || (proj.hero_images && proj.hero_images[0]?.image) || ''),
  };
};

const EMPTY_DATA = {
  project: {}, configs: [], highlights: [], amenities: [], specifications: [],
  locationAdvantages: [], legal: {}, brochures: [], nearby: [], similar: [],
  media: { photos: 0, videos: [], video: '', tour: '' },
};

const normalizeProperty = (property) => {
  const p = property || {};

  const configs = (p.configurations || [])
    .slice()
    .sort((a, b) => BHK_SORT(a.bhk_type, b.bhk_type))
    .map((c, i) => ({
      id: c.id ?? i,
      bhk_type: prettyBhk(c.bhk_type),
      price: c.price,
      carpet_area: c.carpet_area,
      built_up_area: c.built_up_area,
      super_built_up_area: c.super_built_up_area,
      bathrooms: c.bathrooms,
      facing: c.facing,
      parking: c.parking,
      balcony: c.balcony,
      status: c.status,
      floor: c.floor,
      road_frontage: c.road_frontage,
      ceiling_height: c.ceiling_height,
      washrooms: c.washrooms,
      power_backup: c.power_backup,
      ownership: c.ownership,
      images: (c.floor_plan_images || []).map((im) => getImageUrl(im.image)).filter(Boolean),
      brochure: getImageUrl((c.floor_plan_images || [])[0]?.image || ''),
    }));

  const highlights = (p.property_highlights || [])
    .map((h) => ({ name: h.name || '', iconSlug: h.icon || '' }))
    .filter((h) => h.name);

  const amenities = (p.property_amenities || [])
    .map((a) => ({ name: a.name || '', iconSlug: a.icon || '' }))
    .filter((a) => a.name);

  const specifications = (p.specifications || [])
    .map((s) => ({ name: s.name || '', value: s.value || '' }))
    .filter((s) => s.name);

  const locationAdvantages = (p.location_advantages || [])
    .map((l) => ({
      place_name: l.place_name || '',
      distance: withUnit(l.distance, 'km'),
      travel_time: withUnit(l.travel_time, 'min'),
    }))
    .filter((l) => l.place_name);

  const brochures = (p.brochures || [])
    .map((doc, i) => ({
      id: doc.id ?? i,
      title: doc.title || 'Document',
      url: getImageUrl(doc.document),
      uploadedAt: doc.uploaded_at ? formatDate(doc.uploaded_at) : '',
    }))
    .filter((b) => !!b.url);

  const legal = {
    bankApproved: p.bank_approved || '',
    approvalStatus: p.approval_status || (p.status ? 'Approved' : ''),
    governmentApprovals: p.government_approvals || '',
    legalClearances: p.legal_clearances || (brochures.length > 0 ? 'All Clear' : ''),
  };

  const cfgPrices = configs.map((c) => c.price).filter((n) => n !== undefined && n !== null);
  const priceRange =
    p.min_budget && p.max_budget
      ? p.min_budget === p.max_budget
        ? formatPrice(p.min_budget)
        : `${formatPrice(p.min_budget)} - ${formatPrice(p.max_budget)}`
      : cfgPrices.length
        ? (Math.min(...cfgPrices) === Math.max(...cfgPrices)
          ? formatPrice(Math.min(...cfgPrices))
          : `${formatPrice(Math.min(...cfgPrices))} - ${formatPrice(Math.max(...cfgPrices))}`)
        : '';

  const heroImages = Array.isArray(p.hero_images) ? p.hero_images : [];

  const sortedHeroImages = heroImages
    .slice()
    .sort((a, b) => (a.order || 0) - (b.order || 0))
    .map((im) => getImageUrl(im.image))
    .filter(Boolean);

  const rawVideos =
    (Array.isArray(p.videos) && p.videos) ||
    (Array.isArray(p.video_urls) && p.video_urls) ||
    (Array.isArray(p.hero_videos) && p.hero_videos) ||
    [];

  let sortedVideos = rawVideos
    .slice()
    .sort((a, b) => (a.order || 0) - (b.order || 0))
    .map((v) => getImageUrl(v?.video || v?.url || v?.video_url || v?.file || v))
    .filter(Boolean);

  if (sortedVideos.length === 0) {
    const single = getImageUrl(p.video || p.video_url || '');
    if (single) sortedVideos = [single];
  }

  const project = {
    propertyId: p.property_id,
    builder: p.builder_details?.builder_name || '',
    name: p.property_name || '',
    location: [p.address, p.city].filter(Boolean).join(', '),
    exactlocation: p.location,
    lat: p.lat,
    lng: p.long,
    priceRange,
    bhkTypes: [...new Set(configs.map((c) => c.bhk_type))].join(', '),
    status: p.possession_status ? 'Active' : '',
    possession: formatDate(p.possession_date) || 'Ready to Move',
    towers: p.towers || p.total_towers || '',
    floors: p.floors || p.overall_floors || '',
    units: p.units || p.total_units || '',
    totalArea: withUnit(p.site_area || p.project_area, 'sq.ft'),
    constructionProgress: Number(p.construction_progress) || 0,
    rera: p.rera_number ? 'RERA APPROVED' : '',
    verified: !!p.status,
    propertyType: p.property_type || '',
    category: p.property_type || '',
    description: p.description || '',
    phone: p.user_mobile_no || '',
    sellerName: p.user_first_name || p.user_last_name || 'Property Owner',
    sellerMobile: p.user_mobile_no || p.mobile_no || '',
    sellerEmail: p.user_email || '',
    ownerId: p.user_id ?? p.user ?? p.posted_by_id ?? p.owner_id ?? null,
    postedBy: p.posted_by || 'Owner',
    createdAt: p.created_at || '',
    cover: sortedHeroImages[0] || '',
    covers: sortedHeroImages,
    videos: sortedVideos,
    logo: getImageUrl(p.logo_image || ''),
    logoFallback: sortedHeroImages[0] || '',
  };

  return {
    project, configs, highlights, amenities, specifications,
    locationAdvantages, legal, brochures,
    nearby: (p.nearby_projects || p.nearbyProjects || p.nearby || []).map(normalizeProject),
    similar: (p.similar_projects || p.similarProjects || []).map(normalizeProject),
    media: {
      photos: heroImages.length,
      videos: sortedVideos,
      video: sortedVideos[0] || '',
      tour: getImageUrl(p.virtual_tour || p.virtual_tour_url || ''),
    },
  };
};

/* ------------------------------------------------------------------
   Reusable components
------------------------------------------------------------------ */
const IconGrid = ({ items, emptyText }) => {
  if (!items || items.length === 0) {
    return (
      <Typography variant="body2" sx={{ color: COLORS.textSecondary, textAlign: 'center', py: 1 }}>
        {emptyText || 'Not available'}
      </Typography>
    );
  }
  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px' }}>
      {items.map((raw) => {
        const name = typeof raw === 'string' ? raw : raw.name;
        const IconComp = resolveIcon(name);
        return (
          <Box
            key={name}
            sx={{
              display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center',
              borderRadius: '10px', border: `1px solid ${COLORS.border}`,
              backgroundColor: COLORS.cardBg, minHeight: '60px', justifyContent: 'center', overflow: 'hidden',
            }}
          >
            <IconComp sx={{ fontSize: 24, color: COLORS.primary }} />
            <Typography sx={{ fontSize: '10.5px', fontWeight: 600, color: COLORS.textDark, lineHeight: 1.2, wordBreak: 'break-word' }}>
              {name}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

const SectionHeaderWithViewAll = ({ title, onViewAll, expanded }) => (
  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <Typography variant="subtitle1" fontWeight="bold" sx={{ color: COLORS.textDark }}>{title}</Typography>
    {onViewAll && (
      <Typography
        variant="body2"
        onClick={onViewAll}
        sx={{ color: COLORS.blue, fontWeight: 600, cursor: 'pointer' }}
      >
        {expanded ? 'Show Less' : 'View All'}
      </Typography>
    )}
  </Box>
);

const NearbyImagePlaceholder = ({ image }) =>
  image ? (
    <Box component="img" src={image} alt="" sx={{ width: '100%', height: 90, objectFit: 'cover', display: 'block' }} />
  ) : (
    <Box sx={{ width: '100%', height: 90, bgcolor: '#F5F5F5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Construction sx={{ fontSize: 28, color: '#D4A373' }} />
    </Box>
  );

const ProjectCard = ({ proj }) => (
  <Card sx={{ borderRadius: 3, border: `1px solid ${COLORS.border}`, boxShadow: 'none', overflow: 'hidden' }}>
    <NearbyImagePlaceholder image={proj.image} />
    <CardContent sx={{ p: 1, '&:last-child': { pb: 1 } }}>
      <Typography variant="body2" fontWeight="bold" sx={{ color: COLORS.textDark }} noWrap>{proj.name}</Typography>
      <Typography variant="caption" sx={{ color: COLORS.textSecondary, display: 'block' }} noWrap>
        {[proj.area, proj.bhk].filter(Boolean).join(' • ')}
      </Typography>
      <Typography variant="body2" fontWeight="bold" sx={{ color: COLORS.blue, mt: 0.5 }}>{proj.priceRange}</Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 0.5 }}>
        {proj.rera ? (
          <Chip label="RERA" size="small" sx={{ bgcolor: COLORS.chipDark, color: 'white', fontSize: '0.65rem', height: 20 }} />
        ) : <span />}
        {!isEmpty(proj.rating) && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
            <Star sx={{ fontSize: 14, color: '#F5A623' }} />
            <Typography variant="caption" fontWeight="bold">{proj.rating}</Typography>
          </Box>
        )}
      </Box>
    </CardContent>
  </Card>
);

const EmptyText = ({ children }) => (
  <Typography variant="body2" sx={{ color: COLORS.textSecondary, textAlign: 'center', py: 3 }}>
    {children}
  </Typography>
);

/* ================================================================== */
const BHKDescription = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [userLoading, setUserLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [showCallbackForm, setShowCallbackForm] = useState(false);

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);
  const { userId } = useContext(AuthContext);

  const [activeTab, setActiveTab] = useState(0);
  const [activeSlide, setActiveSlide] = useState(0);

  const [showAllHighlights, setShowAllHighlights] = useState(false);
  const [showAllNearby, setShowAllNearby] = useState(false);
  const [showAllSimilar, setShowAllSimilar] = useState(false);

  const [selectedAmenityCategory, setSelectedAmenityCategory] = useState('All');

  const [heroIndex, setHeroIndex] = useState(0);
  const heroScrollRef = useRef(null);

  // ---- Wishlist (user cart) state ----
  const [cartId, setCartId] = useState(null);
  const [wishlistBusy, setWishlistBusy] = useState(false);
  const wishlistLock = useRef(false); 
  const isWishlisted = Boolean(cartId);

  // ---- Floor plan image lightbox state ----
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImages, setLightboxImages] = useState([]);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const [lightboxTitle, setLightboxTitle] = useState('');

  // --- NEW MODAL STATES ---
  const [showPhoneModal, setShowPhoneModal] = useState(false);
  const [showMapModal, setShowMapModal] = useState(false);

  const [contactForm, setContactForm] = useState({
    name: "", phone: "", email: "",
    preferredTime: "morning", message: "",
  });

  useEffect(() => {
    if (!userId) return;
    console.log("Fetching user details for userId:", userId);

    const fetchUserDetails = async () => {
      try {
        setUserLoading(true);
        const response = await fetch(
          `https://landnest.net:81/users/${userId}/`,
          { headers: { Accept: "application/json" } }
        );
        if (!response.ok) throw new Error("Failed to fetch user details");
        const user = await response.json();
        setContactForm((prev) => ({
          ...prev,
          name: `${user.first_name || ""} ${user.last_name || ""}`.trim() || user.username || "",
          phone: user.mobile_no || "",
          email: user.email || "",
        }));
      } catch (error) {
        console.error("Error fetching user details:", error);
      } finally {
        setUserLoading(false);
      }
    };
    fetchUserDetails();
  }, [userId]);

  useEffect(() => {
    if (!userId || !id) {
      setCartId(null);
      return;
    }
    let cancelled = false;

    (async () => {
      try {
        const res = await axios.get(`${API_ORIGIN}/get-user-cart/${userId}/`);
        const raw = res.data;
        const list = Array.isArray(raw) ? raw : raw?.data || raw?.results || [];

        const match = list.find((item) => {
          if (item.property_source && item.property_source !== 'AdProperty') return false;
          const adId =
            item.ad_property && typeof item.ad_property === 'object'
              ? item.ad_property.property_id ?? item.ad_property.id
              : item.ad_property;
          return adId !== null && adId !== undefined && String(adId) === String(id);
        });

        if (!cancelled) setCartId(match ? match.cart_id : null);
      } catch (err) {
        console.error('Error loading user cart:', err.message);
      }
    })();

    return () => { cancelled = true; };
  }, [userId, id]);

  useEffect(() => {
    if (!id) {
      setError('No property id in the URL');
      setLoading(false);
      return;
    }
    const controller = new AbortController();

    (async () => {
      try {
        setLoading(true);
        setError(null);
        const res = await fetch(`${AD_API_URL}${id}/`, {
          signal: controller.signal,
          headers: { Accept: 'application/json' },
        });
        if (!res.ok) throw new Error(`Request failed (${res.status})`);
        const json = await res.json();
        console.log('[BHKDescription] raw API response:', json);

        let property = json?.data ?? json;
        if (Array.isArray(property)) {
          property = property.find((it) => String(it.property_id) === String(id)) || property[0];
        }
        setData(normalizeProperty(property));
        setActiveTab(0);
        setActiveSlide(0);
        setHeroIndex(0);
        setSelectedAmenityCategory('All');
      } catch (e) {
        if (e.name !== 'AbortError') setError(e.message || 'Something went wrong');
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    })();

    return () => controller.abort();
  }, [id, reloadKey]);

  useEffect(() => {
    const container = heroScrollRef.current;
    if (!container) return;
    const items = container.querySelectorAll('[data-media-type]');
    items.forEach((el) => {
      const mediaType = el.getAttribute('data-media-type');
      const idx = Number(el.getAttribute('data-media-index'));
      if (mediaType === 'video' && idx !== heroIndex) {
        const vid = el.querySelector('video');
        if (vid) { try { vid.pause(); } catch (e) { /* ignore */ } }
      }
    });
  }, [heroIndex]);

  useEffect(() => {
    if (!lightboxOpen) return;
    const handleKey = (e) => {
      if (e.key === 'Escape') setLightboxOpen(false);
      else if (e.key === 'ArrowRight') setLightboxIndex((i) => Math.min(i + 1, lightboxImages.length - 1));
      else if (e.key === 'ArrowLeft') setLightboxIndex((i) => Math.max(i - 1, 0));
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [lightboxOpen, lightboxImages.length]);

  const logActivity = (activityType, status = true) => {
    if (!userId) return Promise.resolve();

    const payload = {
      user_id: Number(userId),
      property_source: 'AdProperty',
      ad_property: Number(id),
      activity_type: activityType,
      activity_as: 'Buyer',
      status,
    };

    const ownerId = data?.project?.ownerId;
    if (ownerId !== null && ownerId !== undefined && ownerId !== '') {
      payload.property_by = Number(ownerId);
    }

    return axios
      .post(ACTIVITIES_API, payload)
      .catch((err) =>
        console.error(`Activity log failed (${activityType}):`, err.response?.data || err.message)
      );
  };

  const toggleWishlist = async () => {
    if (!userId) {
      alert('Please log in to add this property to your wishlist.');
      return;
    }
    if (wishlistLock.current) return;
    wishlistLock.current = true;
    setWishlistBusy(true);

    const previousCartId = cartId;

    try {
      if (previousCartId) {
        setCartId(null); 
        try {
          await axios.delete(`${USER_CART_API}${previousCartId}/`);
          logActivity('Liked', false);
        } catch (err) {
          setCartId(previousCartId); 
          console.error('Error removing from wishlist:', err.response?.data || err.message);
        }
      } else {
        setCartId('pending'); 
        try {
          const res = await axios.post(USER_CART_API, {
            user_id: Number(userId),
            property_source: 'AdProperty',
            ad_property: Number(id),
            activity_as: null,
            status: true,
          });

          const newCartId = res.data?.cart_id ?? res.data?.data?.cart_id;

          if (newCartId) {
            setCartId(newCartId);
          } else {
            const cartRes = await axios.get(`${API_ORIGIN}/get-user-cart/${userId}/`);
            const raw = cartRes.data;
            const list = Array.isArray(raw) ? raw : raw?.data || raw?.results || [];
            const match = list.find((item) => {
              const adId =
                item.ad_property && typeof item.ad_property === 'object'
                  ? item.ad_property.property_id ?? item.ad_property.id
                  : item.ad_property;
              return String(adId) === String(id);
            });
            setCartId(match ? match.cart_id : 'pending');
          }
          logActivity('Liked', true);
        } catch (err) {
          setCartId(null); 
          console.error('Error adding to wishlist:', err.response?.data || err.message);
        }
      }
    } finally {
      wishlistLock.current = false;
      setWishlistBusy(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: COLORS.bg }}>
        <CircularProgress sx={{ color: COLORS.primary }} />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2, px: 3, textAlign: 'center', backgroundColor: COLORS.bg }}>
        <Typography sx={{ color: COLORS.textDark, fontWeight: 700 }}>Couldn't load this property</Typography>
        <Typography variant="body2" sx={{ color: COLORS.textSecondary }}>{error}</Typography>
        <Button
          variant="contained"
          onClick={() => setReloadKey((k) => k + 1)}
          sx={{ borderRadius: 2, bgcolor: COLORS.primary, textTransform: 'none', fontWeight: 700, '&:hover': { bgcolor: COLORS.primaryDark } }}
        >
          Try again
        </Button>
      </Box>
    );
  }

  const d = data || EMPTY_DATA;
  const { project, configs, media, legal, brochures } = d;

  const typeLower = String(project.propertyType || '').toLowerCase();
  const isCommercial = typeLower.includes('commercial');
  const isPlot = typeLower.includes('plot') || typeLower.includes('land');

  const typeSuffix = typeLower.includes('apartment')
    ? 'Flats'
    : typeLower.includes('villa')
      ? 'Villa'
      : typeLower.includes('independent')
        ? 'Independent House'
        : '';

  const getTypeLabel = (type) => (typeSuffix ? `${type} ${typeSuffix}` : type);

  const getConfigFields = (cfg) => {
    if (isPlot) {
      return [
        { label: 'Status', value: show(cfg.status) },
        { label: 'Facing', value: show(cfg.facing) },
        { label: 'Area', value: show(withUnit(cfg.carpet_area, 'sqft')) },
        { label: 'Price', value: formatPrice(cfg.price) },
      ];
    }
    if (isCommercial) {
      return [
        { label: 'Status', value: show(cfg.status) },
        { label: 'Price', value: formatPrice(cfg.price) },
        { label: 'Built-up Area', value: show(withUnit(cfg.built_up_area, 'sqft')) },
        { label: 'Carpet Area', value: show(withUnit(cfg.carpet_area, 'sqft')) },
        { label: 'Floor', value: show(cfg.floor) },
        { label: 'Facing', value: show(cfg.facing) },
        { label: 'Road Frontage', value: show(withUnit(cfg.road_frontage, 'ft')) },
        { label: 'Ceiling Height', value: show(withUnit(cfg.ceiling_height, 'ft')) },
        { label: 'Washrooms', value: show(cfg.washrooms) },
        { label: 'Parking', value: show(cfg.parking) },
        { label: 'Power Backup', value: show(cfg.power_backup) },
        { label: 'Ownership', value: show(cfg.ownership) },
      ];
    }
    return [
      { label: 'Carpet Area', value: show(withUnit(cfg.carpet_area, 'sqft')) },
      { label: 'Built-up Area', value: show(withUnit(cfg.built_up_area, 'sqft')) },
      { label: 'Super Built-up', value: show(withUnit(cfg.super_built_up_area, 'sqft')) },
      { label: 'Price', value: formatPrice(cfg.price) },
      { label: 'Bathrooms', value: show(cfg.bathrooms) },
      { label: 'Facing', value: show(cfg.facing) },
      { label: 'Parking', value: show(cfg.parking) },
      { label: 'Balcony', value: show(cfg.balcony) },
    ];
  };

  const openLightbox = (images, startIndex = 0, title = '') => {
    const valid = (images || []).filter(Boolean);
    if (!valid.length) return;
    setLightboxImages(valid);
    setLightboxIndex(Math.min(Math.max(0, startIndex), valid.length - 1));
    setLightboxTitle(title);
    setLightboxOpen(true);
  };

  const openUrl = (url) => { if (url) window.open(url, '_blank', 'noopener'); };

  const downloadFile = (documentPath) => {
    if (!documentPath) return;

    const baseUrl = "https://landnest.net:81";

    const fileUrl = documentPath.startsWith("http")
      ? documentPath
      : `${baseUrl}${documentPath}`;

    const fileName = documentPath.split("/").pop() || "brochure.pdf";

    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = fileName;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const openGoogleMaps = () => {
    const query =
      project.lat !== undefined && project.lng !== undefined
        ? `${project.lat},${project.lng}`
        : project.location;
    window.open(`https://www.google.com/maps?q=${encodeURIComponent(query)}`, '_blank');
  };

  // ✅ "View on Map": Opens the Map Modal popup
  const handleViewMap = () => {
    logActivity('Location', true);
    setShowMapModal(true);
  };

  // ✅ "View Number": Opens the Phone Modal popup
  const handleViewNumber = () => {
    logActivity('Call', true);
    setShowPhoneModal(true);
  };

  const scrollToCallback = () => {
    setShowCallbackForm(true);

    setTimeout(() => {
      document.getElementById('bhk-request-callback')?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }, 100);
  };

  const configGroups = [];
  configs.forEach((cfg) => {
    let group = configGroups.find((g) => g.type === cfg.bhk_type);
    if (!group) {
      group = { type: cfg.bhk_type, items: [] };
      configGroups.push(group);
    }
    group.items.push(cfg);
  });

  const activeGroup = configGroups[activeTab] || null;

  const groupMinPrice = (group) => {
    const prices = group.items.map((c) => c.price).filter((n) => n !== undefined && n !== null);
    return prices.length ? Math.min(...prices) : undefined;
  };

  const handlePlanScroll = (e) => {
    const el = e.currentTarget;
    if (!el.clientWidth) return;
    setActiveSlide(Math.round(el.scrollLeft / el.clientWidth));
  };

  const selectGroup = (idx) => {
    setActiveTab(idx);
    setActiveSlide(0);
  };

  const renderConfigCard = (cfg) => {
    const cfgImages = cfg.images.length > 0 ? cfg.images : [];
    const hasImages = cfgImages.length > 0;

    const hasBrochure =
      Array.isArray(brochures) && brochures.length > 0 && !!brochures[0]?.url;
    const brochureUrl = hasBrochure ? brochures[0].url : null;

    const downloadFilename = `${(project.name || 'brochure').replace(/[^\w\s-]/g, '').trim() || 'brochure'}.pdf`;

    return (
      <Card sx={{ borderRadius: 3, border: `1px solid ${COLORS.border}`, boxShadow: '0 2px 10px rgba(139,74,43,0.06)' }}>
        <CardContent sx={{ p: 0.5 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
            <Typography sx={{ fontSize: '18px', fontWeight: 800, color: '#6B3620' }}>
              {getTypeLabel(cfg.bhk_type)}
            </Typography>
            <Box sx={{ bgcolor: COLORS.primaryLight, color: COLORS.primary, fontWeight: 700, fontSize: '11px', px: 1, py: 0.5, borderRadius: 1.5 }}>
              {cfg.price !== undefined ? `Starting at ${formatPrice(cfg.price)}` : 'Price on Request'}
            </Box>
          </Box>

          <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', rowGap: 1.75, columnGap: 2 }}>
            {getConfigFields(cfg).map((item) => (
              <Box key={item.label} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography sx={{ fontSize: '12px', color: COLORS.textSecondary }}>{item.label}</Typography>
                <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.textDark }}>{item.value}</Typography>
              </Box>
            ))}
          </Box>

          <Box sx={{ display: 'flex', gap: 1.5, overflowX: 'auto', mt: 1, pb: 0.5, '&::-webkit-scrollbar': { height: 4 }, '&::-webkit-scrollbar-thumb': { bgcolor: COLORS.border, borderRadius: 2 } }}>
            {(hasImages ? cfgImages : [null, null]).map((src, n) => (
              <Box
                key={n}
                onClick={() => src && openLightbox(cfgImages, n, `${getTypeLabel(cfg.bhk_type)} — Floor Plan`)}
                sx={{
                  flex: '0 0 calc(50% - 6px)', minWidth: 'calc(50% - 6px)', height: 150,
                  borderRadius: 2, overflow: 'hidden', border: `1px solid ${COLORS.border}`,
                  bgcolor: '#F5F5F5', display: 'flex', alignItems: 'center', justifyContent: 'center',
                  cursor: src ? 'zoom-in' : 'default',
                }}
              >
                {src ? (
                  <Box
                    component="img"
                    src={src}
                    alt={`${cfg.bhk_type} floor plan ${n + 1}`}
                    sx={{ width: '100%', height: '100%', objectFit: 'contain' }}
                  />
                ) : (
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75, width: '80%', height: '80%' }}>
                    <Box sx={{ display: 'flex', gap: 0.75, height: '40%' }}>
                      <Box sx={{ flex: 1, border: '1px solid #CCC', bgcolor: '#EAEAEA' }} />
                      <Box sx={{ flex: 2, border: '1px solid #CCC', bgcolor: '#EAEAEA' }} />
                    </Box>
                    <Box sx={{ display: 'flex', gap: 0.75, height: '60%' }}>
                      <Box sx={{ flex: 2, border: '1px solid #CCC', bgcolor: '#EAEAEA' }} />
                      <Box sx={{ flex: 1, border: '1px solid #CCC', bgcolor: '#EAEAEA' }} />
                    </Box>
                  </Box>
                )}
              </Box>
            ))}
          </Box>

          <Box sx={{ display: 'flex', gap: 1.5, mt: 1 }}>
            <Button
              variant="outlined"
              size="small"
              startIcon={<Download sx={{ fontSize: 16 }} />}
              onClick={() => downloadFile(brochureUrl, downloadFilename)}
              disabled={!hasBrochure}
              sx={{
                flex: 1,
                borderRadius: 2,
                color: COLORS.primaryDark,
                borderColor: COLORS.border,
                fontWeight: 700,
                fontSize: '12px',
                textTransform: 'none',
                '&:hover': {
                  borderColor: COLORS.primaryDark,
                  bgcolor: COLORS.primaryLight,
                },
                '&.Mui-disabled': {
                  color: '#BDBDBD',
                  borderColor: '#E0E0E0',
                  backgroundColor: '#F9F9F9',
                },
              }}
            >
              {hasBrochure ? 'Download' : 'No Brochure'}
            </Button>
            <Button
              variant="contained"
              size="small"
              startIcon={<Phone sx={{ fontSize: 16 }} />}
              onClick={scrollToCallback}
              sx={{ flex: 1, borderRadius: 2, bgcolor: COLORS.primaryDark, color: 'white', fontWeight: 700, fontSize: '12px', textTransform: 'none', '&:hover': { bgcolor: COLORS.primary } }}
            >
              Request Callback
            </Button>
          </Box>
        </CardContent>
      </Card>
    );
  };

  const handleContactSubmit = async () => {
    if (!userId) { alert("Please log in to request a callback."); return; }
    if (!contactForm.name || !contactForm.phone || !contactForm.email) {
      alert("Please fill in your name, phone, and email."); return;
    }

    try {
      setSubmitting(true);
      const payload = {
        user_id: Number(userId),
        property: Number(id),
        name: contactForm.name,
        phone: contactForm.phone,
        email: contactForm.email,
        preferred_time: contactForm.preferredTime,
        message: contactForm.message,
      };
      console.log("Callback request payload:", payload);

      const response = await fetch("https://landnest.net:81/request-callback/", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(payload),
      });
      const result = await response.json();
      if (!response.ok) {
        console.error("Callback API Error:", result);
        throw new Error(result?.message || result?.detail || "Failed to request callback");
      }
      alert("Callback requested successfully!");
      setContactForm((prev) => ({ ...prev, preferredTime: "morning", message: "" }));
    } catch (error) {
      console.error("Callback submission error:", error);
      alert(error.message || "Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const handleHeroScroll = (e) => {
    const el = e.currentTarget;
    const raw = Math.round(el.scrollLeft / el.clientWidth);
    const clamped = Math.max(0, Math.min(raw, heroMedia.length - 1));
    if (clamped !== heroIndex) setHeroIndex(clamped);
  };

  const scrollHeroTo = (index) => {
    const el = heroScrollRef.current;
    if (!el) return;
    el.scrollTo({ left: index * el.clientWidth, behavior: 'smooth' });
  };

  const highlightNames = d.highlights.map((h) => h.name);
  const amenityNames = d.amenities.map((a) => a.name);

  const visibleHighlights = showAllHighlights ? highlightNames : highlightNames.slice(0, 8);
  const visibleNearby = showAllNearby ? d.nearby : d.nearby.slice(0, 2);
  const visibleSimilar = showAllSimilar ? d.similar : d.similar.slice(0, 2);

  const amenityGroups = groupAmenitiesByCategory(amenityNames);
  const presentAmenityCategories = AMENITY_CATEGORIES.filter(
    (c) => amenityGroups[c]?.length > 0
  );
  if (amenityGroups["Other"]?.length) presentAmenityCategories.push("Other");

  const amenityCategoriesToShow =
    selectedAmenityCategory === 'All'
      ? presentAmenityCategories
      : presentAmenityCategories.filter((c) => c === selectedAmenityCategory);

  const heroImages = project.covers || [];
  const heroVideos = project.videos || [];
  const heroMedia = [
    ...heroImages.map((src) => ({ type: 'image', src })),
    ...heroVideos.map((src) => ({ type: 'video', src })),
  ];

  const hasMultipleMedia = heroMedia.length > 1;
  const firstVideoIndex = heroImages.length;

  const currentMedia = heroMedia[heroIndex];
  const currentThumb =
    (currentMedia?.type === 'image' && currentMedia.src) ||
    heroImages[0] || project.cover || '';

  return (
    <Box sx={{ backgroundColor: COLORS.bg, minHeight: '100vh', pb: 10, fontFamily: 'sans-serif', overflowY: 'auto' }}>

      {/* --- HERO --- */}
      <Box sx={{ position: 'relative', width: '100%', height: 320, mb: 1 }}>
        {heroMedia.length > 0 ? (
          <>
            <Box
              ref={heroScrollRef}
              onScroll={handleHeroScroll}
              sx={{
                display: 'flex', width: '100%', height: '100%',
                overflowX: 'auto', overflowY: 'hidden',
                scrollSnapType: 'x mandatory', scrollBehavior: 'smooth',
                WebkitOverflowScrolling: 'touch',
                '&::-webkit-scrollbar': { display: 'none' },
                msOverflowStyle: 'none', scrollbarWidth: 'none',
              }}
            >
              {heroMedia.map((item, i) => (
                <Box
                  key={`${item.type}-${i}`}
                  data-media-type={item.type}
                  data-media-index={i}
                  sx={{ flex: '0 0 100%', width: '100%', height: '100%', scrollSnapAlign: 'start', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#000' }}
                >
                  {item.type === 'image' ? (
                    <Box component="img" src={item.src} alt={`${project.name} ${i + 1}`} draggable={false} sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', userSelect: 'none' }} />
                  ) : (
                    <Box component="video" src={item.src} controls playsInline preload="metadata" sx={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block', bgcolor: '#000' }} />
                  )}
                </Box>
              ))}
            </Box>

            {hasMultipleMedia && (
              <Box sx={{ position: 'absolute', bottom: 44, left: '50%', transform: 'translateX(-50%)', display: 'flex', gap: '5px', px: 1, py: 0.5, borderRadius: '10px', bgcolor: 'rgba(0,0,0,0.35)', backdropFilter: 'blur(4px)', zIndex: 3 }}>
                {heroMedia.map((item, i) => (
                  <Box
                    key={i}
                    onClick={() => scrollHeroTo(i)}
                    sx={{
                      width: item.type === 'video' ? 10 : 6, height: 6,
                      borderRadius: item.type === 'video' ? '3px' : '50%',
                      cursor: 'pointer',
                      bgcolor: heroIndex === i ? '#FFFFFF' : 'rgba(255,255,255,0.5)',
                      transition: 'background 0.2s',
                    }}
                  />
                ))}
              </Box>
            )}
          </>
        ) : (
          <Box sx={{ width: '100%', height: '100%', bgcolor: '#E0E0E0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Construction sx={{ fontSize: 60, color: '#BDBDBD' }} />
          </Box>
        )}

        <IconButton
          onClick={() => navigate(-1)}
          sx={{ position: 'absolute', top: 16, left: 16, bgcolor: 'rgba(255,255,255,0.85)', color: COLORS.textDark, backdropFilter: 'blur(4px)', '&:hover': { bgcolor: 'white' }, boxShadow: 1, zIndex: 4 }}
        >
          <ArrowBack />
        </IconButton>

        <Box sx={{ position: 'absolute', bottom: 4, left: 16, right: 16, display: 'flex', gap: 1.5, overflowX: 'auto', '&::-webkit-scrollbar': { display: 'none' }, pb: 0.5, zIndex: 4 }}>
          <Chip
            icon={<HiOutlinePhoto size={16} />}
            label={media.photos ? `${media.photos} Photos` : 'Photos'}
            onClick={() => scrollHeroTo(0)}
            sx={{ bgcolor: 'rgba(61, 43, 31, 0.85)', color: 'white', fontWeight: 600, fontSize: '12px', borderRadius: 10, px: 1, backdropFilter: 'blur(4px)', cursor: 'pointer', '& .MuiChip-icon': { color: 'white' } }}
          />

          {heroVideos.length > 0 && (
            <Chip
              icon={<CgPlayButtonO size={16} />}
              label={heroVideos.length > 1 ? `${heroVideos.length} Videos` : 'Video'}
              onClick={() => scrollHeroTo(firstVideoIndex)}
              sx={{
                bgcolor: heroIndex >= firstVideoIndex ? 'rgba(139, 74, 43, 0.95)' : 'rgba(61, 43, 31, 0.85)',
                color: 'white', fontWeight: 600, fontSize: '12px', borderRadius: 10, px: 1, backdropFilter: 'blur(4px)', cursor: 'pointer', transition: 'background 0.2s',
                '& .MuiChip-icon': { color: 'white' },
              }}
            />
          )}
        </Box>
      </Box>

      {/* --- Property Header Card --- */}
      <Box sx={{ px: 2 }}>
        <Card sx={{ borderRadius: 3, p: 2, boxShadow: '0 4px 20px rgba(139,74,43,0.08)', border: `1px solid ${COLORS.border}` }}>
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
            <Box
              sx={{
                width: 80,
                height: 100,
                bgcolor: '#F5F5F5',
                borderRadius: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                overflow: 'hidden',
              }}
            >
              {project.logo || project.logoFallback ? (
                <Box
                  component="img"
                  src={project.logo || project.logoFallback}
                  alt={`${project.name} logo`}
                  onError={(e) => {
                    if (project.logoFallback && e.currentTarget.src !== project.logoFallback) {
                      e.currentTarget.src = project.logoFallback;
                    }
                  }}
                  sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              ) : (
                <Construction sx={{ fontSize: 40, color: '#D4A373' }} />
              )}
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography sx={{ fontSize: '14px', color: COLORS.primary, fontWeight: 700, mb: 0.5 }}>
                {project.builder}
              </Typography>
              <Typography sx={{ fontSize: '18px', fontWeight: 800, color: COLORS.textDark, mb: 0.5, lineHeight: 1.2 }}>
                {project.name}
              </Typography>
              <Typography sx={{ fontSize: '14px', color: COLORS.primary, fontWeight: 700, mb: 0.5 }}>
                {project.category}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1 }}>
                <LocationOn sx={{ fontSize: 14, color: COLORS.textSecondary }} />
                <Typography sx={{ fontSize: '12px', color: COLORS.textSecondary }}>
                  {project.exactlocation}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                {project.rera && (
                  <Chip label={project.rera} size="small" sx={{ bgcolor: COLORS.primaryDark, color: 'white', fontSize: '10px', fontWeight: 700, height: 22, borderRadius: 10 }} />
                )}
                {project.verified && (
                  <Chip icon={<CheckCircle sx={{ fontSize: 12 }} />} label="Verified" size="small" sx={{ bgcolor: COLORS.greenBg, color: COLORS.green, fontSize: '10px', fontWeight: 700, height: 22, borderRadius: 10, '& .MuiChip-icon': { color: COLORS.green } }} />
                )}
              </Box>
            </Box>
          </Box>

          <Divider sx={{ my: 0.5, borderColor: COLORS.border, borderStyle: 'dashed' }} />

          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <Typography sx={{ fontSize: '13px', color: '#4B5563' }}>
              <Box component="span" sx={{ fontWeight: 700, color: '#111827', mr: 0.5 }}>Possession:</Box>
              {show(project.possession)}
            </Typography>
            <Typography sx={{ fontSize: '13px', color: '#4B5563' }}>
              <Box component="span" sx={{ fontWeight: 700, color: '#111827', mr: 0.5 }}>Type:</Box>
              {show(project.propertyType)}
            </Typography>
          </Box>
        </Card>
      </Box>

      {/* --- Price & BHK Summary --- */}
      <Box sx={{ px: 2, mt: 1 }}>
        <Typography sx={{ fontSize: '28px', fontWeight: 800, color: '#6B3620', letterSpacing: '-0.5px' }}>
          {project.priceRange || 'Price on Request'}
        </Typography>
        <Typography sx={{ fontSize: '12px', color: COLORS.textSecondary, letterSpacing: '1px', fontWeight: 600 }}>
          PRICE RANGE
        </Typography>

        {(project.bhkTypes || project.propertyType) && (
          <Typography sx={{ fontSize: '20px', fontWeight: 700, color: '#6B3620' }}>
            {[isCommercial ? '' : project.bhkTypes, project.propertyType].filter(Boolean).join(' ')}
          </Typography>
        )}
      </Box>

      {/* --- Project Stats --- */}
      <Box sx={{ px: 2, mt: 1 }}>
        <Card sx={{ borderRadius: 3, p: 0.5, boxShadow: 'none', border: `1px solid ${COLORS.border}`, bgcolor: '#FAFAFA' }}>
          <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', rowGap: 2, columnGap: 2 }}>
            <Box>
              <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary, mb: 0.5 }}>STATUS</Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Construction sx={{ fontSize: 16, color: COLORS.primary }} />
                <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.primary }}>{show(project.status)}</Typography>
              </Box>
            </Box>
            <Box>
              <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary, mb: 0.5 }}>POSSESSION</Typography>
              <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.primary }}>{show(project.possession)}</Typography>
            </Box>
            {!isPlot && (
              <>
                <Box>
                  <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary, mb: 0.5 }}>TOWERS</Typography>
                  <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.primary }}>{show(project.towers)}</Typography>
                </Box>
                <Box>
                  <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary, mb: 0.5 }}>FLOORS</Typography>
                  <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.primary }}>{show(project.floors)}</Typography>
                </Box>
              </>
            )}
            <Box>
              <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary, mb: 0.5 }}>UNITS</Typography>
              <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.primary }}>{show(project.units)}</Typography>
            </Box>
            <Box>
              <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary, mb: 0.5 }}>TOTAL PROJECT AREA</Typography>
              <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.primary }}>{show(project.totalArea)}</Typography>
            </Box>
          </Box>
        </Card>
      </Box>

      {/* ================================================================
          ✅ NEW: REQUEST CALLBACK BUTTON (above Property Highlights)
          ================================================================ */}
      <Box sx={{ px: 2, mt: 1.5 }}>
        <Button
          variant="contained"
          fullWidth
          startIcon={<CallOutlined />}
          onClick={scrollToCallback}
          sx={{
            borderRadius: 3,
            bgcolor: COLORS.primaryDark,
            color: 'white',
            fontWeight: 800,
            fontSize: '14px',
            textTransform: 'none',
            py: 1.3,
            boxShadow: '0 4px 14px rgba(139,74,43,0.28)',
            '&:hover': { bgcolor: COLORS.primary, boxShadow: '0 6px 18px rgba(139,74,43,0.35)' },
          }}
        >
          Contact Us
        </Button>
      </Box>

      <Box sx={{ px: 2, mt: 1 }}>
        {/* Wishlist & Share */}
        <Box
          sx={{
            display: 'flex',
            gap: 1.5,
            mt: 1.5,
          }}
        >
          {/* Wishlist — adds to / removes from the user cart */}
          <Button
            variant="outlined"
            fullWidth
            onClick={toggleWishlist}
            disabled={wishlistBusy}
            startIcon={
              isWishlisted ? (
                <Favorite sx={{ color: '#e0432b' }} />
              ) : (
                <FavoriteBorder />
              )
            }
            sx={{
              flex: 1,
              borderColor: isWishlisted ? '#6B3620' : '#a87c51',
              backgroundColor: isWishlisted ? '#FDF8F2' : 'transparent',
              color: '#6B3620',
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 600,
              py: 1,
              '&:hover': {
                borderColor: '#6B3620',
                backgroundColor: '#FDF8F2',
              },
              '&.Mui-disabled': {
                color: '#6B3620',
                borderColor: isWishlisted ? '#6B3620' : '#a87c51',
                opacity: 0.7,
              },
            }}
          >
            {isWishlisted ? 'Wishlisted' : 'Wishlist'}
          </Button>

          {/* Share */}
          <Button
            variant="outlined"
            fullWidth
            startIcon={<Share />}
            sx={{
              flex: 1,
              borderColor: '#a87c51',
              color: '#6B3620',
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 600,
              py: 1,
              '&:hover': {
                borderColor: '#6B3620',
                backgroundColor: '#FDF8F2',
              },
            }}
          >
            Share
          </Button>
        </Box>
      </Box>

      {/* --- BHK Tabs --- */}
      {configGroups.length > 0 && (
        <Box sx={{ mt: 1, px: 1, bgcolor: 'white' }}>
          <Box sx={{ display: 'flex', gap: 1, overflowX: 'auto', '&::-webkit-scrollbar': { display: 'none' } }}>
            {configGroups.map((group, idx) => {
              const isActive = activeTab === idx;
              return (
                <Box
                  key={group.type}
                  onClick={() => selectGroup(idx)}
                  sx={{
                    flex: '1 0 auto', minWidth: 60, px: 1.5, textAlign: 'center', py: 1, borderRadius: 2,
                    border: `1px solid ${isActive ? COLORS.primaryDark : COLORS.border}`,
                    bgcolor: isActive ? COLORS.primaryDark : 'white',
                    color: isActive ? 'white' : COLORS.textDark,
                    fontWeight: 700, fontSize: '12.5px', cursor: 'pointer', userSelect: 'none',
                    whiteSpace: 'nowrap', transition: 'all 0.15s ease',
                  }}
                >
                  {getTypeLabel(group.type)}
                  {group.items.length > 1 ? ` (${group.items.length})` : ''}
                </Box>
              );
            })}
          </Box>
        </Box>
      )}

      {/* --- Floor Plans & Pricing --- */}
      <Box sx={{ p: 1 }}>
        <Typography sx={{ fontSize: '20px', fontWeight: 800, color: COLORS.textDark }}>
          Floor Plans & Pricing
        </Typography>

        {!activeGroup && <EmptyText>No configurations available for this property</EmptyText>}

        {activeGroup && (
          <Box sx={{ mb: 1 }}>
            <Box
              key={activeGroup.type}
              onScroll={handlePlanScroll}
              sx={{
                display: 'flex', gap: 1, overflowX: 'auto', scrollSnapType: 'x mandatory',
                WebkitOverflowScrolling: 'touch',
                '&::-webkit-scrollbar': { display: 'none' }, scrollbarWidth: 'none',
              }}
            >
              {activeGroup.items.map((cfg) => (
                <Box key={cfg.id} sx={{ flex: '0 0 100%', minWidth: 0, scrollSnapAlign: 'start' }}>
                  {renderConfigCard(cfg)}
                </Box>
              ))}
            </Box>

            {activeGroup.items.length > 1 && (
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mt: 1 }}>
                <Box sx={{ display: 'flex', gap: '5px' }}>
                  {activeGroup.items.map((cfg, i) => (
                    <Box key={cfg.id} sx={{ width: activeSlide === i ? 16 : 6, height: 6, borderRadius: 3, bgcolor: activeSlide === i ? COLORS.primaryDark : COLORS.border, transition: 'all 0.2s' }} />
                  ))}
                </Box>
                <Typography sx={{ fontSize: '11px', color: COLORS.textSecondary }}>
                  {activeSlide + 1} / {activeGroup.items.length} · swipe →
                </Typography>
              </Box>
            )}
          </Box>
        )}

        {configGroups.map((group, idx) => {
          if (idx === activeTab) return null;
          const minPrice = groupMinPrice(group);
          return (
            <Paper
              key={group.type}
              onClick={() => selectGroup(idx)}
              sx={{
                display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 1, mb: 0.5,
                borderRadius: 3, cursor: 'pointer', border: `1px solid ${COLORS.border}`,
                boxShadow: 'none', bgcolor: 'white', '&:hover': { bgcolor: '#FAFAFA' },
              }}
            >
              <Typography sx={{ fontSize: '15px', fontWeight: 700, color: COLORS.textDark }}>
                {getTypeLabel(group.type)}
                {group.items.length > 1 ? ` (${group.items.length})` : ''}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography sx={{ fontSize: '13px', fontWeight: 600, color: COLORS.primary }}>
                  {minPrice !== undefined ? `Starting at ${formatPrice(minPrice)}` : 'Price on Request'}
                </Typography>
                <ChevronRight sx={{ color: COLORS.textSecondary, fontSize: 20 }} />
              </Box>
            </Paper>
          );
        })}
      </Box>

      {/* --- HIGHLIGHTS --- */}
      <Box sx={{ px: 0.5 }}>
        <Divider sx={{ borderColor: COLORS.border, mb: 0.5 }} />
        <Card sx={{ borderRadius: 3, boxShadow: '0 2px 10px rgba(139,74,43,0.06)', border: `1px solid ${COLORS.border}` }}>
          <CardContent sx={{ p: 0.5 }}>
            <SectionHeaderWithViewAll
              title="Property Highlights"
              onViewAll={highlightNames.length > 8 ? () => setShowAllHighlights(!showAllHighlights) : null}
              expanded={showAllHighlights}
            />
            <IconGrid items={visibleHighlights} emptyText="No highlights available for this property" />
          </CardContent>
        </Card>
      </Box>

      {/* --- AMENITIES --- */}
      <Box sx={{ px: 0.5 }}>
        <Card sx={{ borderRadius: 3, boxShadow: '0 2px 10px rgba(139,74,43,0.06)', border: `1px solid ${COLORS.border}` }}>
          <CardContent sx={{ p: 0.5 }}>
            <Typography variant="subtitle1" fontWeight="bold" sx={{ color: COLORS.textDark }}>
              Amenities
            </Typography>

            {amenityNames.length === 0 ? (
              <EmptyText>No amenities listed for this property</EmptyText>
            ) : (
              <>
                <Box
                  sx={{
                    mb: 2, mt: 1, overflowX: 'auto', whiteSpace: 'nowrap',
                    borderBottom: `1px solid ${COLORS.border}`,
                    '&::-webkit-scrollbar': { display: 'none' },
                  }}
                >
                  <Box sx={{ display: 'inline-flex' }}>
                    {['All', ...presentAmenityCategories].map((cat) => {
                      const isActive = selectedAmenityCategory === cat;
                      const count =
                        cat === 'All'
                          ? amenityNames.length
                          : amenityGroups[cat]?.length || 0;
                      return (
                        <Box
                          key={cat}
                          onClick={() => setSelectedAmenityCategory(cat)}
                          sx={{
                            px: 1.5, py: 1, cursor: 'pointer', flexShrink: 0,
                            borderBottom: isActive
                              ? `2px solid ${COLORS.primaryDark}`
                              : '2px solid transparent',
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: '13px',
                              fontWeight: isActive ? 700 : 500,
                              color: isActive ? COLORS.primaryDark : COLORS.textSecondary,
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {cat} ({count})
                          </Typography>
                        </Box>
                      );
                    })}
                  </Box>
                </Box>

                {amenityCategoriesToShow.map((cat) => (
                  <Box key={cat} sx={{ mb: 2 }}>
                    <Typography sx={{ fontSize: '13px', fontWeight: 700, color: COLORS.textDark, mb: 1 }}>
                      {cat}
                    </Typography>
                    <IconGrid items={amenityGroups[cat]} />
                  </Box>
                ))}
              </>
            )}
          </CardContent>
        </Card>
      </Box>

      {/* --- SPECIFICATIONS --- */}
      <Box sx={{ px: 0.5 }}>
        <Card sx={{ borderRadius: 3, border: `1px solid ${COLORS.border}`, boxShadow: '0 2px 10px rgba(139,74,43,0.06)' }}>
          <CardContent sx={{ p: 0.5 }}>
            <Typography variant="subtitle1" fontWeight="bold" sx={{ color: COLORS.textDark }}>
              Specifications
            </Typography>
            {d.specifications.length === 0 && <EmptyText>No specifications listed for this property</EmptyText>}
            {d.specifications.map((spec, idx, arr) => {
              const IconComp = resolveIcon(spec.name);
              return (
                <Box
                  key={`${spec.name}-${idx}`}
                  sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 0.5, borderBottom: idx < arr.length - 1 ? `1px solid ${COLORS.border}` : 'none' }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <IconComp sx={{ fontSize: 20, color: COLORS.primary }} />
                    <Box>
                      <Typography variant="body2" fontWeight={600} sx={{ color: COLORS.textDark }}>{spec.name}</Typography>
                      <Typography variant="caption" sx={{ color: COLORS.textSecondary }}>{spec.value}</Typography>
                    </Box>
                  </Box>
                </Box>
              );
            })}
          </CardContent>
        </Card>
      </Box>

      {/* --- LOCATION --- */}
      <Box sx={{ px: 0.5, mb: 1 }}>
        <Card sx={{ borderRadius: 3, border: `1px solid ${COLORS.border}`, boxShadow: '0 2px 10px rgba(139,74,43,0.06)' }}>
          <CardContent sx={{ p: 0.5 }}>
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1, color: COLORS.textDark }}>
              Location Advantages
            </Typography>

            {d.locationAdvantages.length === 0 && <EmptyText>No location details available</EmptyText>}
            {d.locationAdvantages.map((item, index, arr) => {
              const IconComp = resolveIcon(item.place_name);
              return (
                <Box
                  key={`${item.place_name}-${index}`}
                  sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1.5, borderBottom: index < arr.length - 1 ? `1px solid ${COLORS.border}` : 'none' }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <IconComp sx={{ fontSize: 20, color: COLORS.primary }} />
                    <Box>
                      <Typography variant="body2" sx={{ color: COLORS.textDark, fontSize: 14, fontWeight: 600 }}>{item.place_name}</Typography>
                      <Typography variant="caption" sx={{ color: COLORS.textSecondary }}>{item.distance}</Typography>
                    </Box>
                  </Box>
                  <Typography sx={{ color: COLORS.blue, fontWeight: 600 }}>{item.travel_time}</Typography>
                </Box>
              );
            })}

            <Box sx={{ mt: 2 }}>
              <Button
                variant="outlined" fullWidth startIcon={<Map />}
                onClick={openGoogleMaps}
                disabled={!project.location && (project.lat === undefined || project.lng === undefined)}
                sx={{ borderRadius: 6, color: COLORS.primary, borderColor: COLORS.primary, fontWeight: 700, py: 1, '&:hover': { borderColor: COLORS.primaryDark, bgcolor: COLORS.primaryLight } }}
              >
                View on Google Maps
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>

      {/* --- ABOUT --- */}
      {project.description && (
        <Box sx={{ px: 0.5, mb: 1 }}>
          <Card sx={{ borderRadius: 3, border: `1px solid ${COLORS.border}`, boxShadow: '0 2px 10px rgba(139,74,43,0.06)' }}>
            <CardContent sx={{ p: 0.5 }}>
              <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1, color: COLORS.textDark }}>
                About the Project
              </Typography>
              <Typography sx={{ fontSize: '13px', color: COLORS.textSecondary, lineHeight: 1.6, whiteSpace: 'pre-line' }}>
                {project.description}
              </Typography>
            </CardContent>
          </Card>
        </Box>
      )}

      {/* --- REQUEST CALLBACK FORM --- */}
      {/* --- REQUEST CALLBACK --- */}
      <Box id="bhk-request-callback" sx={{ px: 0.5 }}>
        {!showCallbackForm ? (
          <Button
            variant="contained"
            fullWidth
            startIcon={<CallOutlined />}
            onClick={scrollToCallback}
            sx={{
              borderRadius: 3,
              bgcolor: COLORS.primaryDark,
              color: 'white',
              fontWeight: 800,
              fontSize: '14px',
              textTransform: 'none',
              py: 1.3,
              boxShadow: '0 4px 14px rgba(139,74,43,0.28)',
              '&:hover': {
                bgcolor: COLORS.primary,
                boxShadow: '0 6px 18px rgba(139,74,43,0.35)',
              },
            }}
          >
            Request Callback
          </Button>
        ) : (
          <Card
            sx={{
              borderRadius: 3,
              border: `1px solid ${COLORS.border}`,
              boxShadow: '0 2px 10px rgba(139,74,43,0.06)',
            }}
          >
            <CardContent sx={{ p: 1 }}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  mb: 1,
                }}
              >
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  sx={{ color: COLORS.textDark }}
                >
                  Request Callback
                </Typography>

                <IconButton
                  size="small"
                  onClick={() => setShowCallbackForm(false)}
                  sx={{ color: COLORS.textSecondary }}
                >
                  <Close fontSize="small" />
                </IconButton>
              </Box>

              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                {/* Name */}
                <Box>
                  <Typography
                    variant="caption"
                    sx={{
                      color: COLORS.textSecondary,
                      fontWeight: 600,
                    }}
                  >
                    Name
                  </Typography>

                  <TextField
                    placeholder="Your full name"
                    fullWidth
                    size="small"
                    value={contactForm.name}
                    onChange={(e) =>
                      setContactForm({
                        ...contactForm,
                        name: e.target.value,
                      })
                    }
                    sx={{
                      mt: 0.5,
                      '& .MuiOutlinedInput-root': {
                        bgcolor: COLORS.inputBg,
                        borderRadius: 2,
                        '& fieldset': {
                          borderColor: COLORS.border,
                        },
                      },
                    }}
                  />
                </Box>

                {/* Phone */}
                <Box>
                  <Typography
                    variant="caption"
                    sx={{
                      color: COLORS.textSecondary,
                      fontWeight: 600,
                    }}
                  >
                    Phone
                  </Typography>

                  <TextField
                    placeholder="+91 88765 43210"
                    fullWidth
                    size="small"
                    value={contactForm.phone}
                    onChange={(e) =>
                      setContactForm({
                        ...contactForm,
                        phone: e.target.value,
                      })
                    }
                    sx={{
                      mt: 0.5,
                      '& .MuiOutlinedInput-root': {
                        bgcolor: COLORS.inputBg,
                        borderRadius: 2,
                        '& fieldset': {
                          borderColor: COLORS.border,
                        },
                      },
                    }}
                  />
                </Box>

                {/* Email */}
                <Box>
                  <Typography
                    variant="caption"
                    sx={{
                      color: COLORS.textSecondary,
                      fontWeight: 600,
                    }}
                  >
                    Email
                  </Typography>

                  <TextField
                    placeholder="you@example.com"
                    fullWidth
                    size="small"
                    value={contactForm.email}
                    onChange={(e) =>
                      setContactForm({
                        ...contactForm,
                        email: e.target.value,
                      })
                    }
                    sx={{
                      mt: 0.5,
                      '& .MuiOutlinedInput-root': {
                        bgcolor: COLORS.inputBg,
                        borderRadius: 2,
                        '& fieldset': {
                          borderColor: COLORS.border,
                        },
                      },
                    }}
                  />
                </Box>

                {/* Preferred Time */}
                <Box>
                  <Typography
                    variant="caption"
                    sx={{
                      color: COLORS.textSecondary,
                      fontWeight: 600,
                    }}
                  >
                    Preferred Time
                  </Typography>

                  <TextField
                    select
                    fullWidth
                    size="small"
                    value={contactForm.preferredTime}
                    onChange={(e) =>
                      setContactForm((prev) => ({
                        ...prev,
                        preferredTime: e.target.value,
                      }))
                    }
                    sx={{
                      mt: 0.5,
                      '& .MuiOutlinedInput-root': {
                        bgcolor: COLORS.inputBg,
                        borderRadius: 2,
                        '& fieldset': {
                          borderColor: COLORS.border,
                        },
                      },
                    }}
                  >
                    <MenuItem value="morning">
                      Morning (9-12)
                    </MenuItem>

                    <MenuItem value="afternoon">
                      Afternoon (12-3)
                    </MenuItem>

                    <MenuItem value="evening">
                      Evening (3-6)
                    </MenuItem>
                  </TextField>
                </Box>

                {/* Message */}
                <Box>
                  <Typography
                    variant="caption"
                    sx={{
                      color: COLORS.textSecondary,
                      fontWeight: 600,
                    }}
                  >
                    Message
                  </Typography>

                  <TextField
                    placeholder="Type your message..."
                    multiline
                    rows={3}
                    fullWidth
                    value={contactForm.message}
                    onChange={(e) =>
                      setContactForm({
                        ...contactForm,
                        message: e.target.value,
                      })
                    }
                    sx={{
                      mt: 0.5,
                      '& .MuiOutlinedInput-root': {
                        bgcolor: COLORS.inputBg,
                        borderRadius: 2,
                        '& fieldset': {
                          borderColor: COLORS.border,
                        },
                      },
                    }}
                  />
                </Box>
              </Box>

              {/* Submit Button */}
              <Button
                variant="contained"
                fullWidth
                startIcon={<Phone />}
                onClick={handleContactSubmit}
                disabled={submitting || userLoading}
                sx={{
                  mt: 1.5,
                  borderRadius: 2,
                  bgcolor: COLORS.primary,
                  py: 1.1,
                  fontWeight: 700,
                  textTransform: 'none',
                  '&:hover': {
                    bgcolor: COLORS.primaryDark,
                  },
                }}
              >
                {submitting ? 'Submitting...' : 'Submit'}
              </Button>
            </CardContent>
          </Card>
        )}
      </Box>

      {/* ===== SELLER CARD ===== */}
      <Box sx={{ px: 0.5, mb: 1 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1,
            bgcolor: '#FFFFFF',
            border: '1px solid #EEE',
            borderRadius: '12px',
            px: 1.5,
            py: 1.2,
            boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
          }}
        >
          {/* Seller Information */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1.2,
              minWidth: 0,
            }}
          >
            {/* Profile Circle */}
            <Box
              sx={{
                width: 44,
                height: 44,
                borderRadius: '50%',
                bgcolor: '#a87c51',
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                fontWeight: 700,
                fontSize: '1rem',
                overflow: 'hidden',
              }}
            >
              {project.sellerName ? (
                project.sellerName.charAt(0).toUpperCase()
              ) : (
                <PersonIcon sx={{ fontSize: 24 }} />
              )}
            </Box>

            {/* Seller Details */}
            <Box sx={{ minWidth: 0 }}>
              <Typography
                sx={{
                  fontSize: '0.72rem',
                  color: '#888',
                  lineHeight: 1.2,
                  fontWeight: 500,
                }}
              >
                Posted {formatDate(project.createdAt)} by
              </Typography>

              <Typography
                sx={{
                  fontSize: '0.95rem',
                  fontWeight: 700,
                  color: '#222',
                  lineHeight: 1.25,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: 180,
                }}
              >
                {project.sellerName || 'Property Owner'}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* ===== ACTION BUTTONS ===== */}
      <Box
        sx={{
          px: 0.5,
          mb: 1,
          display: 'flex',
          justifyContent: 'space-between',
          gap: 1,
        }}
      >
        {/* View Number */}
        <Box
          onClick={handleViewNumber}
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1,
            bgcolor: '#FDF8F2',
            border: '1px solid #a87c51',
            borderRadius: '8px',
            px: 1,
            py: 1.2,
            cursor: 'pointer',
            transition: 'all 0.2s',
            '&:hover': {
              bgcolor: '#F5ECE0',
            },
          }}
        >
          <Phone
            sx={{
              color: '#6B3620',
              fontSize: 22,
            }}
          />

          <Typography
            sx={{
              fontSize: '0.8rem',
              fontWeight: 700,
              color: '#6B3620',
            }}
          >
            View Number
          </Typography>
        </Box>

        {/* View Location */}
        <Box
          onClick={handleViewMap}
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1,
            bgcolor: '#FDF8F2',
            border: '1px solid #a87c51',
            borderRadius: '8px',
            px: 1,
            py: 1.2,
            cursor: 'pointer',
            transition: 'all 0.2s',
            '&:hover': {
              bgcolor: '#F5ECE0',
            },
          }}
        >
          <LocationOn
            sx={{
              color: '#6B3620',
              fontSize: 22,
            }}
          />

          <Typography
            sx={{
              fontSize: '0.8rem',
              fontWeight: 700,
              color: '#6B3620',
            }}
          >
            View on Map
          </Typography>
        </Box>
      </Box>

      {/* --- NEARBY / SIMILAR --- */}
      {(d.nearby.length > 0 || d.similar.length > 0) && (
        <Box sx={{ px: 2, mb: 1 }}>
          {d.nearby.length > 0 && (
            <>
              <SectionHeaderWithViewAll
                title="Nearby Projects"
                onViewAll={d.nearby.length > 2 ? () => setShowAllNearby(!showAllNearby) : null}
                expanded={showAllNearby}
              />
              <Grid container spacing={1.5}>
                {visibleNearby.map((proj) => (
                  <Grid item xs={6} key={proj.id}>
                    <ProjectCard proj={proj} />
                  </Grid>
                ))}
              </Grid>
            </>
          )}

          {d.similar.length > 0 && (
            <>
              <Box sx={{ mt: 1 }}>
                <SectionHeaderWithViewAll
                  title="Similar Projects"
                  onViewAll={d.similar.length > 2 ? () => setShowAllSimilar(!showAllSimilar) : null}
                  expanded={showAllSimilar}
                />
              </Box>
              <Grid container spacing={1.5}>
                {visibleSimilar.map((proj) => (
                  <Grid item xs={6} key={proj.id}>
                    <ProjectCard proj={proj} />
                  </Grid>
                ))}
              </Grid>
            </>
          )}
        </Box>
      )}

      {/* ================================================================
          ✅ FLOOR PLAN / FLOORING IMAGE LIGHTBOX MODAL
          ================================================================ */}
      <Dialog
        open={lightboxOpen}
        onClose={() => setLightboxOpen(false)}
        maxWidth={false}
        fullWidth
        PaperProps={{
          sx: {
            bgcolor: 'transparent',
            boxShadow: 'none',
            m: 0,
            maxWidth: '100vw',
            width: '100vw',
            height: '100vh',
            overflow: 'hidden',
          },
        }}
        slotProps={{
          backdrop: { sx: { bgcolor: 'rgba(0,0,0,0.92)' } },
        }}
      >
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            p: { xs: 1, sm: 3 },
          }}
        >
          {/* Close button */}
          <IconButton
            onClick={() => setLightboxOpen(false)}
            sx={{
              position: 'absolute',
              top: 12, right: 12,
              color: 'white',
              bgcolor: 'rgba(255,255,255,0.15)',
              '&:hover': { bgcolor: 'rgba(255,255,255,0.3)' },
              zIndex: 10,
            }}
          >
            <Close />
          </IconButton>

          {/* Title / counter */}
          {lightboxTitle && (
            <Typography
              sx={{
                color: 'white',
                fontWeight: 700,
                fontSize: { xs: '13px', sm: '15px' },
                mb: 1,
                px: 6,
                textAlign: 'center',
              }}
            >
              {lightboxTitle}
              {lightboxImages.length > 1 && (
                <Box component="span" sx={{ opacity: 0.7, ml: 1, fontWeight: 500 }}>
                  ({lightboxIndex + 1}/{lightboxImages.length})
                </Box>
              )}
            </Typography>
          )}

          {/* Main image */}
          {lightboxImages[lightboxIndex] && (
            <Box
              component="img"
              src={lightboxImages[lightboxIndex]}
              alt={`${lightboxTitle} ${lightboxIndex + 1}`}
              sx={{
                maxWidth: '100%',
                maxHeight: 'calc(100vh - 160px)',
                objectFit: 'contain',
                borderRadius: 1,
                userSelect: 'none',
              }}
            />
          )}

          {/* Prev / Next arrows */}
          {lightboxImages.length > 1 && (
            <>
              <IconButton
                onClick={() =>
                  setLightboxIndex((i) => (i - 1 + lightboxImages.length) % lightboxImages.length)
                }
                sx={{
                  position: 'absolute',
                  left: { xs: 4, sm: 16 },
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: 'white',
                  bgcolor: 'rgba(255,255,255,0.15)',
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.3)' },
                }}
              >
                <ChevronRight sx={{ transform: 'rotate(180deg)', fontSize: 32 }} />
              </IconButton>
              <IconButton
                onClick={() => setLightboxIndex((i) => (i + 1) % lightboxImages.length)}
                sx={{
                  position: 'absolute',
                  right: { xs: 4, sm: 16 },
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: 'white',
                  bgcolor: 'rgba(255,255,255,0.15)',
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.3)' },
                }}
              >
                <ChevronRight sx={{ fontSize: 32 }} />
              </IconButton>

              {/* Thumbnails */}
              <Box
                sx={{
                  position: 'absolute',
                  bottom: 16,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  display: 'flex',
                  gap: 1,
                  p: 0.75,
                  borderRadius: 2,
                  bgcolor: 'rgba(0,0,0,0.5)',
                  backdropFilter: 'blur(6px)',
                  maxWidth: '90vw',
                  overflowX: 'auto',
                  '&::-webkit-scrollbar': { display: 'none' },
                }}
              >
                {lightboxImages.map((src, i) => (
                  <Box
                    key={i}
                    onClick={() => setLightboxIndex(i)}
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: 1,
                      overflow: 'hidden',
                      cursor: 'pointer',
                      flexShrink: 0,
                      border:
                        i === lightboxIndex
                          ? '2px solid white'
                          : '2px solid transparent',
                      opacity: i === lightboxIndex ? 1 : 0.6,
                      transition: 'opacity 0.2s, border-color 0.2s',
                      '&:hover': { opacity: 1 },
                    }}
                  >
                    <Box
                      component="img"
                      src={src}
                      alt={`thumb ${i + 1}`}
                      sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                  </Box>
                ))}
              </Box>
            </>
          )}
        </Box>
      </Dialog>

      {/* --- NEW CUSTOM MODALS --- */}
      <PhoneModal 
        open={showPhoneModal} 
        onClose={() => setShowPhoneModal(false)} 
        ownerName={project.sellerName} 
        mobileNo={project.sellerMobile} 
      />

      <MapModal 
        open={showMapModal} 
        onClose={() => setShowMapModal(false)} 
        onOpenMap={openGoogleMaps} 
      />

      <Box
        sx={{
          px: 1,
          mt: 1,

          display: 'flex',
          justifyContent: 'right',
          alignItems: 'right',
        }}
      >
        <Typography
          sx={{
            fontSize: '12px',
            color: COLORS.textSecondary,
            fontWeight: 600,
            letterSpacing: '0.5px',
          }}
        >
          Property ID:&nbsp;
          <Box
            component="span"
            sx={{
              fontWeight: 800,
              color: COLORS.primaryDark,
            }}
          >
            {project.propertyId ?? '—'}
          </Box>
        </Typography>
      </Box>

    </Box>
  );
};

export default BHKDescription;